// @ts-nocheck
import $ from 'jquery';
import DateFormat from 'dateformat';
import { Environment } from 'ag-grid-community';
import PlugSolid from '../images/PlugSolid.svg';
import UnPlug from '../images/Unplug.svg';
import HighALM from '../images/Status/Alarms/HighALM.png';
import RSSI4 from '../images/RSSI/RSSI_4.png';
import failed from '../images/failed.png';
import HighCC from '../images/Status/Alarms/HighCC.png';
import NotRunning from '../images/NotRunning.png';
import Running from '../images/Running.png';
import bulletcommand from '../images/bullet_command.png';
import batterycritical from '../images/battery-critical.svg';
import batterylow from '../images/battery-low.svg';
import batterynormal from '../images/battery-normal.svg';
import BatteryIndicator from '../images/BatteryIndicator.svg';
import DualColorBattery from '../images/DualColorBattery.svg';
import ImgPending1 from '../images/Img_Pending1.png';
import ImgWarning1 from '../images/Img_Warning1.png';
import ImgSuccess1 from '../images/Img_Success1.png';
import RSSIUNK from '../images/RSSI/RSSI_UNK.png';
import RSSI1 from '../images/RSSI/RSSI_1.png';
import RSSI2 from '../images/RSSI/RSSI_2.png';
import RSSI3 from '../images/RSSI/RSSI_3.png';
import RSSI5 from '../images/RSSI/RSSI_5.png';
import GroupChat from '../images/GroupChat.png';
import High from '../images/Status/High.png';
import Medium from '../images/Status/Medium.png';
import Low from '../images/Status/Low.png';
import AssetStateActive from '../images/AssetState/ActiveRA.svg';
import AssetStateDisconnected from '../images/AssetState/DisconnectedRA.png';
import AssetStateRetired from '../images/AssetState/RetiredRA.svg';
import TripInprogress from '../images/Status/RouteDeviation/TripInprogress.png';
import TripCompletedDeviation from '../images/Status/RouteDeviation/TripCompletedDeviation.png';
import TripCompleted from '../images/Status/RouteDeviation/TripCompleted.png';
import TripProblemetic from '../images/Status//RouteDeviation/TripProblemetic.png';
import TripPending from '../images/Status/RouteDeviation/TripPending.png';
import TripDeleted from '../images/Status/RouteDeviation/TripDeleted.png';
import TripCancelDeviation from '../images/Status/RouteDeviation/TripCancelDeviation.png';
import TripCancel from '../images/Status/RouteDeviation/TripCancel.png';
import MediumALM from '../images/Status/Alarms/MediumALM.png';
import UnknownStatus from '../images/Status/UnknownStatus.png';
import ErrorStatus from '../images/Status/ErrorStatus.png';
import PendingStatus from '../images/Status/PendingStatus.png';
import IssuedStatus from '../images/Status/IssuedStatus.png';
import ExpiredStatus from '../images/Status/ExpiredStatus.png';
import CancelStatus from '../images/Status/CancelStatus.png';
import SucessStatus from '../images/Status/SucessStatus.png';
import AcceptedStatus from '../images/Status/AcceptedStatus.png';
import RejectedStatus from '../images/Status/RejectedStatus.png';
import DiscardedStatus from '../images/Status/DiscardedStatus.png';
import RetryStatus from '../images/Status/RetryStatus.png';
import AcceptedByBusyRCDStatus from '../images/Status/AcceptedByBusyRCDStatus.png';
import AwaitingPrerequisites from '../images/Status/AwaitingPrerequisites.png';
import CancellationRequest from '../images/Status/CancellationRequest.png';
import SendToVC from '../images/Status/SendToVC.png';
import ValidationPendingStatus from '../images/Status/ValidationPendingStatus.png';
import UndeliverableStatus from '../images/Status/UndeliverableStatus.png';
import Yes from '../images/Status/Yes.png';
import No from '../images/Status/No.png';
import NormalCC from '../images/Status/Alarms/NormalCC.png';
import MediumCC from '../images/Status/Alarms/MediumCC.png';
import LowCC from '../images/Status/Alarms/LowCC.png';
import passed from '../images/passed.png';
import aborted from '../images/aborted.png';
import runningtime from '../images/running-time.png';
import Skipped from '../images/Skipped.png';
import questionMark from '../images/questionMark.png';
import { Switch } from 'react-router';

const formatters = {
    dateTypeFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value !='-NA-') {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.value.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else if (params.data != null && params.data != "null" && params.data != undefined && params.data != '') {
            return '-NA-'
        }
        else
            return '';
    },
    dateTypeSorting: (param) => {
        if (param != null && param != undefined && param != "null") {
            return param;
        }
        else
            return '-NA-';
    }, 
    dateTypeSortingFieldName: (params, FieldName) => {
        if (params != null && params != undefined) {
            if (params.data != undefined && params.data != null) {

                switch (FieldName) {
                    case 'EventDTTM':
                        return params.data.EventDTTM != null && params.data.EventDTTM != "" && params.data.EventDTTM != "null" ?params.data.EventDTTM:'-NA-';
                    case 'UnitEventDTTM':
                        return params.data.UnitEventDTTM != null && params.data.UnitEventDTTM != "" && params.data.UnitEventDTTM != "null" ? params.data.UnitEventDTTM : '-NA-';
                    case 'PTRDateTime':
                        return params.data.PTRDateTime != null && params.data.PTRDateTime != "" && params.data.PTRDateTime != "null" ? params.data.PTRDateTime : '-NA-';
                    case 'DataLoggerDtm':
                        return params.data.DataLoggerDtm != null && params.data.DataLoggerDtm != "" && params.data.DataLoggerDtm != "null" ? params.data.DataLoggerDtm : '-NA-';
                    case 'ModifiedDTTM':
                        return params.data.ModifiedDTTM != null && params.data.ModifiedDTTM != "" && params.data.ModifiedDTTM != "null" ? params.data.ModifiedDTTM : '-NA-';
                    case 'DeviceDataTime':
                        return params.data.DeviceDataTime != null && params.data.DeviceDataTime != "" && params.data.DeviceDataTime != "null" ? params.data.DeviceDataTime : '-NA-';
                    case 'R_EventDTTM':
                        return params.data.R_EventDTTM != null && params.data.R_EventDTTM != "" && params.data.R_EventDTTM != "null" ? params.data.R_EventDTTM : '-NA-';
                    case 'R_ModifiedDTTM':
                        return params.data.R_ModifiedDTTM != null && params.data.R_ModifiedDTTM != "" && params.data.R_ModifiedDTTM != "null" ? params.data.R_ModifiedDTTM : '-NA-';
                    case 'CreatedDTTM':
                        return params.data.CreatedDTTM != null && params.data.CreatedDTTM != "" && params.data.CreatedDTTM != "null" ? params.data.CreatedDTTM : '-NA-';
                    case 'CreateDTTM':
                        return params.data.CreateDTTM != null && params.data.CreateDTTM != "" && params.data.CreateDTTM != "null" ? params.data.CreateDTTM : '-NA-';
                    case 'StatusDate':
                        return params.data.StatusDate != null && params.data.StatusDate != "" && params.data.StatusDate != "null" ? params.data.StatusDate : '-NA-';
                    case 'SubmittedOn':
                        return params.data.SubmittedOn != null && params.data.SubmittedOn != "" && params.data.SubmittedOn != "null" ? params.data.SubmittedOn : '-NA-';
                    case 'EndDate':
                        return params.data.EndDate != null && params.data.EndDate != "" && params.data.EndDate != "null" ? params.data.EndDate : '-NA-';
                    case 'scheduledCreatedDTTM':
                        return params.data.scheduledCreatedDTTM != null && params.data.scheduledCreatedDTTM != "" && params.data.scheduledCreatedDTTM != "null" ? params.data.scheduledCreatedDTTM : '-NA-';
                    case 'StartDate':
                        return params.data.StartDate != null && params.data.StartDate != "" && params.data.StartDate != "null" ? params.data.StartDate : '-NA-';
                    case 'LastPreTripDTTM':
                        return params.data.LastPreTripDTTM != null && params.data.LastPreTripDTTM != "" && params.data.LastPreTripDTTM != "null" ? params.data.LastPreTripDTTM : '-NA-';
                    case 'TTL':
                        return params.data.TTL != null && params.data.TTL != "" && params.data.TTL != "null" ? params.data.TTL : '-NA-';
                    case 'GPSDTTM':
                        return params.data.GPSDTTM != null && params.data.GPSDTTM != "" && params.data.GPSDTTM != "null" ? params.data.GPSDTTM : '-NA-';
                    case 'ExpirationTime':
                        return params.data.ExpirationTime != null && params.data.ExpirationTime != "" && params.data.ExpirationTime != "null" ? params.data.ExpirationTime : '-NA-';
                    case 'EarliestDepartureDtm':
                        return params.data.EarliestDepartureDtm != null && params.data.EarliestDepartureDtm != "" && params.data.EarliestDepartureDtm != "null" ? params.data.EarliestDepartureDtm : '-NA-';
                    case 'ArrivalDtm':
                        return params.data.ArrivalDtm != null && params.data.ArrivalDtm != "" && params.data.ArrivalDtm != "null" ? params.data.ArrivalDtm : '-NA-';
                    case 'TWTime':
                        return params.data.TWTime != null && params.data.TWTime != "" && params.data.TWTime != "null" ? params.data.TWTime : '-NA-';
                    case 'DLEventDTTM':
                        return params.data.DLEventDTTM != null && params.data.DLEventDTTM != "" && params.data.DLEventDTTM != "null" ? params.data.DLEventDTTM : '-NA-';
                    case 'DoorEventDtm':
                        return params.data.DoorEventDtm != null && params.data.DoorEventDtm != "" && params.data.DoorEventDtm != "null" ? params.data.DoorEventDtm : '-NA-';
                    case 'Door1EventDttm':
                        return params.data.Door1EventDttm != null && params.data.Door1EventDttm != "" && params.data.Door1EventDttm != "null" ? params.data.Door1EventDttm : '-NA-';
                    case 'InsertedDttm':
                        return params.data.InsertedDttm != null && params.data.InsertedDttm != "" && params.data.InsertedDttm != "null" ? params.data.InsertedDttm : '-NA-';
                    case 'UpdatedDttm':
                        return params.data.UpdatedDttm != null && params.data.UpdatedDttm != "" && params.data.UpdatedDttm != "null" ? params.data.UpdatedDttm : '-NA-';

                    case 'TripStart':
                        return params.data.TripStart != null && params.data.TripStart != "" && params.data.TripStart != "null" ? params.data.TripStart : '-NA-';
                    case 'TripEnd':
                        return params.data.TripEnd != null && params.data.TripEnd != "" && params.data.TripEnd != "null" ? params.data.TripEnd : '-NA-';
                    case 'CTTime':
                        return params.data.CTTime != null && params.data.CTTime != "" && params.data.CTTime != "null" ? params.data.CTTime : '-NA-';
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    }, 
    dateTypeFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
    },
    dateTypeGrouping: (param, fieldName,Data) => {
        if (param != null && param != undefined && param != '-NA-') {
            //var colDef = Data.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
            //var columnDisplayName = colDef[0].colDef.headerName;
            var columnDisplayName = Data.node.rowGroupColumn.colDef.headerName;//WI-26892
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        return "*No " + columnDisplayName;
    },
    dateTypeFormatterDeviceDataTimeForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.DeviceDataTime != null && param.data.DeviceDataTime != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.DeviceDataTime.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterEventDTTMForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.EventDTTM != null && param.data.EventDTTM != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.EventDTTM.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterTripStartForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.TripStart != null && param.data.TripStart != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.TripStart.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterTripEndForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.TripEnd != null && param.data.TripEnd != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.TripEnd.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterDoorEventDtmForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.DoorEventDtm != null && param.data.DoorEventDtm != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.DoorEventDtm.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterCTTimeForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.CTTime != null && param.data.CTTime != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.CTTime.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterR_EventDTTMForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.R_EventDTTM.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterR_ModifiedDTTMForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.R_ModifiedDTTM.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterModifiedDTTMForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.ModifiedDTTM != null && param.data.ModifiedDTTM != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.ModifiedDTTM.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterCreatedDTTMForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.CreatedDTTM != null && param.data.CreatedDTTM != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.CreatedDTTM.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterPTRDateTimeForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.PTRDateTime.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterTWTimeForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.TWTime.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterUnitEventDTTMForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.UnitEventDTTM != null && param.data.UnitEventDTTM != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.UnitEventDTTM.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterDLEventDTTMForFilter: (param) => {
        if (param != null && param != undefined && param.data != null && param.data != undefined && param.data.DLEventDTTM != null && param.data.DLEventDTTM != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(param.data.DLEventDTTM.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterforExcel: (params) => {
        if (params != null && params != undefined && params != '-NA-') {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return '\t' + DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatterforCopy: (params) => {
        if (params != null && params != undefined && params != '-NA-') {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    dateTypeFormatter12H: (params) => {
        if (params.value != null && params.value != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.value.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy hh:MM TT');
        }
        else
            return '-NA-';
    },
   
   
    
    GensetSwitchFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param == "1")
                return '<div class="poweronbgGrouping"><div class="fa fa-power-off power-icon"></div></div>' + " " + '<div class="aggridOnOff">ON</div>';
            else if (param == "0")
                return '<div class="poweroffbgGrouping"><div class="fa fa-power-off power-icon"></div></div>' + " " + '<div class="aggridOnOff">OFF</div>';
            //else
            //    return "-NA-";
        }
        return "*No SW"
    },
    GensetSwitchFormatterGroupingExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == "1")
                return 'ON';
            else if (param == "0")
                return 'OFF';
            //else
            //    return "-NA-";
        }
        return "*No SW"
    },
    //gensetSwitchFormatter: (params) => {
    //    if (params.value != null && params.value != undefined) {
    //        if (params.value.toString().toUpperCase().trim() == "TRUE")
    //            return "On";
    //        else
    //            return "Off";
    //    }
    //    else
    //        return '-NA-';
    //},
    gensetSwitchFormatterForExcel: (params) => {
        if (params != null && params != undefined) {
            if (params.toString().toUpperCase().trim() == "TRUE" || params.toString() === "1")
                return "On";
            else if (params.toString().toUpperCase().trim() == "FALSE" || params.toString() === "0")
            return "Off";
            else
            return '-NA-';
        }
        else
            return '-NA-';
    },
    
    
    gensetRunningFormatterforExcel: (params) => {
        if (params != null && params != undefined) {
            if (params.HasOilPressureSwitch != null && params.GensetRunning != null) {
                if (params.HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {
                    if (params.GensetRunning.toString().toUpperCase().trim() == "0" || params.GensetRunning.toString().toUpperCase().trim() == "FALSE") {
                        return "No";
                    }
                    else if (params.GensetRunning.toString().toUpperCase().trim() == "1" || params.GensetRunning.toString().toUpperCase().trim() == "TRUE") {
                        return "Yes";
                    }
                    else
                        return "-NA-";
                }
                else
                    return "-NA-";
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
    },
    EngFormatterforExcel: (params) => {
        if (params != null && params != undefined) {
            if (params.HasOilPressureSwitch != null && params.GensetRunning != null) {
                if (params.HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {
                    if (params.OEMTypeCD != null && params.OEMTypeCD.toString().toUpperCase().trim() == "C") {
                        return "-NA-";
                    }
                   else if (params.GensetRunning.toString().toUpperCase().trim() == "0" || params.GensetRunning.toString().toUpperCase().trim() == "FALSE") {
                        return "No";
                    }
                    else if (params.GensetRunning.toString().toUpperCase().trim() == "1" || params.GensetRunning.toString().toUpperCase().trim() == "TRUE") {
                        return "Yes";
                    }
                    else
                        return "-NA-";
                }
                else
                    return "-NA-";
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
    },
    floatTypeFormatter: (params) => {
        if (params.value != null && params.value != undefined) {
            return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '-NA-';
    },

    floatTypeSorting: (param) => {
        if (param != null && param != undefined) {
            return param;
        }
        else
            return '-NA-';
    },

    /* RCNG-108 */
    AlarmDescriptionFormatter: (param, DeviceType, alarmsList) => {
        var element = document.createElement("span");
        if (param != null && param != undefined) {
            if (param != null && param != undefined && param != '') {
                var lstAlarms = param.split(',');
                $.each(lstAlarms, function (index, item) {
                    if (item != "" && item != null) {
                        if (parseInt(index.toString()) > 0) {
                            var spanElement = document.createElement("span");
                            spanElement.innerText = ", ";
                            element.appendChild(spanElement);
                        }

                        if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                            if (DeviceType != null && DeviceType != undefined && DeviceType.toString().trim() == "ST9100") {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item && e.AlarmSeriesTypeCD.toString().toUpperCase().trim() === "K");
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                            else {
                                var alarmDescription = alarmsList.filter(e =>
                                    e.AlarmAlias === item);
                                var anchorElement = document.createElement("a");
                                anchorElement.title = alarmDescription.length > 0 ? alarmDescription[0].Description.toString() : "";
                                anchorElement.text = item;
                                element.appendChild(anchorElement);
                            }
                        }
                    }
                });

                return element;
            }

            else return "-NA-";
        }
    },
    /* RCNG-108 */
    GPSHDOPTypeSorting: (GPSHDOP, GPSLockState) => {
        //debugger;
        if (GPSHDOP != null && GPSHDOP != undefined) {            
            if (GPSHDOP == "null" || GPSLockState == null || GPSLockState == '' || GPSLockState == "UNLOCKED")
                return '-NA-';
            else
            {
                var decimalPlaces = 2;
                var multiplier = Math.pow(10, decimalPlaces);
                return (Math.round(GPSHDOP * multiplier) / multiplier).toFixed(decimalPlaces);
            }
        }
        else
            return '-NA-';
    },

    GPSSatCountTypeSorting: (GPSSatelliteCount, GPSLockState) => {
        if (GPSSatelliteCount != null && GPSSatelliteCount != undefined) {
            if (GPSSatelliteCount == "null" || GPSLockState == null || GPSLockState == '' || GPSLockState == "UNLOCKED")
                return '-NA-';
            else
                return GPSSatelliteCount;
        }
        else
            return '-NA-';
    },

    floatTypeValueFormatter: (params) => {
        if (params.value != '-NA-') {
            return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '-NA-';
    },

    GPSfloatTypeValueFormatter: (params) => {
        if (params.value != '-NA-') {
            return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '-NA-';
    },

    GPSfloatTypeFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value != 0) {
            return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '-NA-';
    },
    GPSfloatTypeFormatterForExcel: (params) => {
        if (params != null && params != undefined && params != 0) {
            return params;
        }
        else
            return '-NA-';
    },

    GPSHDOPTypeFormatterForExcel: (GPSHDOP, GPSLockState) => {
        if (GPSHDOP != null && GPSHDOP != undefined) {
            if (GPSHDOP == "null" || GPSLockState == null || GPSLockState == '' || GPSLockState == "UNLOCKED")
                return '-NA-';
            else
            {
                var decimalPlaces = 2;
                var multiplier = Math.pow(10, decimalPlaces);
                return (Math.round(GPSHDOP * multiplier) / multiplier).toFixed(decimalPlaces);
            }
        }
        else
            return '-NA-';
    },
    GPSAcctypeFormatterForExcel: (params) => {
        //debugger;
        if (params != null && params != undefined && params != '-NA-') {
            if (params.toString().trim() == "-999") {
                return "OOR";
            }
            else {
                return (params != null) ? params.toString() : "-NA-";
            }
        }
        else
            return '-NA-';
    },

    GPSSatCountTypeFormatterForExcel: (GPSSatelliteCount, GPSLockState) => {
        if (GPSSatelliteCount != null && GPSSatelliteCount != undefined) {
            if (GPSSatelliteCount == "null" || GPSLockState == null || GPSLockState == '' || GPSLockState == "UNLOCKED")
                return '-NA-';
            else
                return GPSSatelliteCount;
        }
        else
            return '-NA-';
    },

    BattVoltageFormatter: (params) => {
        if (params.value != null && params.value != undefined) {
            var tempRoundingValue = "1";
            return (params.value != null) ? parseFloat(params.value.toFixed(parseInt(tempRoundingValue))) : "-NA-";
        }
        else
            return '-NA-';
    },
   

    DigitalSensorFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value != '-NA-') {
            if (params.value.toString().trim() == "-999") {
                if (params.colDef.headerClass != null && params.colDef.headerClass != undefined)
                    return params.colDef.headerClass;
                else
                    return "OOR";
            }
            else {
                //var tempRoundingValue = "1";
                //return (params.value != null) ? parseFloat(params.value.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString() : "-NA-";//26528
                return (params.value != null) ? params.value.toString() : "-NA-";//26784
            }
        }
        else
            return '-NA-';
    },

    DigitalSensorFormatterForExcel: (params) => {
        if (params.value != null && params.value != undefined && params.value != '-NA-') {
            if (params.value.toString().trim() == "-999") {
                if (params.column.colDef.headerClass != null && params.column.colDef.headerClass != undefined)
                    return params.column.colDef.headerClass;
                else
                    return "OOR";
            }
            else {
                var tempRoundingValue = "1";
                //return (params.value != null) ? parseFloat(params.value.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString() : "-NA-";//26528
                return (params.value != null) ? params.value.toString() : "-NA-";//26784
            }
        }
        else
            return '-NA-';
    },

    DigitalSensorGroupingForExcel: (params) => {
        if (params.value != null && params.value != undefined && params.value != '-NA-') {
            if (params.value.toString().trim() == "-999") {
                if (params.column.colDef.headerClass != null && params.column.colDef.headerClass != undefined)
                    return params.column.colDef.headerClass;
                else
                    return "OOR";
            }
            else {
                var tempRoundingValue = "1";
                return (params.value != null) ? parseFloat(params.value.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString() : "-NA-";//26528
            }
        }
        else
            return '-NA-';
    },

    BattVoltageValueFormatter: (params) => {

        if (params.value == -999)
            return "-NA-";
        else {
            var val = parseFloat(params.value.toString());
            return val.toFixed(1);
        }
            //return params.value;
    },
    BattVoltageSorting: (param) => {
        if (param != null && param != undefined) {
            var tempRoundingValue = "1";
            //return (param != null) ? parseFloat(param.toFixed(parseInt(tempRoundingValue))) : -999;
            if (param != null) {
                var val = parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                return val.toFixed(parseInt(tempRoundingValue));
            }
            return - 999;
        }
        else
            return -999;
    },
    BattVoltageSortingGrouping: (param) => {
        
        if (param != null && param != undefined && param != -999) {
            //var tempRoundingValue = "1";
            //return (param != null) ? parseFloat(param.toFixed(parseInt(tempRoundingValue))) : '-NA-';

            return (param == null) ? '-NA-' : param;// === "0" ? param : parseFloat(param.toFixed(parseInt(tempRoundingValue)));
        }
        else
            return '-NA-';
    },
    //RCNG-2227,2228
    DoorBattPctSortingGrouping: (param) => {
        if (param != null && param != undefined && param != -1) {
            return (param == null) ? '-NA-' : param;// === "0" ? param : parseFloat(param.toFixed(parseInt(tempRoundingValue)));
        }
        else
            return '-NA-';
    },

    ReeferBattPctSortingGrouping: (param, deviceType) => {
        if (deviceType != null && deviceType != undefined) {
            if (deviceType.trim() == 'CT3600' && param != null && param != undefined && param != -1) {
                return (param == null) ? '-NA-' : param;// === "0" ? param : parseFloat(param.toFixed(parseInt(tempRoundingValue)));
            }
            else
                return '-NA-';
        }
        return '-NA-';
    },
   
    BattVoltageSortingFieldName: (params, FieldName) => {

        if (params != null && params != undefined) {

            if (params.data != null && params.data != undefined) {
                var tempRoundingValue = "1";
                //return (params.data.BatteryVoltage != null) ? parseFloat(params.data.BatteryVoltage.toFixed(parseInt(tempRoundingValue))) : -999;
                if (params.data.BatteryVoltage != null) {
                    var val = parseFloat(params.data.BatteryVoltage.toFixed(parseInt(tempRoundingValue)));
                    return val.toFixed(parseInt(tempRoundingValue));
                }
                return - 999;
            }
            else
                return -999;
        }
        else
            return -999;
    },
    DoorBattVoltageSortingFieldName: (params, FieldName) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                var tempRoundingValue = "1";
                //return (params.data.DoorSensorBatteryVoltage != null) ? parseFloat(params.data.DoorSensorBatteryVoltage.toFixed(parseInt(tempRoundingValue))) : -999;
                if (params.data.DoorSensorBatteryVoltage != null) {
                    var val = parseFloat(params.data.DoorSensorBatteryVoltage.toFixed(parseInt(tempRoundingValue)));
                    return val.toFixed(parseInt(tempRoundingValue));
                }
                return - 999;
            }
            else
                return -999;
        }
        else
            return -999;
    },
    BattVoltageFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.ExtBattVoltage != null && params.data.ExtBattVoltage != undefined && params.data.ExtBattVoltage != '') {
            var tempRoundingValue = "1";
            //return (params.data.ExtBattVoltage != null) ? parseFloat(params.data.ExtBattVoltage.toFixed(parseInt(tempRoundingValue))) : "-NA-";
            if (params.data.ExtBattVoltage != null) {
                var val = parseFloat(params.data.ExtBattVoltage.toFixed(parseInt(tempRoundingValue)));
                return val.toFixed(parseInt(tempRoundingValue));
            }
            return '-NA-';
        }
        else
            return '-NA-';
    },
    DeviceBatteryFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.DeviceBattery != null && params.data.DeviceBattery != undefined) {
            var tempRoundingValue = "1";
            //return (params.data.DeviceBattery != null) ? parseFloat(params.data.DeviceBattery.toFixed(parseInt(tempRoundingValue))) : "-NA-";
            if (params.data.DeviceBattery != null) {
                var val = parseFloat(params.data.DeviceBattery.toFixed(parseInt(tempRoundingValue)));
                return val.toFixed(parseInt(tempRoundingValue));
            }
            return '-NA-';
        }
        else
            return '-NA-';
    },
    DeviceBattVoltageFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.BattVoltage != null && params.data.BattVoltage != undefined) {
            var tempRoundingValue = "1";
            //return (params.data.BattVoltage != null) ? parseFloat(params.data.BattVoltage.toFixed(parseInt(tempRoundingValue))) : "-NA-";
            if (params.data.BattVoltage != null) {
                var val = parseFloat(params.data.BattVoltage.toFixed(parseInt(tempRoundingValue)));
                return val.toFixed(parseInt(tempRoundingValue));
            }
            return "-NA-";
        }
        else
            return '-NA-';
    },
  
    GPSCoordsForFilter: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined && params.data != '') {
                var tempRoundingValue = "6";
                if (params.data.GPSCoords != null && params.data.GPSCoords != undefined && params.data.GPSCoords.toString() != "") {
                    var lstCoordinatePoints = params.data.GPSCoords.split(',');
                    var lat = parseFloat(lstCoordinatePoints[0].toString());
                    var long = parseFloat(lstCoordinatePoints[1].toString());
                    var param = parseFloat(lat.toFixed(parseInt(tempRoundingValue)).toString()) + "," + parseFloat(long.toFixed(parseInt(tempRoundingValue)).toString());
                    return param;
                }
                else
                    return "-NA-";;
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
    },
    BatteryVoltageFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.BatteryVoltage != null && params.data.BatteryVoltage != undefined) {
            var tempRoundingValue = "1";
            //return (params.data.BatteryVoltage != null) ? parseFloat(params.data.BatteryVoltage.toFixed(parseInt(tempRoundingValue))) : "-NA-";
            if (params.data.BatteryVoltage != null) {
                var val = parseFloat(params.data.BatteryVoltage.toFixed(parseInt(tempRoundingValue)));
                return val.toFixed(parseInt(tempRoundingValue));
            }
            return '-NA-';
        }
        else
            return '-NA-';
    },
    DoorBatteryVoltageFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.DoorSensorBatteryVoltage != null && params.data.DoorSensorBatteryVoltage != undefined) {
            var tempRoundingValue = "1";
            if (params.data.DoorSensorBatteryVoltage != null) {
                var val = parseFloat(params.data.DoorSensorBatteryVoltage.toFixed(parseInt(tempRoundingValue)));
                return val.toFixed(parseInt(tempRoundingValue));
            }
            return '-NA-';
        }
        else
            return '-NA-';
    },
    
    FillLevelTraceGrouping: (params) => {
        if (params != null && params != undefined && params != '') {           
            if (params < 0 ) {
                switch (params.toString()) {
                    case "-7": return "No Sensor";
                    case "-6": return "Config Error";
                    case "-5": return "Fuel Reading Unavailable";
                    case "-4": return "Not Configured";
                    case "-3": return "Sensor Error";
                    case "-2": return "Sensor Error";
                    case "-1": return "Unknown";
                    default:
                        return "*No Fuel Level";
                }
            }
            else {
                var image:any = params;
                if (image > 17)
                    return params;
                else
                    image = params - 1;

                if (image == 0)
                    image = "E";
                else if (image == 16)
                    image = "F";   
                
                var element = document.createElement("span");
                element.className = "reefer-alert";
                var imageElement = document.createElement("img");
                imageElement.src = "../images/FuelFractionImages/" + image + ".png";
                element.appendChild(imageElement);
                return element;
            }

        }        
    },
  
    stringTypeFormatter: (params) => {

        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
            return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '-NA-';

    },
    commoditystringTypeFormatter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data != "null") {
            return params.data.commodity;
        }
        else
            return '-NA-';

    },
    rcdFirmwareFormatter: (params) => {
        var tempRoundingValue = "2";
        if (params != null && params != undefined && params.data != null && params.data != undefined) {
            var RCDFirmwareVersion = params.data.RCDFirmwareVersion;
            var DeviceType = params.data.DeviceType;

            if (RCDFirmwareVersion != null && RCDFirmwareVersion != "" && RCDFirmwareVersion != "null") {
                if (DeviceType != null && DeviceType.trim() == "CT4000") {
                    var tempVal = RCDFirmwareVersion.split(" ");
                    var param = tempVal[1];
                    if (param != null && param != undefined) {
                        var val = parseFloat(param.toString());
                        var firmwareRev = tempVal[0] + " " + val.toFixed(parseInt(tempRoundingValue));
                        return firmwareRev;
                    }
                }

                return RCDFirmwareVersion;
            }
            else
                return '-NA-';
        }
    },

    deviceFirmwareFormatter: (params) => {
        var tempRoundingValue = "2";
        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
            if (params.data.DeviceType != null && params.data.DeviceType.trim() == "CT4000") {
                var tempVal = params.value.split(" ");
                var param = tempVal[1];
                if (param != null && param != undefined) {
                    var val = parseFloat(param.toString());
                    var firmwareRev = tempVal[0] + " " + val.toFixed(parseInt(tempRoundingValue));

                    return '<span title ="' + firmwareRev + '">' + firmwareRev + '</span>';
                }
                else 
                    return '<span title ="' + params.value + '">' + params.value + '</span>';
            }
            else
                return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '-NA-';       
    },

    deviceFirmwareFormatterForExcel: (params) => {
        var tempRoundingValue = "2";
        if (params.FirmwareRev != null && params.FirmwareRev != undefined && params.FirmwareRev != '' && params.FirmwareRev != "null") {           
            try {
                if (params.DeviceType != null && params.DeviceType.trim() == "CT4000") {
                    var tempVal = params.FirmwareRev.split(" ");
                    var firmwareRev = '';

                    if (tempVal[1] != null && tempVal[1] != undefined && tempVal[1] != '' && tempVal[1] != "null") {
                        var param = tempVal[1].toString();
                        var val = parseFloat(param);
                        firmwareRev = tempVal[0] + " " + val.toFixed(parseInt(tempRoundingValue));
                    }
                    else
                        firmwareRev = tempVal[0];
                    
                    return firmwareRev;
                }
                else
                    return params.FirmwareRev;
            } catch (e) {
                return '-NA-';
            }
        }
        else
            return '-NA-'; 
    },

    TemperatureFormatterGrouping: (params, fieldName, Data, DeviceType) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        //var colDef = Data.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
        //var columnDisplayName = colDef[0].colDef.headerName;
        var columnDisplayName = Data.node.rowGroupColumn.colDef.headerName;//WI-26892
        if (params != '-NA-') {
            if (params.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                return "OOR";
            else {
                var tempVal = parseFloat(params);

                if ((DeviceType != null && DeviceType != undefined && DeviceType.toString().toUpperCase().trim() == "ST9100") && Data.node.field == "DeviceTemp") {
                    //if (tempVal == 0)
                    return '-NA-';
                }
                if (tempUnitCd.toUpperCase() == "F") {
                    tempVal = ((tempVal * 9) / 5) + 32;

                    var param = parseFloat(tempVal.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
                else
                    return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue)));
            }
        }
        else
            return '*No ' + columnDisplayName;
    },
    BookingTemperatureFormatterGrouping: (params, fieldName, Data) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        //var colDef = Data.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
        //var columnDisplayName = colDef[0].colDef.headerName;
        var columnDisplayName = Data.node.rowGroupColumn.colDef.headerName;//WI-26892
        var BookedTemperature = null;
        var TempUnit = null;
        if (params != null && params != '-NA-') {
            var strlstValues = params.split('@');
            BookedTemperature = strlstValues[0];
            TempUnit = strlstValues[1];
            if (TempUnit.toUpperCase() == "N")
                return "Non-Running";
            else if (TempUnit.toUpperCase() != tempUnitCd.toUpperCase()) {
                if ("F" == tempUnitCd.toUpperCase()) {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = ((tempValue * 9) / 5) + 32;
                    var param = parseFloat(tempValue.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
                else {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = (tempValue - 32) * 5 / 9;
                    var param = parseFloat(tempValue.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
            }
            else
                return parseFloat(parseFloat(BookedTemperature.toString()).toFixed(parseInt(tempRoundingValue)));
        }
        else
            return '*No ' + columnDisplayName;
    },
    EvaporatorExpansionValveOpeningSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.EvaporatorExpansionValveOpening != null && params.data.EvaporatorExpansionValveOpening != '-NA-') {
                return params.data.EvaporatorExpansionValveOpening.toString();
            }
            return '-NA-';
        }
            return '-NA-';
        
    },
    SuctionModulationValveOpeningSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
                    if (params.data.SuctionModulationValveOpening != null && params.data.SuctionModulationValveOpening != '' && params.data.SuctionModulationValveOpening != '-NA-') {
                            return params.data.SuctionModulationValveOpening.toString();
            }
            return '-NA-';
        }
        return '-NA-';
    },
    ControlledAtmosphereModeSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data != '-NA-') {
            if (params.data.ControlledAtmosphereMode != null && params.data.ControlledAtmosphereMode != '-NA-' && params.data.ControlledAtmosphereMode != undefined && params.data.ControlledAtmosphereMode != '') {
                        return params.data.ControlledAtmosphereMode.toString();
            }
                return '-NA-';
        }
        return '-NA-';
    },
    ThreePhaseCurrentSorting: (params) => {    
        if (params.data.ThreePhaseCurrent != null && params.data.TotalCurrentDraw != "-N-") {
            return params.data.ThreePhaseCurrent;
        }
        else
            return "-NA-";
    },
    
    vesselCdSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.VesselCd != null && params.data.VesselCd != "" && params.data.VesselCd != undefined && params.data.VesselCd != "null") {
                return params.data.VesselCd;
            }

            return "-NA-";
        }
    },
    
    stringTypeValueFormatter: (params) => {        
        if (params.value != "-NA-") {
            return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '-NA-';
    },
    DepartingVVCstringTypeValueFormatter: (params) => {
        var valueString = '-NA-';
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.DepartingVVC != "-NA-") {
                valueString = params.data.DepartingVVC.trim();
                if (valueString.endsWith("-")) {
                    valueString = valueString.substring(0, valueString.length - 1);
                }
                if (valueString == "")
                    return '-NA-';
                else
                    return valueString;
            }
        }
        return '-NA-';
    },
    BKVVstringTypeValueFormatter: (params) => {
        var valueString = '-NA-';
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.BKVV != "-NA-" && params.data.BKVV != undefined && params.data.BKVV !=null) {
                valueString = params.data.BKVV.trim();
                if (valueString.endsWith("-")) {
                    valueString = valueString.substring(0, valueString.length - 1);
                }
                if (valueString == "")
                    return '-NA-';
                else
                    return valueString;
            }
            else
                return valueString;
        }
        return '-NA-';
    },
    BKVVstringTypeValueFormatter: (params) => {
        var valueString = '-NA-';
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.BKVV != "-NA-" && params.data.BKVV != undefined && params.data.BKVV !=null) {
                valueString = params.data.BKVV.trim();
                if (valueString.endsWith("-")) {
                    valueString = valueString.substring(0, valueString.length - 1);
                }
                if (valueString == "")
                    return '-NA-';
                else
                    return valueString;
            }
            else
                return valueString;
        }
        return '-NA-';
    },
    ArrivingVVCstringTypeValueFormatter: (params) => {
        var valueString = '-NA-';
        if (params.data != null && params.data != undefined && params.data != '') {
        if (params.data.ArrivingVVC != "-NA-") {
            valueString = params.data.ArrivingVVC.trim();
            if (valueString.endsWith("-")) {
                valueString = valueString.substring(0, valueString.length - 1);
            }
                if (valueString == "")
                    return '-NA-';
                else
                    return valueString;
            }
        }
        return '-NA-';
    },
    FreshAirTypeValueFormatter: (params) => {
        if (params.value != "-NA-") {
            return '<span title ="' + params.value + '">' + parseFloat(params.value).toFixed(1) + '</span>';
        }
        else
            return '-NA-';
    },
    stringTypeSorting: (param) => {
        if (param != null && param != undefined && param != '' && param != "null") {
            return param;
        }
        else
            return '-NA-';
    },
    stringTypeSortingFieldName: (params,FieldName) => {
        if (params != null && params != undefined) {
            if (params.data != undefined && params.data != null) {
                //if (param != null && param != undefined && param != '' && param != "null") {
                //    return param;
                //}

                switch (FieldName) {
                    case 'AssetNumber':
                        return params.data.AssetNumber != null && params.data.AssetNumber != "" && params.data.AssetNumber != "null" ? params.data.AssetNumber : '-NA-';
                    case 'FenceName':
                        return params.data.FenceName != null && params.data.FenceName != "" && params.data.FenceName != "null" ? params.data.FenceName : '-NA-';
                    case 'FenceNameID':
                        return params.data.FenceNameID != null && params.data.FenceNameID != "" && params.data.FenceNameID != "null" ? params.data.FenceNameID : '-NA-';
                    case 'BackendGeofenceName':
                        return params.data.BackendGeofenceName != null && params.data.BackendGeofenceName != "" && params.data.BackendGeofenceName != "null" ? params.data.BackendGeofenceName : '-NA-';
                    case 'BackendGeofenceNameID':
                        return params.data.BackendGeofenceNameID != null && params.data.BackendGeofenceNameID != "" && params.data.BackendGeofenceNameID != "null" ? params.data.BackendGeofenceNameID : '-NA-';
                    case 'FirmwareVersion':
                        return params.data.FirmwareVersion != null && params.data.FirmwareVersion != "" && params.data.FirmwareVersion != "null" ? params.data.FirmwareVersion : '-NA-';
                    case 'PTIType':
                        return params.data.PTIType != null && params.data.PTIType.trim() != "" && params.data.PTIType != "null" ? params.data.PTIType : '-NA-';
                    case 'ReeferID':
                        return params.data.ReeferID != null && params.data.ReeferID != "" && params.data.ReeferID != "null" ? params.data.ReeferID : '-NA-';
                    case 'CCProfileCode':
                        return params.data.CCProfileCode != null && params.data.CCProfileCode != "" && params.data.CCProfileCode != "null" ? params.data.CCProfileCode : '-NA-';
                    case 'ColdTreatmentState':
                        if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd.toUpperCase().trim() == "D") {
                            if (params.data.ACTMode != null && params.data.ACTMode.toString().toUpperCase().trim() == "TRUE")
                                return params.data.ColdTreatmentState != null && params.data.ColdTreatmentState != "" && params.data.ColdTreatmentState != "null" ? params.data.ColdTreatmentState : '-NA-';
                            else
                                return '-NA-';
                        }
                        else
                            return params.data.ColdTreatmentState != null && params.data.ColdTreatmentState != "" && params.data.ColdTreatmentState != "null" ? params.data.ColdTreatmentState : '-NA-';
                    //26668 - start
                    case 'VesselID':
                        return params.data.VesselID != null && params.data.VesselID != "" && params.data.VesselID != "null" ? params.data.VesselID : '-NA-';
                    case 'VoyageID':
                        return params.data.VoyageID != null && params.data.VoyageID != "" && params.data.VoyageID != "null" ? params.data.VoyageID : '-NA-';
                    case 'PortOfDeparture':
                        return params.data.PortOfDeparture != null && params.data.PortOfDeparture != "" && params.data.PortOfDeparture != "null" ? params.data.PortOfDeparture : '-NA-';
                    case 'PortOfDestination':
                        return params.data.PortOfDestination != null && params.data.PortOfDestination != "" && params.data.PortOfDestination != "null" ? params.data.PortOfDestination : '-NA-';
                    case 'Bay':
                        return params.data.Bay != null && params.data.Bay != "" && params.data.Bay != "null" ? params.data.Bay : '-NA-';
                    case 'Row':
                        return params.data.Row != null && params.data.Row != "" && params.data.Row != "null" ? params.data.Row : '-NA-';
                    case 'Tier':
                        return params.data.Tier != null && params.data.Tier != "" && params.data.Tier != "null" ? params.data.Tier : '-NA-';
                    //26668 -end

                    case 'OEMModel':
                        return params.data.OEMModel != null && params.data.OEMModel != "" && params.data.OEMModel != "null" ? params.data.OEMModel : '-NA-';
                    case 'BookingNumber':
                        return params.data.BookingNumber != null && params.data.BookingNumber != "" && params.data.BookingNumber != "null" ? params.data.BookingNumber : '-NA-';
                    case 'EventDescription':
                        return params.data.EventDescription != null && params.data.EventDescription != "null" && params.data.EventDescription != "" ? params.data.EventDescription : '-NA-';
                    case 'GeofenceName':
                        return params.data.GeofenceName != null && params.data.GeofenceName != "null" && params.data.GeofenceName != "" ? params.data.GeofenceName : '-NA-';
                    case 'ServerGeofenceName':
                        return params.data.ServerGeofenceName != null && params.data.ServerGeofenceName != "null" && params.data.ServerGeofenceName != "" ? params.data.ServerGeofenceName : '-NA-';
                    case 'Geofence':
                        return params.data.Geofence != null && params.data.Geofence != "null" && params.data.Geofence != "" ? params.data.Geofence : '-NA-';
                    case 'ServerGeofence':
                        return params.data.ServerGeofence != null && params.data.ServerGeofence != "null" && params.data.ServerGeofence != "" ? params.data.ServerGeofence : '-NA-';
                    case 'Tag':
                        return params.data.Tag != null && params.data.Tag != "null" && params.data.Tag != "" ? params.data.Tag : '-NA-';
                    case 'Name':
                        return params.data.Name != null && params.data.Name != "null" && params.data.Name != "" ? params.data.Name : '-NA-';
                    case 'Address':
                        return params.data.Address != null && params.data.Address != "null" && params.data.Address != "" ? params.data.Address : '-NA-';
                    case 'City':
                        return params.data.City != null && params.data.City != "" && params.data.City != "null" ? params.data.City : '-NA-';
                    case 'State':
                        return params.data.State != null && params.data.State != "" && params.data.State != "null" ? params.data.State : '-NA-';
                    case 'Country':
                        return params.data.Country != null && params.data.Country != "" && params.data.Country != "null" ? params.data.Country : '-NA-';
                    case 'Zip':
                        return params.data.Zip != null && params.data.Zip != "" && params.data.Zip != "null" ? params.data.Zip : '-NA-';
                    case 'ZipCode':
                        return params.data.ZipCode != null && params.data.ZipCode != "" && params.data.ZipCode != "null" ? params.data.ZipCode : '-NA-';
                    case 'TripWiseStatusDescription':
                        return params.data.TripWiseStatusDescription != null && params.data.TripWiseStatusDescription != "" && params.data.TripWiseStatusDescription != "null" ? params.data.TripWiseStatusDescription : '-NA-';
                    case 'PTIState':
                        return params.data.PTIState != null && params.data.PTIState != "" && params.data.PTIState != "null" ? params.data.PTIState : '-NA-';

                    case 'ControllerSerialNumber':
                        return params.data.ControllerSerialNumber != null && params.data.ControllerSerialNumber != "" && params.data.ControllerSerialNumber != "null" ? params.data.ControllerSerialNumber : '-NA-';
                    case 'SoftwareRevision':
                        return params.data.SoftwareRevision != null && params.data.SoftwareRevision != "" && params.data.SoftwareRevision != "null" ? params.data.SoftwareRevision : '-NA-';

                    case 'ControllerTypeSetting':
                        return params.data.ControllerTypeSetting != null && params.data.ControllerTypeSetting != "" && params.data.ControllerTypeSetting != "null" ? params.data.ControllerTypeSetting : '-NA-';
                    case 'FreshAirType':
                        return params.data.FreshAirType != null && params.data.FreshAirType != "" && params.data.FreshAirType != "null" ? params.data.FreshAirType : '-NA-';
                    case 'RCDID':
                        return params.data.RCDID != null && params.data.RCDID != "" && params.data.RCDID != "null" ? params.data.RCDID : '-NA-';
                    case 'RCDFirmwareVersion':
                        return params.data.RCDFirmwareVersion != null && params.data.RCDFirmwareVersion != "" && params.data.RCDFirmwareVersion != "null" ? params.data.RCDFirmwareVersion : '-NA-';

                    case 'RCDBootloaderVersion':
                        return params.data.RCDBootloaderVersion != null && params.data.RCDBootloaderVersion != "" && params.data.RCDBootloaderVersion != "null" ? params.data.RCDBootloaderVersion : '-NA-';
                    case 'RCDMeshFirmwareVersion':
                        return params.data.RCDMeshFirmwareVersion != null && params.data.RCDMeshFirmwareVersion != "" && params.data.RCDMeshFirmwareVersion != "null" ? params.data.RCDMeshFirmwareVersion : '-NA-';
                    case 'RCDReportingInterval':
                        return params.data.RCDReportingInterval != null && params.data.RCDReportingInterval != "" && params.data.RCDReportingInterval != "null" ? params.data.RCDReportingInterval : '-NA-';
                    case 'DefrostInterval':
                        return params.data.DefrostInterval != null && params.data.DefrostInterval != "" && params.data.DefrostInterval != "null" ? params.data.DefrostInterval : '-NA-';
                    case 'PowerMeter':
                        return params.data.PowerMeter != null && params.data.PowerMeter != "" && params.data.PowerMeter != "null" ? params.data.PowerMeter : '-NA-';
                    case 'RevisionNum':
                        return params.data.RevisionNum != null && params.data.RevisionNum != "" && params.data.RevisionNum != "null" ? params.data.RevisionNum : '-NA-';
                    case 'GeofenceRevisionNum':
                        return params.data.GeofenceRevisionNum != null && params.data.GeofenceRevisionNum != "" && params.data.GeofenceRevisionNum != "null" ? params.data.GeofenceRevisionNum : '-NA-';

                    case 'MSISDN':
                        return params.data.MSISDN != null && params.data.MSISDN != "" && params.data.MSISDN != "null" ? params.data.MSISDN : '-NA-';
                    case 'SIM_IMSI':
                        return params.data.SIM_IMSI != null && params.data.SIM_IMSI != "" && params.data.SIM_IMSI != "null" ? params.data.SIM_IMSI : '-NA-';
                    case 'ICCID':
                        return params.data.ICCID != null && params.data.ICCID != "" && params.data.ICCID != "null" ? params.data.ICCID : '-NA-';
                    case 'EUI':
                        return params.data.EUI != null && params.data.EUI != "" && params.data.EUI != "null" ? params.data.EUI : '-NA-';

                    case 'CountryName':
                        return params.data.CountryName != null && params.data.CountryName != "" && params.data.CountryName != "null" ? params.data.CountryName : '-NA-';
                    case 'TowerLocalizationAreaCode':
                        return params.data.TowerLocalizationAreaCode != null && params.data.TowerLocalizationAreaCode != "" && params.data.TowerLocalizationAreaCode != "null" ? params.data.TowerLocalizationAreaCode : '-NA-';
                    case 'TowerBaseStationID':
                        return params.data.TowerBaseStationID != null && params.data.TowerBaseStationID != "" && params.data.TowerBaseStationID != "null" ? params.data.TowerBaseStationID : '-NA-';
                    case 'DeviceType':
                        return params.data.DeviceType != null && params.data.DeviceType != "" && params.data.DeviceType != "null" ? params.data.DeviceType : '-NA-';
                    case 'VesselCd':
                        return params.data.VesselCd != null && params.data.VesselCd != "" && params.data.VesselCd != "null" ? params.data.VesselCd : '-NA-';
                    case 'AssetState':
                        return params.data.AssetState != null && params.data.AssetState != "" && params.data.AssetState != "null" ? params.data.AssetState : '-NA-';
                    case 'DeploymentName':
                        return params.data.DeploymentName != null && params.data.DeploymentName != "" && params.data.DeploymentName != "null" ? params.data.DeploymentName : '-NA-';
                    case 'DeploymentTypeName':
                        return params.data.DeploymentTypeName != null && params.data.DeploymentTypeName != "" && params.data.DeploymentTypeName != "null" ? params.data.DeploymentTypeName : '-NA-';
                    case 'DeploymentStatus':
                        return params.data.DeploymentStatus != null && params.data.DeploymentStatus != "" && params.data.DeploymentStatus != "null" ? params.data.DeploymentStatus : '-NA-';
                    case 'Description':
                        return params.data.Description != null && params.data.Description != "" && params.data.Description != "null" ? params.data.Description : '-NA-';
                    case 'CreatedBy':
                        return params.data.CreatedBy != null && params.data.CreatedBy != "" && params.data.CreatedBy != "null" ? params.data.CreatedBy : '-NA-';
                    case 'ModifiedBy':
                        return params.data.ModifiedBy != null && params.data.ModifiedBy != "" && params.data.ModifiedBy != "null" ? params.data.ModifiedBy : '-NA-';
                    case 'FileName':
                        return params.data.FileName != null && params.data.FileName != "" && params.data.FileName != "null" ? params.data.FileName : '-NA-';
                    case 'TagName':
                        return params.data.TagName != null && params.data.TagName != "" && params.data.TagName != "null" ? params.data.TagName : '-NA-';
                    case 'OEMDescription':
                        return params.data.OEMDescription != null && params.data.OEMDescription != "" && params.data.OEMDescription != "null" ? params.data.OEMDescription : '-NA-';
                    case 'OemModelDescription':
                        return params.data.OemModelDescription != null && params.data.OemModelDescription != "" && params.data.OemModelDescription != "null" ? params.data.OemModelDescription : '-NA-';
                    case 'Created':
                        return params.data.Created != null && params.data.Created != "" && params.data.Created != "null" ? params.data.Created : '-NA-';
                    case 'CustomerName':
                        return params.data.CustomerName != null && params.data.CustomerName != "" && params.data.CustomerName != "null" ? params.data.CustomerName : '-NA-';
                    case 'Compression':
                        return params.data.Compression != null && params.data.Compression != "" && params.data.Compression != "null" ? params.data.Compression : '-NA-';
                    case 'GeofenceCategoryDsc':
                        return params.data.GeofenceCategoryDsc != null && params.data.GeofenceCategoryDsc != "" && params.data.GeofenceCategoryDsc != "null" ? params.data.GeofenceCategoryDsc : '-NA-';
                    case 'UserName':
                        return params.data.UserName != null && params.data.UserName != "" && params.data.UserName != "null" ? params.data.UserName : '-NA-';
                    case 'FullName':
                        return params.data.FullName != null && params.data.FullName != "" && params.data.FullName != "null" ? params.data.FullName : '-NA-';
                    case 'SSOSignInTypes':
                        return params.data.SSOSignInTypes != null && params.data.SSOSignInTypes != "" && params.data.SSOSignInTypes != "null" ? params.data.SSOSignInTypes : '-NA-';
                    case 'UserEmail':
                        return params.data.UserEmail != null && params.data.UserEmail != "" && params.data.UserEmail != "null" ? params.data.UserEmail : '-NA-';
                    case 'Domain':
                        return params.data.Domain != null && params.data.Domain != "" && params.data.Domain != "null" ? params.data.Domain : '-NA-';
                    case 'AssignedGroup':
                        return params.data.AssignedGroup != null && params.data.AssignedGroup != "" && params.data.AssignedGroup != "null" ? params.data.AssignedGroup : '-NA-';
                    case 'GroupType':
                        return params.data.GroupType != null && params.data.GroupType != "" && params.data.GroupType != "null" ? params.data.GroupType : '-NA-';
                    case 'DLParam1':
                        return params.data.DLParam1 != null && params.data.DLParam1 != "" && params.data.DLParam1 != "null" ? params.data.DLParam1 : '-NA-';
                    case 'DLParam2':
                        return params.data.DLParam2 != null && params.data.DLParam2 != "" && params.data.DLParam2 != "null" ? params.data.DLParam2 : '-NA-';
                    case 'DLParam3':
                        return params.data.DLParam3 != null && params.data.DLParam3 != "" && params.data.DLParam3 != "null" ? params.data.DLParam3 : '-NA-';
                    case 'DLParam4':
                        return params.data.DLParam4 != null && params.data.DLParam4 != "" && params.data.DLParam4 != "null" ? params.data.DLParam4 : '-NA-';
                    case 'DLParam5':
                        return params.data.DLParam5 != null && params.data.DLParam5 != "" && params.data.DLParam5 != "null" ? params.data.DLParam5 : '-NA-';
                    case 'CellNetGeneration':
                        return params.data.CellNetGeneration != null && params.data.CellNetGeneration != "" && params.data.CellNetGeneration != "null" ? params.data.CellNetGeneration : '-NA-';
                    case 'PersonID':
                        return params.data.PersonID != null && params.data.PersonID != "" && params.data.PersonID != "null" ? params.data.PersonID : '-NA-';
                    case 'DLEventMasterID':
                        return params.data.DLEventMasterID != null && params.data.DLEventMasterID != "null" && params.data.DLEventMasterID != "" ? params.data.DLEventMasterID : '-NA-';
                    case 'EventNotes':
                        return params.data.EventNotes != null && params.data.EventNotes != "" && params.data.EventNotes != "null" ? params.data.EventNotes : '-NA-';
                    case 'DepartingVVC':
                        return params.data.DepartingVVC != null && params.data.DepartingVVC != "" && params.data.DepartingVVC != "null" ? params.data.DepartingVVC : '-NA-';
                    case 'ArrivingVVC':
                        return params.data.ArrivingVVC != null && params.data.ArrivingVVC != "" && params.data.ArrivingVVC != "null" ? params.data.ArrivingVVC : '-NA-';

                    case 'ProfileCode':
                        return params.data.ProfileCode != null && params.data.ProfileCode != "" && params.data.ProfileCode != "null" ? params.data.ProfileCode : '-NA-';
                    case 'ProfileCodeDescription':
                        return params.data.ProfileCodeDescription != null && params.data.ProfileCodeDescription != "" && params.data.ProfileCodeDescription != "null" ? params.data.ProfileCodeDescription : '-NA-';
                    case 'InsertedBy':
                        return params.data.InsertedBy != null && params.data.InsertedBy != "" && params.data.InsertedBy != "null" ? params.data.InsertedBy : '-NA-';
                    case 'UpdatedBy':
                        return params.data.UpdatedBy != null && params.data.UpdatedBy != "" && params.data.UpdatedBy != "null" ? params.data.UpdatedBy : '-NA-';
                    case 'DeviceTemp':
                        return params.data.DeviceTemp != null && params.data.DeviceTemp != "" && params.data.DeviceTemp != "null" ? params.data.DeviceTemp : '-NA-';   //RCNG-1099
                    case 'InsideTemp':
                        return params.data.InsideTemp != null && params.data.InsideTemp != "" && params.data.InsideTemp != "null" ? params.data.InsideTemp : '-NA-';
                    case 'MNC':
                        return params.data.MNC != null && params.data.MNC != "" && params.data.MNC != "null" ? params.data.MNC : '-NA-'; //RCNG-1183

                    case 'BKVV':
                        return params.data.BKVV != null && params.data.BKVV != "" && params.data.BKVV != "null" ? params.data.BKVV : '-NA-';
                    case 'BKPOR':
                        return params.data.BKPOR != null && params.data.BKPOR != "" && params.data.BKPOR != "null" ? params.data.BKPOR : '-NA-';
                    case 'BKPOL':
                        return params.data.BKPOL != null && params.data.BKPOL != "" && params.data.BKPOL != "null" ? params.data.BKPOL : '-NA-';
                    case 'BKPOD':
                        return params.data.BKPOD != null && params.data.BKPOD != "" && params.data.BKPOD != "null" ? params.data.BKPOD : '-NA-';
                    case 'BKDEL':
                        return params.data.BKDEL != null && params.data.BKDEL != "" && params.data.BKDEL != "null" ? params.data.BKDEL : '-NA-';
                    case 'BKCustomer':
                        return params.data.BKCustomer != null && params.data.BKCustomer != "" && params.data.BKCustomer != "null" ? params.data.BKCustomer : '-NA-';
                    case 'DimiRemainTerm':
                        return params.data.DimiRemainTerm != null && params.data.DimiRemainTerm != "" && params.data.DimiRemainTerm != "null" ? params.data.DimiRemainTerm : '-NA-';
                    case 'DimiStartAfter':
                        return params.data.DimiStartAfter != null && params.data.DimiStartAfter != "" && params.data.DimiStartAfter != "null" ? params.data.DimiStartAfter : '-NA-';
                    case 'XAxis':
                        return params.data.XAxis != null && params.data.XAxis != "null" ? params.data.XAxis : '-NA-';
                    case 'YAxis':
                        return params.data.YAxis != null && params.data.YAxis != "null" ? params.data.YAxis : '-NA-';
                    case 'ZAxis':
                        return params.data.ZAxis != null && params.data.ZAxis != "null" ? params.data.ZAxis : '-NA-';
                    case 'Illumination':
                        return params.data.Illumination != null && params.data.Illumination != "null" ? params.data.Illumination : '-NA-';
                    case 'EvaporatorFanSpeedControl':
                        return params.data.EvaporatorFanSpeedControl != null && params.data.EvaporatorFanSpeedControl != "" && params.data.EvaporatorFanSpeedControl != "null" ? params.data.EvaporatorFanSpeedControl : '-NA-';
                    case 'BulbMode':
                        return params.data.BulbMode != null && params.data.BulbMode != "" && params.data.BulbMode != "null" ? params.data.BulbMode : '-NA-';
                    case 'PossibleDamage':
                            if (params.data.PossibleDamage != null && params.data.PossibleDamage.toString().toUpperCase() == "TRUE")
                                return 'Check';
                            else if(params.data.PossibleDamage != null && params.data.PossibleDamage.toString().toUpperCase() == "FALSE")
                                return 'Clear';
                            else
                                return 'NA';
                    default:
                    return '-NA-';

               }

            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },
BatteryModeFormatter:(params) => {
    if(params.data != null && params.data != undefined && params.data.BatteryMode != null && params.data.BatteryMode != "" && params.data.BatteryMode != "null")
    {
        var BatteryMode = params.data.BatteryMode;
        if(BatteryMode == "N")
            return "Normal";
        else if(BatteryMode == "B")
            return "Backup";
        else if(BatteryMode == "T")
            return "Tertiary";
        else if(BatteryMode == "R")
            return "Reserve";
        else return "-NA-";
    }
        
    else return "-NA-";
},
    //everFreshSortingFieldName: (params) => {
    //    if (params.data.EverFRESH != null && params.data.EverFRESH != "" && params.data.EverFRESH != "null") {
    //        if (params.data.EverFRESH == true)
    //            return 'On';
    //        else return 'Off';
    //    }
    //    else
    //        return '-NA-';
    //},
    stringTypeSortingForCustomefields: (param) => {
        if (param != null && param != undefined) {
            if (param.column != null && param.column != undefined) {

                if (param.column.colId != null && param.column.colId != undefined) {
                    if (param.data != null && param.data != undefined) {
                        var name = param.column.colId;  
                        var value = param.data[name];
                        if (value != null && value != undefined && value != '' && value != "null") {
                            return value;
                        }
                        else
                            return '-NA-';
                    }
                    else
                        return '-NA-';
                }
                else
                    return '-NA-';
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
        
    }, 

    stringTypeSortingForSensorfields: (param) => {
        if (param != null && param != undefined) {
            if (param.column != null && param.column != undefined) {
                if (param.column.colId != null && param.column.colId != undefined) {
                    if (param.data != null && param.data != undefined) {
                        var columnFieldName = param.column.colId;
                        var deviceType = param.data.DeviceType;
                        var name = columnFieldName.split("_");
                        var value = param.data[name[0]];
                        var deviceTypeCd = name[1];
                        //if (value != null && value != undefined && value != '') {
                        if (value != null && value != undefined && value != "null") {
                            if (deviceType != null && deviceType != '' && deviceTypeCd != null && deviceTypeCd != '') {
                                if (deviceTypeCd.trim() == deviceType.trim())
                                    return value;
                            }
                            return '-NA-';
                        }
                        else
                            return '-NA-';
                    }
                    else
                        return '-NA-';
                }
                else
                    return '-NA-';
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    }, 

    stringTypeSortingForDigitalSensorfields: (param) => {
        if (param != null && param != undefined) {
            if (param.column != null && param.column != undefined) {                
                if (param.column.colId != null && param.column.colId != undefined) {
                    if (param.data != null && param.data != undefined) {
                        var columnFieldName = param.column.colId;
                        var refData = param.colDef.refData;                        
                        var deviceType = param.data.DeviceType;
                        var name = columnFieldName.split("_");
                        var value = param.data[name[0]];
                        var deviceTypeCd = name[1];
                        //if (value != null && value != undefined && value != '') {
                        if (value != null && value != undefined && value != "null") {
                            if (deviceType != null && deviceType != '' && deviceTypeCd != null && deviceTypeCd != '') {
                                if (deviceTypeCd.trim() == deviceType.trim()) {
                                    
                                    if (value == 1) {
                                        var sensorSetDsc = refData.split(",")[0];
                                        return sensorSetDsc;
                                    }
                                    else if (value == 0) {
                                        var sensorResetDsc = refData.split(",")[1];
                                        return sensorResetDsc;
                                    }
                                    else
                                        return value;
                                }
                            }
                            return '-NA-';
                        }
                        else
                            return '-NA-';
                    }
                    else
                        return '-NA-';
                }
                else
                    return '-NA-';
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },

    TripWiseStatusDescriptionSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.TripWiseStatusDescription != null && params.data.TripWiseStatusDescription != "" && params.data.TripWiseStatusDescription != undefined && params.data.TripWiseStatusDescription != "null") {
                return params.data.TripWiseStatusDescription;
            }

            return "null";
        }
    },
    PTIStateSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.PTIState != null && params.data.PTIState != "" && params.data.PTIState != undefined && params.data.PTIState != "null") {
                return params.data.PTIState;
            }

            return "null";
        }
    },
    MNCSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.MNC != null && params.data.MNC != "" && params.data.MNC != undefined && params.data.MNC != "-NA-") {
                return params.data.MNC;
            }

            return "-NA-";
        }
    },
    GPSCoordsSorting: (params) => {
        if (params != null && params != undefined) {
            var tempRoundingValue = "6";

            if (params.data != null && params.data != undefined && params.data != '') {
                if (params.data.GPSCoords != null && params.data.GPSCoords != undefined && params.data.GPSCoords.toString().trim() != "") {
                    var lstCoordinatePoints = params.data.GPSCoords.split(',');
                    if (lstCoordinatePoints.length > 1)
                    {
                        var lat = parseFloat(lstCoordinatePoints[0].toString());
                        var long = parseFloat(lstCoordinatePoints[1].toString());
                        var param = parseFloat(lat.toFixed(parseInt(tempRoundingValue)).toString()) + "," + parseFloat(long.toFixed(parseInt(tempRoundingValue)).toString());
                        return param;
                    }
                    else
                        return "-1000";                
                }
                else
                    return "-1000";
            }
            else
                return "-1000";
        }
        else
            return "-1000";

    },
    secondsToTimeSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.GPSLastLock != null && params.data.GPSLastLock != undefined) {
                    var val = parseInt(params.data.GPSLastLock);
                    if (val != 0) {
                        var hours = val / 60;
                        var minutes = val % 60;
                        return parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":00";

                    }
                    else
                        return val;
                }
                else
                    return "-NA-";
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
        
    },
    BookingNumberSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.BookingNumber != null && params.data.BookingNumber != "" && params.data.BookingNumber != undefined && params.data.BookingNumber != "null") {
                return params.data.BookingNumber;
            }

            return "null";
        }
    },
  
    stringTypeFormatterOnlyValue: (params) => {
        if (params.value != null && params.value != "null" && params.value != undefined && params.value != '') {
            return params.value;
        }
        else
            return '-NA-';
    },
    stringTypeSortingFor3P: (param) => {
        if (param != null && param != "null" && param != undefined && param != '') {
            if (param === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName)
                return '-NA-';
            else
                return param;
        }
        else
            return '-NA-';
    },
    stringTypeFormatterFor3PforDryAndChassis: (params) => {
        if (params.data != null && params.data != "null" && params.data != undefined && params.data != '' && params.data != '-NA-') {
            if (params.data.customername === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName)
                    return '-NA-';
                else
                return '<span title ="' + params.data.customername + '">' + params.data.customername + '</span>';
            }
            else
                return '-NA-';
        },
    stringTypeFormatterFor3P: (params) => {
        if (params.value != null && params.value != "null" && params.value != undefined && params.value != '' && params.value != '-NA-') {
            if (params.value === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName)
                return '-NA-';
            else
                return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '-NA-';
    },
    stringTypeFormatterFor3PForFilter: (params) => {
        if (params.data != null && params.data != "null" && params.data != undefined && params.data != '') {
            if (params.data.CustomerName === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName)
                return '-NA-';
            else
                return params.data.CustomerName;
        }
        else
            return '-NA-';
    },
    stringTypeFormatterFor3PExcel: (params) => {
        if (params != null && params != "null" && params != undefined && params != '') {
            if (params === JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName)
                return '-NA-';
            else
                return params;
        }
        else
            return '-NA-';
    },
    MNCTypeFormatter: (params) => {
        if (params.value != null && params.value != undefined) {
            return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '-NA-';
    },

    GeofenceTypeGrouping: (param) => {
        if (param != null && param != undefined) {
            switch (param.toString().toUpperCase().trim()) {
                case "B":
                    return "Server Geofence";
                case "D":
                    return "Device Geofence";
                case "R":
                    return "Region Geofence";
            }
        }

        return "*No Geofence Type";
    },

    GeofenceTypeFormatterForFilter: (params) => {
        if (params != null && params != undefined && params.data != null && params.data != undefined && params.data.GeofenceCategoryCd != null && params.data.GeofenceCategoryCd != undefined) {
            switch (params.data.GeofenceCategoryCd.toString().toUpperCase().trim()) {
                case "B":
                    return "Server Geofence";
                case "D":
                    return "Device Geofence";
                case "R":
                    return "Region Geofence";                
            }
        }
        return "-NA-";
    },

    fenceTypeFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value != '') {
            if (params.value.toString().trim() == "D")
                return "Device Geofence";
            else if (params.value.toString().trim() == "R")
                return "Region Geofence";
            else if (params.value.toString().trim() == "B")
                return "Server Geofence";
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },
    fenceTypeFormatterForExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params == "D")
                return "Device Geofence";
            else if (params == "R")
                return "Region Geofence";
            else if (params == "B")
                return "Server Geofence";
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },
    stringTypeFormatterChildForms: (params) => {
        
        if (params != null && params != "null" && params != undefined && params != '') {
            return "\t" + params;
        }
        //else if (params.data != null && params.data != "null" && params.data != undefined && params.data != '') {
        //    return '-NA-';
        //}
        else
            return '';
    },
    stringTypeFormatterChildFormsNew: (params) => {

        if (params != null && params != "null" && params != undefined && params != '') {
            return "\t" + params;
        }
        else if (params.data != null && params.data != "null" && params.data != undefined && params.data != '') {
            return '-NA-';
        }
        else
            return '';
    },
    DimiRemainTermGrouping: (params) => {
        if (params != null && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '*No OEM PTI term rem (d)';
    },
    DimiTermTermGrouping: (params) => {
        if (params != null && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '*No OEM PTI term (d)';
    },
    OEMPTITypeFormatter(params) {
        var returnValue = '';

        if (params != null && params != "null" && params != undefined && params != '') {

            returnValue = params.toUpperCase().trim() == "FULLPTI" ? "Full PTI" : params.toUpperCase().trim() == "SHORTPTI" ? "Short PTI" : params;

            return returnValue;
        }
        else
            return '-NA-';
    },
    stringTypeFormatterChildFormsForCopy: (params) => {

        if (params != null && params != "null" && params != undefined && params != '') {
            return params;
        }
        else if (params.data != null && params.data != "null" && params.data != undefined && params.data != '') {
            return '-NA-';
        }
        else
            return '';
    },

    PTIStateforExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params == "P" || params == "4") {
                params = "Pending";
                return "\t" + params;
            }
            else if (params == "C") {
                params = "Success";
                return "\t" + params;
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },
    reeferCommsFormatter: (params) => {
        if (params.value != null) {
            if (params.value.toString().toUpperCase().trim() == "TRUE")
                return "True";
            else
                return "False";
        }
        else
            return '-NA-';
    },
    GuestReeferModeFormatter: (params) => {
        if (params.value != null) {
            if (params.value.toString().toUpperCase().trim() == "TRUE")
                return "Guest";
            else
                return "Standard";
        }
        else
            return 'Standard';
    },
    GuestReeferModeFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.DeviceConfig != null && params.data.DeviceConfig != undefined && params.data.DeviceConfig != '') {
            if (params.data.DeviceConfig.toString().toUpperCase().trim() == "TRUE")
                return "Guest";
            else
                return "Standard";
        }
        else
            return 'Standard';
    },
    GuestReeferModeGrouping: (params) => {
        if (params != null) {
            if (params.toString().toUpperCase().trim() == "TRUE")
                return "Guest";
            else
                return "Standard";
        }
        else
            return 'Standard';
    },
    CommentExistsGrouping: (params) => {
        if (params != null && params != '-NA-') {
            if (params.toString() == "0")
                return '<span class="reefer-alert"><img src=' + GroupChat + ' title="yes"></img></span>' + " " + "<span class='aggrid-CellSignal'>yes</span>";
            else
                return "*No Comments";
        }
        else
            return '*No Comments';
    },
   
    
    
    LoadedFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param.toString().toUpperCase().trim() == "TRUE")
                return "Loaded";
            else
                return "Empty";
        }
        return "*No Loaded";
    },
    LoadedFormatterForExcel: (params) => {
        if (params != null) {
            if (params.toString().toUpperCase().trim() == "TRUE")
                return "Loaded";
            else
                return "Empty";
        }
        else
            return '-NA-';
    }, 
   
   
    BrakeSignalFormatterForExcel: (params) => {

        return "-NA-";
    },
    
    
    DoorFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return "Open";
            else if (param == 2)
                return "Closed";
            else if (param == 3)
                return "Unknown"
            else if (param == 4)
                return "No Sensor"
            else if (param == 5)
                return "*No Door"
        }        
    },
    //RCNG-2369
    Door1FormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param == 1 || param == "OPN")
                return "Open";
            else if (param == 2 || param == "CLS")
                return "Closed";
            else if (param == 3 || param == "DIS")
                return "Sensor Error"
            else if (param == 4 || param == "UNP")
                return "No Sensor"
            else if (param == 5 || param == "UNK")
                return "*No Door"
        }
    },
    DeviceDoorFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return "Open";
            else if (param == 2)
                return "Closed";
            else if (param == 5)
                return "Unknown";
            else if (param == 3)
                return "Sensor Error";
            else if (param == 4)
                return "No Sensor";
            else if (param == 6)
                return "*No Door";
        }
    },
    DeviceDoorFormatterExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return "Open";
            else if (param == 2)
                return "Closed";
            else if (param == 5)
                return "Unknown";
            else if (param == 3)
                return "Sensor Error";
            else if (param == 4)
                return "No Sensor";
            else if (param == 6)
                return "-NA-";
        }
    },
    DoorFormatterExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return "Open";
            else if (param == 2)
                return "Closed";
            else if (param == 3)
                return "Unknown"
            else if (param == 4)
                return "No Sensor"
            else if (param == 5)
                return "-NA-"
        }
    },
    //RCNG-2369
    Door1FormatterExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == 1 || param == "OPN")
                return "Open";
            else if (param == 2 || param == "CLS")
                return "Closed";
            else if (param == 3 || param == "DIS")
                return "Sensor Error"
            else if (param == 4 || param == "UNP")
                return "No Sensor"
            else if (param == 5 || param == "UNK")
                return "-NA-"
        }
    },

   
    DoorFormatterChassis: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.HasDoorSensor != null && params.data.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.data.Door1OpenChassis != null) {
                    if (params.data.Door1OpenChassis.toString().toUpperCase().trim() == "TRUE")
                        return "Open";                   
                    else
                        return "Closed";
                }
                else
                    return "Unknown";
            }
            else
                return "No Sensor";
        }
        else
            return '-NA-';
    },
    DoorFormatterChassisforExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.HasDoorSensor != null && params.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.Door1OpenChassis != null) {
                    if (params.Door1OpenChassis.toString().toUpperCase().trim() == "TRUE")
                        return "Open";                    
                    else
                        return "Closed";
                }
                else
                    return "Unknown";
            }
            else
                return "No Sensor";
        }
        else
            return '-NA-';
    },

    isOnVesselFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value != '') {

            if (params.value)
                return "V";
            else
                return "";
        }

        return "";
    },
    isOnVesselFormatterChildForms: (params) => {
        if (params != null && params != undefined && params != '') {

            if (params)
                return "V";
            else
                return "";
        }

        return "";
    },
    commandTypeFormatter: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";

        if (params.value != null && params.value != undefined && params.value != '') {
            if (params.value) {

                var imageElement = document.createElement("img");
                imageElement.src = bulletcommand;
                element.appendChild(imageElement);

                return element;
            }
            else
                return element;
        }

        return element;
    },
    // Commented for WI-24141 Reefer Run State Change
    //runStateFormatter: (params) => {
    //    var element = document.createElement("span");
    //    element.className = "reefer-alert";

    //    if (params.value != null && params.value != undefined) {
    //        var imageElement = document.createElement("img");

    //        switch (params.value.toString().trim()) {
    //            case '1':
    //                imageElement.src = "../images/Status/RunState/Reporting.png";
    //                break;
    //            case '2':
    //                imageElement.src = "../images/Status/RunState/Last-Reported-Running.png";
    //                break;
    //            case '3':
    //                imageElement.src = "../images/Status/RunState/Last-Reported-Stopped.png";
    //                break;
    //            case '4':
    //                imageElement.src = "../images/Status/RunState/Stopped.png";
    //                break;
    //            case '5':
    //                imageElement.src = "../images/Status/RunState/Stopped.png";
    //                break;
    //        }

    //        element.appendChild(imageElement);
    //    }

    //    return element;
    //},
    //runStateFormatterforExcel: (params) => {
    //    var valueString = "";
    //    if (params != null) {
    //        if (params == 1)
    //            valueString = "1-Running, reporting on schedule";
    //        else if (params == 2)
    //            valueString = "2-Missed reporting, were running";
    //        else if (params == 3)
    //            valueString = "3-stopped, reporting on schedule";
    //        else if (params == 4)
    //            valueString = "4-Missed reporting, were stopped";
    //        else if (params == 5)
    //            valueString = "5-Missed reporting, were stopped";
    //        else
    //            valueString = "";
    //    }
    //    else
    //        valueString = "";
    //    return valueString;
    //},

    //Added for WI - 24141 Reefer Run State Change
    
    

    RunStateFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return '<span title="Faulty" class="fas fa-power-off GridIcons orangetext"></span>' + " " + '<span class="aggrid-run">Faulty</span>';

            else if (param == 2)
                return '<span title="Running" class="fas fa-power-off GridIcons greenText"></span>' + " " + '<span class="aggrid-run">Running</span>';

            else if (param == 3)
                return '<span title="Standby" class="fas fa-power-off GridIcons greytext"></span>' + " " + '<span class="aggrid-run">Standby</span>';

            else if (param == 4)
                return '<span title="Offline" class="fas fa-horizontal-rule"></span>' + " " + '<span class="ps-1">Offline</span>';
            else
                return '*No Run';
        }
    },

    AssetStateFormatterGrouping: (param) => {
        if (param != null && param != undefined && param != '') {
            if (param == "A") {
                return '<span class="ActiveRA"><img src=' + AssetStateActive + ' title="Active"></img></span>' + " " + "<span class='aggrid-Inv pl-10'>Active</span>";
            }
            else if (param == "D") {
                return '<span class="DisconnectedRA"><img src=' + AssetStateDisconnected + ' title="Disconnected"></img></span>' + " " + "<span class='aggrid-Inv'>Disconnected</span>";
            }
            else if (param == "R") {
                return '<span class="RetiredRA"><img src=' + AssetStateRetired + ' title="Retired"></img></span>' + " " + "<span class='aggrid-Inv pl-10'>Retired</span>";
            }
        }
        return "*No INV";
    },
    RunStateFormatterGroupingForExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return 'Faulty';

            else if (param == 2)
                return 'Running';

            else if (param == 3)
                return 'Standby';

            else if (param == 4)
                return 'Offline';
            else
                return '-NA-';
        }
    },

    AssetStateFormatterGroupingForExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == "A")
                return 'Active';

            else if (param == "D")
                return 'Disconnected';

            else if (param == "R")
                return 'Retired';
            else
                return '-NA-';
        }
    },

    runStateFormatterforExcel: (params) => {
        var valueString = "";
        if (params != null && params != undefined) {
            if (params == "I")
                valueString = "Running";
            else if (params == "S")
                valueString = "Standby";
            else if (params == "X")
                valueString = "Faulty";
            else if (params == "O")
                valueString = "Offline";
            else
                valueString = "-NA-";
        }
        else
            valueString = "-NA-";
        return valueString;
    },
    
    
    PowerStateFormatterGrouping: (param) => {        
        if (param != null && param != undefined) {
            if (param == 1) {
                return '<span class="PlugSolid"><img src=' + PlugSolid + ' title="Powered"></img></span>' + " " + "<span class='aggrid-pwr'>Powered</span>";
            }
            else if (param == 2) {
                return '<span class="BatteryIndicator"><img src=' + BatteryIndicator + ' title="On Battery"></img></span>' + " " + "<span class='aggrid-pwr'>On Battery</span>";
            }
            else if (param == 3) {
                return '<span class="DualColorBattery"><img src=' + DualColorBattery + ' title="Charging"></img></span>' + " " + "<span class='aggrid-pwr'>Charging</span>";
            }
            else if (param == 4) {
                return '<span class="pwr_grid_icon"><img src=' + batterycritical + ' title="Critical"></img></span>' + " " + "<span class='aggrid-pwr'>Critical</span>";
            }
            else if (param == 5) {
                return '<span class="pwr_grid_icon"><img src=' + batterylow + ' title="Low"></img></span>' + " " + "<span class='aggrid-pwr'>Low</span>";
            }
            else if (param == 6) {
                return '<span class="pwr_grid_icon"><img src=' + batterynormal + ' title="Normal"></img></span>' + " " + "<span class='aggrid-pwr'>Normal</span>";
            }
            else
                return "*No PWR";
        }
    },
    PowerStateFormatterGroupingForExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == 1) {
                return 'Powered';
            }
            else if (param == 2) {
                return 'On Battery';
            }
            else if (param == 3) {
                return 'Charging';
            }
            else if (param == 4) {
                return 'Critical';
            }
            else if (param == 5) {
                return 'Low';
            }
            else if (param == 6) {
                return 'Normal';
            }
            else if (param == 7)
                return '*No PWR'
        }
    },

    GPSCoordsFormatterGrouping: (value, param) => {     
          if (param != null && param != undefined) {            
               
       if (value != null && value != undefined) {
            if (value == -1000) {
                return "*No GPS Coords";
            }
            else
                return value;
        }
}
    },
 
    GPSCoordsFormatterForExcel: (value, param) => {
        if (param != null && param != undefined) {            
               
       if (value != null && value != undefined) {
            if (value == -1000) {
                return "*No GPS Coords";
            }
            else
                return value;
        }
}
    },
    GPSCoordsFormatterForGrid: (value) => {
        if (value != null && value != undefined) {
            if (value == -1000) {
                return "-NA-";
            }
            else
                return value;
        }
    },

    GPSCoordsFormatterGroupingForExcel: (param) => {
        if (param != null && param != undefined) {
            if (param.node.data.GPSCoords != null && param.node.data.GPSCoords != undefined) {
                if (param.node.data.GPSCoords.toString().trim() != "" && param.node.data.GPSCoords != '-1000') {
                    var tempRoundingValue = "6";
                    if (param.node.data.GPSCoords != null && param.node.data.GPSCoords != undefined && param.node.data.GPSCoords.toString().trim() != "") {
                        var lstCoordinatePoints = param.node.data.GPSCoords.split(',');
                        var lat = parseFloat(lstCoordinatePoints[0].toString());
                        var long = parseFloat(lstCoordinatePoints[1].toString());
                        var paramValue = parseFloat(lat.toFixed(parseInt(tempRoundingValue)).toString()) + "," + parseFloat(long.toFixed(parseInt(tempRoundingValue)).toString());
                        return paramValue;
                    }
                    else
                        return '-NA-';
                }
                else
                    return '-NA-';
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },
        
    ChassisPwrStateFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            switch (param.toString()) {
                case "1":
                    return '<span class="PlugSolid"><img src=' + PlugSolid + ' title="Powered"></img></span>' + " " + "<span class='aggrid-pwr'>Powered</span>";
                case "2":
                    return '<span class="PlugSolid"><img src=' + UnPlug + ' title="On Battery"></img></span>' + " " + "<span class='aggrid-pwr'>On Battery</span>";
                case "3":
                    return '*No PWR';
            }
        }
    },

    ChassisBatteryStatusFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            switch (param.toString()) {
                case "1":
                    return '<span class="BatteryIndicator"><img src=' + batterycritical + ' title="Critical"></img></span>' + " " + "<span class='aggrid-pwr'>Critical</span>";
                case "2":
                    return '<span class="BatteryIndicator"><img src=' + batterylow + ' title="Low"></img></span>' + " " + "<span class='aggrid-pwr'>Low</span>";
                case "3":
                    return '<span class="BatteryIndicator"><img src=' + batterynormal + ' title="Normal"></img></span>' + " " + "<span class='aggrid-pwr'>Normal</span>";
                case "-1":
                    return '*No BATT';
            }
        }
    },

    ChassisBatteryStatusFormatterGroupingExcel: (param) => {
        if (param != null && param != undefined) {
            switch (param.toString()) {
                case "1":
                    return 'Critical';
                case "2":
                    return 'Low';
                case "3":
                    return 'Normal';
                case "-1":
                    return '*No BATT';
            }
        }
    },

    ChassisBatteryStatusFormatterForExcel: (params) => {
        var batt = '';
        if (params != null && params != undefined) {
            switch (params.toString().toUpperCase().trim()) {
                case "C":
                    batt = "Critical";
                    break;
                case "L":
                    batt = "Low";
                    break;
                case "N":
                    batt = "Normal";
                    break;
            }
        }
        else batt = "-NA-";
        return batt;
    },

    DryBatteryStatusFormatterGrouping: (param) => {
        if (param != null && param != undefined) {            
            switch (param.toString()) {
                case "1":
                    return '<span class="BatteryIndicator"><img src=' + batterycritical + ' title="Critical"></img></span>' + " " + "<span class='aggrid-pwr'>Critical</span>";                    
                case "2":
                    return '<span class="BatteryIndicator"><img src=' + batterylow + ' title="Low"></img></span>' + " " + "<span class='aggrid-pwr'>Low</span>";
                case "3":
                    return '<span class="BatteryIndicator"><img src=' + batterynormal + ' title="Normal"></img></span>' + " " + "<span class='aggrid-pwr'>Normal</span>";
                case "-1":
                    return '*No BATT';
            }
        }
    },
    DryPwrStateFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            switch (param.toString()) {
                case "1":
                    return '<span class="PlugSolid"><img src=' + PlugSolid + ' title="Powered"></img></span>' + " " + "<span class='aggrid-pwr'>Powered</span>";
                case "2":
                    return '<span class="PlugSolid"><img src=' + UnPlug + ' title="On Battery"></img></span>' + " " + "<span class='aggrid-pwr'>On Battery</span>";
                case "3":
                    return '*No PWR';
            }
        }
    },
    DryPwrStateFormatterGroupingExcel: (param) => {
        if (param != null && param != undefined) {
            switch (param.toString()) {
                case "1":
                    return 'Critical';
                case "2":
                    return 'Low';
                case "3":
                    return 'Normal';
                case "-1":
                    return '*No PWR';
            }
        }
    },
    dryPwrStateFormatterForExcel: (params) => {
        var Power = '';
        if (params != null && params != undefined) {
            switch (params.toString().toUpperCase().trim()) {
                case "C":
                    Power = "Critical";
                    break;
                case "L":
                    Power = "Low";
                    break;
                case "N":
                    Power = "Normal";
                    break;
            }
        }
        else Power = "-NA-";
        return Power;
    },
    pwrStateFormatterforExcel: (params) => {
        var valueString = "";
        if (params.DeviceTypeCd != null && params.DeviceTypeCd != undefined && params.DeviceTypeCd.toString().toUpperCase().trim() == "GT1200") {
            if (params.DevicePowerSourceCd == "C")
                valueString = "Critical";
            else if (params.DevicePowerSourceCd == "L")
                valueString = "Low";
            else
                valueString = "Normal";
        }
        else if (params.DevicePowerSourceCd != null) {
            if (params.DevicePowerSourceCd == "B")
                valueString = "On Battery";
            else if (params.DeviceType.toString().toUpperCase().trim() == "TRUE" && params.DevicePowerSourceCd.toString().toUpperCase().trim() == "A")
                valueString = "Charging";
            else
                valueString = "Powered";
        }
        else
            valueString = "-NA-";
        return valueString;
    },
    
    pwrStateFormatterChassisforExcel: (params) => {        
        var Power = '-NA-';
        if (params != null && params != undefined) {
            switch (params.toString().toUpperCase().trim()) {
                case "A":
                case "1":
                    Power = "Powered";
                    break;
                case "B":
                case "2":
                    Power = "On Battery";
                    break;
            }
        }
        else Power = "-NA-";
        return Power;
    },

    FuelSensorGrouping: (param) => {
        if (param != null && param != undefined && param != '') {
            switch (param.toString()) {
                case "0": return "No Sensor";
                case "1": return "Config Error";
                case "2": return "Not Configured";
                case "3": return "Present";
                case "4": return "Sensor Error";
                case "5": return "Unknown";
                default:
                    return "*No Fuel Sensor";
            }           
        }
        return "*No Fuel Sensor";
    },

    FuelLevelGalGrouping: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params < 0) {
                switch (params.toString()) {
                    case "-6": return "No Sensor";
                    case "-5": return "Config Error";
                    case "-4": return "Not Configured";
                    case "-3": return "Sensor Error";
                    case "-2": return "Sensor Error";
                    case "-1": return "Unknown";
                    default:
                        return "*No Fuel Level (gal.)";
                }
            }
            else
                return params;
        }
    },

    EngineSortingFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param == "0")
                return '<span class="reefer-alert"><img src=' + NotRunning + ' title="NO"></img></span>' + " " + "<span class='aggrid-CellSignal'>NO</span>";
            else if (param == "1")
                return '<span class="reefer-alert"><img src=' + Running + ' title="YES"></img></span>' + " " + "<span class='aggrid-CellSignal'>YES</span>";
            //else
            //    return "-NA-";
        }
        return "*No ENG";
    },
    EngineSortingFormatterGroupingExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == "0")
                return 'NO';
            else if (param == "1")
                return 'YES';
            //else
            //    return "-NA-";
        }
        return "*No ENG";
    },

    //Added for WI - 24141 Reefer Run State Change
    CommentExistsforExcel: (params) => {
        var valueString = "";
        if (params != null)
            valueString = (params == 0) ? "Yes" : "No";
        else
            valueString = "";
        return valueString;
    },
    PossibleDamageForExcel: (params) => {
        var valueString = "-NA-";
        if (params == 'Check')
            valueString = 'Check';
        else if(params == 'Clear')
            valueString = 'Clear';
        else
            valueString = "-NA-";
        return valueString;
    },
    CommandValidator: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";
        if (params.value != null && params.value != undefined) {
            var imageElement = document.createElement("img");

            switch (params.value.toString().trim()) {
                case 'E':
                    imageElement.src = ImgPending1;
                    break;
                case 'W':
                    imageElement.src = ImgWarning1;
                    break;
                default:
                    imageElement.src = ImgSuccess1;
                    break;

            }
            element.appendChild(imageElement);
        }

        return element;
    },
   
 
    OEMTypeValueFormatter: (param) => {
        var oemType = "-NA-";

        if (param != null && param != undefined && param !="") {
            switch (param.toString().toUpperCase().trim()) {
                case "C":
                    oemType = "CAR";
                    break;
                case "D":
                    oemType = "DKN";
                    break;
                case "S":
                    oemType = "SC";
                    break;
                case "T":
                    oemType = "TK";
                    break;
                case "G":
                    oemType = "GMK";
                    break;
                case "TA":
                    oemType = "TLR";
                    break;
                case "U":
                    oemType = "UNK";
                    break;
                case "CARRIER":
                    oemType = "CAR";
                    break;
                case "DAIKIN":
                    oemType = "DKN";
                    break;
                case "STARCOOL":
                    oemType = "SC";
                    break;
                case "THERMOKING":
                    oemType = "TK";
                    break;
                case "GENMARK":
                    oemType = "GMK";
                    break;
                case "TAYLOR":
                    oemType = "TLR";
                    break;
                case "UNKNOWN":
                    oemType = "UNK";
                    break;
                default:
                    oemType = '-NA-';
            }
        }
        return oemType;
    },

    
    oemTypesorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != undefined && params.data != null) {
                if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != undefined) {
                    return params.data.ReeferOEMTypeCd;
                }
            }
        }
        return '-NA-';
    },
    oemTypeFormatter: (params) => {
        var oemType = '';
        if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != undefined && params.data.ReeferOEMTypeCd != '-NA-') {
            switch (params.data.ReeferOEMTypeCd.toString().toUpperCase().trim()) {
                case "C":
                    oemType = "CAR";
                    break;
                case "D":
                    oemType = "DKN";
                    break;
                case "S":
                    oemType = "SC";
                    break;
                case "T":
                    oemType = "TK";
                    break;
                case "G":
                    oemType = "GMK";
                    break;
                case "TA":
                    oemType = "TLR";
                    break;
                case "U":
                    oemType = "UNK";
                    break;
                case "CARRIER":
                    oemType = "CAR";
                    break;
                case "DAIKIN":
                    oemType = "DKN";
                    break;
                case "STARCOOL":
                    oemType = "SC";
                    break;
                case "THERMOKING":
                    oemType = "TK";
                    break;
                case "GENMARK":
                    oemType = "GMK";
                    break;
                case "TAYLOR":
                    oemType = "TLR";
                    break;
                case "UNKNOWN":
                    oemType = "UNK";
                    break;
            }
        }
        else oemType = "-NA-";
        return oemType;
    },

    OEMTypeFormatterGrouping: (param) => {

        if (param != null && param != undefined) {          
            switch (param.toString().toUpperCase().trim()) {
                case "CARRIER":
                case "CAR":
                    return "CARRIER";
                case "DAIKIN":
                case "DKN":
                    return "DAIKIN";
                case "STARCOOL":
                case "SC":
                    return "STAR COOL";
                case "TK":
                case"THERMOKING":
                    return "THERMOKING";
                case "GENMARK":
                case "GMK":
                    return "GENMARK";
                case "TAYLOR":
                case "TLR":
                    return "TAYLOR";
                case "UNKNOWN":
                case "UNK":
                    return "UNKNOWN";
                case "OEM_KLINGE":
                case "KLINGE":
                    return "KLINGE";
                default:
                    return "*No OEM";
            }
        }
        return "*No OEM";
    },
    AssetTypeFormatter: (params) => {
        //var AssetType = '';
        if (params.value != null && params.value != undefined) {
            switch (params.value.toString().toUpperCase().trim()) {
                case "G":
                    return "Genset";
                case "D":
                    return "Dry";
                case "R":
                    return "Reefer";
                case "C":
                    return "Chassis";
                case "O":
                    return "Orphan";
            }
        }
        return "-NA-";
    },

    AssetTypeGrouping: (param) => {
        if (param != null && param != undefined) {
            switch (param.toString().toUpperCase().trim()) {
                case "G":
                    return "Genset";
                case "D":
                    return "Dry";
                case "R":
                    return "Reefer";
                case "C":
                    return "Chassis";
                case "O":
                    return "Orphan";
            }
        }

        return "*No Asset Type";
    },

    AssetTypeFormatterForFilter: (params) => {
        if (params != null && params != undefined && params.data != null && params.data != undefined && params.data.AssetType != null && params.data.AssetType != undefined) {
            switch (params.data.AssetType.toString().toUpperCase().trim()) {
                case "G":
                    return "Genset";
                case "D":
                    return "Dry";
                case "R":
                    return "Reefer";
                case "C":
                    return "Chassis";
                case "O":
                    return "Orphan";
            }
        }
        return "-NA-";
    },
    AssetTypeFormatterForExcel: (params) => {
        var AssetType = '';
        if (params != null && params != undefined && params != "-NA-") {
            switch (params.toString().toUpperCase().trim()) {
                case "G":
                case "GENSET":
                    AssetType = "Genset";
                    break;
                case "D":
                case "DRY":
                    AssetType = "Dry";
                    break;
                case "R":
                case "REEFER":
                    AssetType = "Reefer";
                    break;
                case "C":
                case "CHASSIS":
                    AssetType = "Chassis";
                    break;
                case "O":
                case "ORPHAN":
                    AssetType = "Orphan";
                    break;
            }
        }
        else AssetType = "-NA-";
        return AssetType;
    },
    RSSITypeFormatter: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";
        var imageElement = document.createElement("img");
        if (params.data != null && params.data != undefined) {//WI-21812:For Unknown RSSI Id image is not showing
            if (params.data.RSSI != null && params.data.RSSI != undefined) {
                if (params.data.RSSI == 0)
                    imageElement.src = RSSIUNK;
                else if (params.data.RSSI <= -111)
                    imageElement.src = RSSI1;
                else if (params.data.RSSI >= -110 && params.data.RSSI <= -100)
                    imageElement.src = RSSI2;
                else if (params.data.RSSI >= -99 && params.data.RSSI <= -88)
                    imageElement.src = RSSI3;
                else if (params.data.RSSI >= -87 && params.data.RSSI <= -76)
                    imageElement.src = RSSI4;
                else if (params.data.RSSI >= -75)
                    imageElement.src = RSSI5;
                else
                    imageElement.src = RSSIUNK;
            }
            else
                imageElement.src = RSSIUNK;//WI-21812:For Unknown RSSI Id image is not showing
        }        

        element.appendChild(imageElement);

        return element;
    },
    RSSITypeFormatterFilter: (params) => {
        var returnValue = "";
        if (params.data != null && params.data != undefined) {//WI-21812:For Unknown RSSI Id image is not showing
            if (params.data.RSSI != null && params.data.RSSI != undefined) {
                if (params.data.RSSI == 0)
                    returnValue = "Unknown";
                else if (params.data.RSSI <= -111)
                    returnValue = "1 Bar";
                else if (params.data.RSSI >= -110 && params.data.RSSI <= -100)
                    returnValue = "2 Bars";
                else if (params.data.RSSI >= -99 && params.data.RSSI <= -88)
                    returnValue = "3 Bars";
                else if (params.data.RSSI >= -87 && params.data.RSSI <= -76)
                    returnValue = "4 Bars";
                else if (params.data.RSSI >= -75)
                    returnValue = "5 Bars";
                else
                    returnValue = "Unknown";
            }
            else
                returnValue = "Unknown";//WI-21812:For Unknown RSSI Id image is not showing
        }        

        return returnValue;
    },
    RSSISorting: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.RSSI != null && params.data.RSSI != undefined) {
                if (params.data.RSSI == 0)
                    return "6";
                else if (params.data.RSSI <= -111)
                    return "5";
                else if (params.data.RSSI >= -110 && params.data.RSSI <= -100)
                    return "4";
                else if (params.data.RSSI >= -99 && params.data.RSSI <= -88)
                    return "3";
                else if (params.data.RSSI >= -87 && params.data.RSSI <= -76)
                    return "2";
                else if (params.data.RSSI >= -75)
                    return "1";
                else
                    return "6";
            }
            else
                return "6";
        }        
    },
    RSSIFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return '<span class="reefer-alert"><img src=' + RSSI5 + ' title="5 Bars"></img></span>' + " " + "<span class='aggrid-CellSignal'>5 Bars</span>";
            else if (param == 2)
                return '<span class="reefer-alert"><img src=' + RSSI4 + ' title="4 Bars"></img></span>' + " " + "<span class='aggrid-CellSignal'>4 Bars</span>";
            else if (param == 3)
                return '<span class="reefer-alert"><img src=' + RSSI3 + ' title="3 Bars"></img></span>' + " " + "<span class='aggrid-CellSignal'>3 Bars</span>";
            else if (param == 4)
                return '<span class="reefer-alert"><img src=' + RSSI2 + ' title="2 Bars"></img></span>' + " " + "<span class='aggrid-CellSignal'>2 Bars</span>";
            else if (param == 5)
                return '<span class="reefer-alert"><img src=' + RSSI1 + ' title="1 Bar"></img></span>' + " " + "<span class='aggrid-CellSignal'>1 Bar</span>";
            else
                return '<span class="reefer-alert"><img src=' + RSSIUNK + ' title="Unknown"></img></span>' + " " + "<span class='aggrid-CellSignal'>Unknown</span>";
        }
    },
    RSSIFormatterGroupingForExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return '5 Bars';
            else if (param == 2)
                return '4 Bars';
            else if (param == 3)
                return '3 Bars';
            else if (param == 4)
                return '2 Bars';
            else if (param == 5)
                return '1 Bar';
            else
                return 'Unknown';
        }
    },
    ChassisPWRFormatterGroupingForExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return 'Powered';
            else if (param == 2)
                return 'On Battery';
            else if (param == 3)
                return '*No PWR';
        }
    },

    CommentExistsFormatter: (params) => {
        var element = document.createElement("span");
        element.className = "Trip-edit";

        if (params.value != null && params.value != undefined && params.value != '-NA-') {
            var imageElement = document.createElement("img");
            if (params.value == 0) {
                imageElement.src = GroupChat;
                element.appendChild(imageElement);
                return element;
            }
            else
                return "-NA-";
        }
        return "-NA-";
    },
    CommentExistsSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.CommentExists != null && params.data.CommentExists != undefined) {
                if (params.data.CommentExists == 0) {
                    return 0;
                }
                else
                    return '-NA-';
            }
        }

    },
   
    statusIndicator: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";
        if (params.value != null && params.value != undefined && params.value != '') {
            var imageElement = document.createElement("img");
            switch (params.value.trim()) {
                case '1':
                    imageElement.src = High;
                    break;
                case '2':
                    imageElement.src = Medium;
                    break;
                case '3':
                    imageElement.src = Low;
                    break;

            }

            element.appendChild(imageElement);
        }

        return element;
    },
   
    
    TripStatusFormatterGrouping: (param) => {
        var deviationFlg = '';
        if (param != null && param != undefined) {
            var valueString = param.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        return '<span class="reefer-alert"><img src=' + TripInprogress + ' title="In Progress"></img></span>' + " " + "<span class='ps-1'>In Progress</span>";
                    case 'C':
                        if (deviationFlg == "True")
                            return '<span class="reefer-alert"><img src=' + TripCompletedDeviation + ' title="Completed Deviation"></img></span>' + " " + "<span class='ps-1'>Completed Deviation</span>";
                        else
                            return '<span class="reefer-alert"><img src=' + TripCompleted + ' title="Completed"></img></span>' + " " + "<span class='ps-1'>Completed</span>";
                            
                    case 'D':
                        return '<span class="reefer-alert"><img src=' + TripProblemetic + ' title="Problemetic"></img></span>' + " " + "<span class='ps-1'>Problemetic</span>";
                    case 'P':
                        return '<span class="reefer-alert"><img src=' + TripPending + ' title="Pending"></img></span>' + " " + "<span class='ps-1'>Pending</span>";
                    case 'R':
                        return '<span class="reefer-alert"><img src=' + TripDeleted + ' title="Deleted"></img></span>' + " " + "<span class='ps-1'>Deleted</span>";
                    case 'X':
                        if (deviationFlg == "True")
                            return '<span class="reefer-alert"><img src=' + TripCancelDeviation + ' title="Cancel Deviation"></img></span>' + " " + "<span class='ps-1'>Cancel Deviation</span>";
                        else
                            return '<span class="reefer-alert"><img src=' + TripCancel + ' title="Cancel"></img></span>' + " " + "<span class='ps-1'>Cancel</span>";
                    default:
                        return "*No Trip";

                }
            }
            return "*No Trip";
        }
        return "*No Trip";
    },

    TripStatusFormatterGroupingForExcel: (param) => {
        var deviationFlg = '';
        if (param != null && param != undefined) {
            var valueString = param.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        return 'In Progress';
                    case 'C':
                        if (deviationFlg == "True")
                            return 'Completed Deviation';
                        else
                            return 'Completed';

                    case 'D':
                        return 'Problemetic';
                    case 'P':
                        return 'Pending';
                    case 'R':
                        return 'Deleted';
                    case 'X':
                        if (deviationFlg == "True")
                            return 'Cancel Deviation';
                        else
                            return 'Cancel';
                    default:
                        return "";
                }
            }
            return "";
        }
        return "";
    },
    statusIndicatorforALM: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";
        if (params.value != null && params.value != undefined && params.value != '') {
            var imageElement = document.createElement("img");

            switch (params.value.trim()) {
                case '1':
                    imageElement.src = HighALM;
                    break;
                case '2':
                    imageElement.src = MediumALM;
                    break;
            }
            element.appendChild(imageElement);
        }
        return element;
    },

    statusIndicatorforALR: (params) => {
        if (params.value != null && params.value != undefined) {
            switch (params.value.toString().trim()) {
                case "1":
                    params.value = '<span class="fas fa-exclamation-triangle grey-critical"></span>';
                    break;
                case "2":
                    params.value = '<span class="fas fa-exclamation-triangle red-critical"></span>';
                    break;
                case "3":
                    params.value = '<span class="fas fa-exclamation-triangle red-critical"></span>';
                    break;
                case "4":
                    params.value = '<span class="fas fa-info-circle yellow-critical"></span>';
                    break;
                case "5":
                    params.value = '<span class="fas fa-info-circle yellow-critical"></span>';
                    break;
            }
            return params.value;
        }
        else
            return '-NA-';
    },
    statusIndicatorWithDescriptionForALR: (params, alarmsList) => {
        if (params.value != null && params.value != undefined) {
            var title = "";
            if (alarmsList != null && alarmsList != undefined && alarmsList.length > 0) {
                var lstAlerts = params.data.Alerts.split(',');
                var _alarmsList = "";
                $.each(lstAlerts, function (index, item) {
                    if (item != "" && item != null) {
                        var alarmDescription = alarmsList.filter(e =>
                            e.AlertCD === item.toString().trim());
                        var _alarmDesc = alarmDescription.length > 0 ? alarmDescription[0].AlertDsc.toString() : "";
                        _alarmsList = _alarmsList != "" ? _alarmsList + "\n" + item.trim() + " - " + _alarmDesc : item.trim() + " - " + _alarmDesc;
                        title = _alarmsList;
                    }
                });
            }
            switch (params.value.toString().trim()) {
                case "1":
                    params.value = '<span class="fas fa-exclamation-triangle grey-critical" ' + 'title=' + '"' + title + '"' + '></span>';
                    break;
                case "2":
                    params.value = '<span class="fas fa-exclamation-triangle red-critical" ' + 'title=' + '"' + title + '"' + '></span>';
                    break;
                case "3":
                    params.value = '<span class="fas fa-exclamation-triangle red-critical" ' + 'title=' + '"' + title + '"' + '></span>';
                    break;
                case "4":
                    params.value = '<span class="fas fa-info-circle yellow-critical" ' + 'title=' + '"' + title + '"' + '></span>';
                    break;
                case "5":
                    params.value = '<span class="fas fa-info-circle yellow-critical" ' + 'title=' + '"' + title + '"' + '></span>';
                    break;
            }
            return params.value;
        }
        else {
            return '-NA-';
        }
    },
    StatusIndicatorALMFormatterGrouping: (param) => {
        if (param != null && param != undefined && param != '') {
            if (param == 1) {
                return '<span class="reefer-alert"><img src=' + HighALM + ' title="Severe"></img></span>' + " " + "<span class='aggrid-alm'>Severe</span>";                
            }
            else if (param == 2) {
                return '<span class="reefer-alert"><img src=' + MediumALM + ' title="Minor"></img></span>' + " " + "<span class='aggrid-alm'>Minor</span>";                
            }
            //else if (param == 3) {
            //    return "<span>Informational</span>";
            //}
        }
        return "*No ALM";
    },
    HumidityGrouping: (params) => {
        if (params.node.childrenAfterFilter[0].data != null && params.node.childrenAfterFilter[0].data != undefined && params.node.childrenAfterFilter[0].data != '') {
            if (params.node.childrenAfterFilter[0].data.Humidity != null && params.node.childrenAfterFilter[0].data.Humidity != '' && params.node.childrenAfterFilter[0].data.Humidity != '-NA-') {
                if (params.node.childrenAfterFilter[0].data.Humidity.toString().trim() == "0" || params.node.childrenAfterFilter[0].data.HumiditySetpointStatus == "O")
                    return "Off";
                else if (params.node.childrenAfterFilter[0].data.Humidity.toString().trim() == "-999")
                    return "OOR";
                else
                    return params.node.childrenAfterFilter[0].data.Humidity.toString();
            }
            return '*No RH read';
        }
        return '*No RH read';
    },
    sensorDataPCondGrouping: (params) => {
        if (params.node.childrenAfterFilter[0].data != null && params.node.childrenAfterFilter[0].data != undefined && params.node.childrenAfterFilter[0].data != '') {
            if (params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd != null && params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd != '') {
                if (params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd.trim() == 'C')
                    return '*No P cond';
                else {
                    if (params.node.childrenAfterFilter[0].data.CondenserPressure != null && params.node.childrenAfterFilter[0].data.CondenserPressure != '-NA-') {
                        if (params.node.childrenAfterFilter[0].data.CondenserPressure.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return params.node.childrenAfterFilter[0].data.CondenserPressure.toString();
                    }
                    else
                        return '*No P cond';
                }
            }
            return '*No P cond';
        }
        return '*No P cond';
    },
    sensorDataOpenExpGrouping: (params) => {
        if (params.node.childrenAfterFilter[0].data != null && params.node.childrenAfterFilter[0].data != undefined && params.node.childrenAfterFilter[0].data != '') {
            if (params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd != null && params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd != '') {
                if (params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd.trim() == 'C')
                    return '*No Open exp';
                else {
                    if (params.node.childrenAfterFilter[0].data.EvaporatorExpansionValveOpening != null && params.node.childrenAfterFilter[0].data.EvaporatorExpansionValveOpening != '-NA-') {
                        if (params.node.childrenAfterFilter[0].data.EvaporatorExpansionValveOpening.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return params.node.childrenAfterFilter[0].data.EvaporatorExpansionValveOpening.toString();
                    }
                    else
                        return '*No Open exp';
                }
            }
            return '*No Open exp';
        }
        return '*No Open exp';
    },
    sensorDataOpenSucGrouping: (params) => {
        if (params.node.childrenAfterFilter[0].data != null && params.node.childrenAfterFilter[0].data != undefined && params.node.childrenAfterFilter[0].data != '') {
            if (params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd != null && params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd != '') {
                if (params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd.trim() == 'C') {
                    return '*No Open suc.';
                }
                else {
                    if (params.node.childrenAfterFilter[0].data.SuctionModulationValveOpening != null && params.node.childrenAfterFilter[0].data.SuctionModulationValveOpening != '' && params.node.childrenAfterFilter[0].data.SuctionModulationValveOpening != '-NA-') {
                        if (params.node.childrenAfterFilter[0].data.SuctionModulationValveOpening.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return params.node.childrenAfterFilter[0].data.SuctionModulationValveOpening.toString();
                    }
                    else
                        return '*No Open suc.';
                }
            }
            return '*No Open suc.';
        }
        return '*No Open suc.';
    },
    ControlledAtmosphereModeGrouping: (params) => {
        if (params.node.childrenAfterFilter[0].data != null && params.node.childrenAfterFilter[0].data != '-NA-' && params.node.childrenAfterFilter[0].data != undefined && params.node.childrenAfterFilter[0].data != '') {
            if (params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd != null && params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd != '') {
                if (params.node.childrenAfterFilter[0].data.ReeferOEMTypeCd.trim() == 'S') {

                    if (params.node.childrenAfterFilter[0].data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "ON")
                        return "CA On";
                    else if (params.node.childrenAfterFilter[0].data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "OFF")
                        return "Off";
                    else if (params.node.childrenAfterFilter[0].data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "AV")
                        return "AV On";
                    else if (params.node.childrenAfterFilter[0].data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "AVPLUS")
                        return "AV+ On";
                    else
                        return params.node.childrenAfterFilter[0].data.ControlledAtmosphereMode.toString();
                }
                else if (params.node.childrenAfterFilter[0].data.ControlledAtmosphereMode.toString().toUpperCase().trim() == "UNITOFF")
                        return "Unit Off";
                    else
                    return params.node.childrenAfterFilter[0].data.ControlledAtmosphereMode.toString();
                }
                else
                return '*No Atm. Mode';
            }
            else
            return '*No Atm. Mode';
    },
    TripWiseExpirationGrouping: (params) => {
        if (params != null && params != "0") {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '*No TW Exp (d)';
    },
    //GPSCoordsGrouping: (params) => {
    //    if (params.node.childrenAfterFilter[0].data != null && params.node.childrenAfterFilter[0].data != undefined && params.node.childrenAfterFilter[0].data != '') {
    //        if (params.node.childrenAfterFilter[0].data.DeviceType != null && params.node.childrenAfterFilter[0].data.DeviceType != undefined && (params.node.childrenAfterFilter[0].data.DeviceType.toString().toUpperCase().trim() == "GT1200" || params.node.childrenAfterFilter[0].data.DeviceType.toString().toUpperCase().trim() == "GT1020")) {
    //            if (params.node.childrenAfterFilter[0].data.GPSCoords != null && params.node.childrenAfterFilter[0].data.GPSCoords != '-NA-')
    //                return params.node.childrenAfterFilter[0].data.GPSCoords;
    //            else
    //                return '-NA-';
    //        }
    //        else if (params.data.GPSLatitude != 0 && params.data.GPSLongitude != 0 && (params.data.GPSLockState == null || params.data.GPSLockState == '' || params.data.GPSLockState.toUpperCase() != "LOCKED")) {
    //            if (params.value != null && params.value != '-NA-') {
    //                params.value = '<i>' + params.value + '</i>';
    //                params.value = '<p style="color:#736F6E" >' + params.value + '</p>';
    //                return params.value;
    //            }
    //            else
    //                return '-NA-';
    //        }
    //        else
    //            return params.value;
    //    }
    //},
    RunningModeGrouping: (params) => {
        var valueString = "";
        if (params != null && params != undefined && params != '' && params !='-NA-') {
                valueString = params.replace('/^\s+/g', '');

                if (valueString.startsWith(",")) {
                    valueString = valueString.substring(1, valueString.length);
                }

                if (valueString.endsWith(",")) {
                    valueString = valueString.substring(0, valueString.length - 1);
                }

                return valueString;
            
        }
        return '*No Opr. Mode';

    },
    PTResultGrouping: (param) => {
        if (param != null && param != undefined && param != "null") {

            if (param == 'Passed') {
                return '<span title="Passed" class="fas fa-check GridIcons green-text-color"></span>' + " " + "<span class='ptTWpadding'>Passed</span>";
            }
            else if (param == 'Failed') {
                return '<span title="Failed" class="fas fa-exclamation GridIcons color-red"> </span>' + " " + "<span class='ptTWpadding'>Failed</span>";
            }
            else if (param == 'Aborted') {
                return '<span title="Expired" class="fas fa-times GridIcons orangetext"></span>' + " " + "<span class='ptTWpadding'>Aborted</span>";
            }
            else if (param == 'Running') {
                return '<span title = "Running" class="fas fa-history GridIcons black-text-color"></span>' + " " + "<span class='ptTWpadding'>Running</span>";
            }
            else if (param == 'Skipped') {
                return '<span title="Skipped" class="fas fa-step-forward GridIcons magenta-color-text"></span>' + " " + "<span class='ptTWpadding'>Skipped</span>";
            }
            else if (param == 'Unknown') {
                return '<span title = "Unknown" class="fas fa-question GridIconsQuestion black-text-color"> </span>' + " " + "<span class='ptTWpadding'>Unknown</span>";
            }

        }
        return "No PTResult";
    },
    statusIndicatorforALMforExcel: (params) => {        
        var valueString = "-NA-";
        if (params != null && params != undefined && params != '') {
            if (params == 1) {
                valueString = "Severe";
            }
            else if (params == 2) {
                valueString = "Minor";
            }
            else if (params == 3) {
                valueString = "Informational";
            }
        }

        return valueString;
    },
    statusIndicatorforALMforGrouping: (params) => {        
        var valueString = "-NA-";
        if (params != null && params != undefined && params != '') {
            if (params == 1) {
                valueString = "Severe";
            }
            else if (params == 2) {
                valueString = "Minor";
            }
        }

        return valueString;
    },
    statusIndicatorforALRforExcel: (params) => {
        var valueString = "-NA-";
        if (params != null && params != undefined && params != '') {
            if (params == 1) {
                valueString = "Unknown";
            }
            else if (params == 2) {
                valueString = "Fatal";
            }
            else if (params == 3) {
                valueString = "Critical";
            }
            else if (params == 4) {
                valueString = "Warning";
            }
            else if (params == 5) {
                valueString = "Information";
            }
        }
        return valueString;
    },
    rcdPowerSourceFormatter: (params) => {
        var rcdPwrSource = '';
        if (params.value != null && params.value != undefined && params.value != '') {
            switch (params.value.toString().toUpperCase().trim()) {
                case "A":
                    rcdPwrSource = "AC";
                    break;
                case "B":
                    rcdPwrSource = "Battery";
                    break;
            }
        }
        else
            rcdPwrSource = "-NA-";

        return rcdPwrSource;
    },
    //rcdPowerSourceFormatterforExcel: (params) => {
    //    var rcdPwrSource = '';
    //    if (params != null && params != undefined && params != '') {
    //        switch (params.toString().toUpperCase().trim()) {
    //            case "A":
    //                rcdPwrSource = "AC";
    //                break;
    //            case "B":
    //                rcdPwrSource = "Battery";
    //                break;
    //            case "1":
    //            case "2":
    //                rcdPwrSource = "True";
    //                break;
    //            default:
    //                rcdPwrSource = "False";
    //                break;
    //        }
    //    }
    //    else
    //        rcdPwrSource = "-NA-";

    //    return rcdPwrSource;
    //},
    rcdPowerSourceFormatterforExcel: (params) => {

        var valueString = "";
        if (params.DeviceType != null && params.DeviceType != undefined && params.DeviceType.toString().toUpperCase().trim() == "GT1200") {
            if (params.RcdPowerSourceCd == "C")
                valueString = "Critical";
            else if (params.RcdPowerSourceCd == "L")
                valueString = "Low";
            else
                valueString = "Normal";
        }
        else if (params.RcdPowerSourceCd != null) {
            if (params.RcdPowerSourceCd == "B")
                valueString = "On Battery";
            else if (params.DeviceType.toString().toUpperCase().trim() == "TRUE" && params.RcdPowerSourceCd.toString().toUpperCase().trim() == "A")
                valueString = "Charging";
            else
                valueString = "Powered";
        }
        else
            valueString = "-NA-";
        return valueString;

    },
    commandLogStatusFormatter: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";
        if (params != null && params != undefined) {
            if (params.data.Status != null && params.data.Status != undefined && params.data.Status != '') {
                var imageElement = document.createElement("img");

                switch (params.data.Status.toString().toUpperCase().trim()) {

                    case "UNKNOWN":
                        imageElement.src = UnknownStatus;
                        break;
                    case "ERROR":
                        imageElement.src = ErrorStatus;
                        break;
                    case "PENDING":
                        imageElement.src = PendingStatus;
                        break;
                    case "ISSUED":
                        imageElement.src = IssuedStatus;
                        break;
                    case "EXPIRED":
                        imageElement.src = ExpiredStatus;
                        break;
                    case "CANCELLED":
                        imageElement.src = CancelStatus;
                        break;
                    case "SUCCESS":
                        imageElement.src = SucessStatus;
                        break;
                    case "COMMANDACCEPTEDBYRCD":
                        imageElement.src = AcceptedStatus;
                        break;
                    case "REJECTED":
                        imageElement.src = RejectedStatus;
                        break;
                    case "DISCARDED":
                        imageElement.src = DiscardedStatus;
                        break;
                    case "RETRY":
                        imageElement.src = RetryStatus;
                        break;
                    case "COMMANDACCEPTEDBYBUSYRCD":
                        imageElement.src = AcceptedByBusyRCDStatus;
                        break;
                    case "AWAITINGPREREQUISITES":
                        imageElement.src = AwaitingPrerequisites;
                        break;
                    case "CANCELLATIONREQUEST":
                        imageElement.src = CancellationRequest;
                        break;
                    case "AWAITINGSYNC":
                        imageElement.src = PendingStatus;
                        break;
                    case "SENTTOVC":
                        imageElement.src = SendToVC;
                        break;
                    case "SYNCERROR":
                        imageElement.src = ErrorStatus;
                        break;
                    case "SYNCCANCELLED":
                        imageElement.src = CancelStatus;
                        break;
                    case "VALIDATIONPENDING":
                        imageElement.src = ValidationPendingStatus;
                        break;
                    case "UNDELIVERABLE":
                        imageElement.src = UndeliverableStatus;
                    default:
                        break;
                }

                element.appendChild(imageElement);
            }
        }

        return element;
    },

    sensorDataFormatter: (params) => {
        if (params.value != null) {

            if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                return "OOR";
            else
               return params.value.toString();
        }

        return "-NA-";
    },
    
    sensorDataSorting: (param) => {
        if (param != null && param != undefined  && param != "null") {
            return param;
        }
        else
            return '-NA-';
    },
  
    sensorDataFormatterforExcel: (params) => {
        if (params != null && params != "-NA-") {
            if (!isNaN(params)) { // WI 26545
                if (params == -999) //SensorOORIdentifier to be defined from RefApplicationParams
                    return "OOR";
                else
                    return parseFloat(params).toFixed(1).toString();//26447
            }
            else
                return params;
        }

        return "-NA-";
    },
    DimiRemainTermFormatterforExcel: (params) => {
        if (params != null && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '-NA-';
    },

    lineFrequencyFormatterforExcel: (qualifier, params) => {
        if(qualifier != null && (qualifier == 0 || qualifier == 1)) {
            //if (params.toString().trim() == "-999") 
            return params;
            //return parseFloat(params).toFixed(1).toString();
        }
        else if (qualifier != null && qualifier == 8)
        {
            //var value = params;
            //if(value == 19)
            return "High";
        }
        else if (qualifier != null && qualifier == 9)
        {
            //var value = params;
            //if(value == 35)
            return "Low";
        } 
        else 
            return "Unknown";
    },
    
    sensorDataFormatterforExcelTwoDecimal: (params) => {
        if (params != null && params != "-NA-") {

            if (params == -999) //SensorOORIdentifier to be defined from RefApplicationParams
                return "OOR";
            else 
                return parseFloat(params).toFixed(2).toString();//26447
        }

        return "-NA-";
    },
    sensorDataPCondSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd != '') {
                if (params.data.ReeferOEMTypeCd.trim() == 'C')
                    return '-NA-';
                else {
                    if (params.data.CondenserPressure != null && params.data.CondenserPressure != '-NA-') {
                        if (params.data.CondenserPressure.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return params.data.CondenserPressure.toString();
                    }
                    else
                        return '-NA-';
                }
            }
            return '-NA-';
        }
        return '-NA-';
    },
    sensorDataPCondvalueFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value != '-NA-') {
            return params.value;
        }
        return '-NA-';
    },
    
    sensorDataPCondFormatterExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.ReeferOEMTypeCd != null && params.ReeferOEMTypeCd != '') {
                if (params.ReeferOEMTypeCd.trim() == 'C')
                    return "-NA-";
                else {
                    if (params.CondenserPressure != null && params.CondenserPressure != '-NA-') {
                        if (params.CondenserPressure.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return parseFloat(params.CondenserPressure).toFixed(2).toString();
                    }
                    else
                        return '-NA-';
                }
            }
            return '-NA-';
        }
        return '-NA-';
    },
    
    sensorDataOpenExpFormatterExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.ReeferOEMTypeCd != null && params.ReeferOEMTypeCd != '') {
                if (params.ReeferOEMTypeCd.trim() == 'C')
                    return '-NA-';
                else {
                    if (params.EvaporatorExpansionValveOpening != null && params.EvaporatorExpansionValveOpening != '-NA-') {
                        if (params.EvaporatorExpansionValveOpening.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return params.EvaporatorExpansionValveOpening.toString();
                    }
                    else
                        return '-NA-';
                }
            }
            return '-NA-';
        }
        return '-NA-';
    },
   
    sensorDataOpenSucFormatterForExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.ReeferOEMTypeCd != null && params.ReeferOEMTypeCd != '') {
                if (params.ReeferOEMTypeCd.trim() == 'C') {
                    //if (params.SuctionModulationValveOpeningQualifier != null) { 
                    //    if (params.SuctionModulationValveOpeningQualifier.toString().trim() == "6") //6 - NotUsed
                    //        return '-NA-';
                    //    else {
                    //        if (params.SuctionModulationValveOpening != null && params.SuctionModulationValveOpening != '') {
                    //            if (params.SuctionModulationValveOpening.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                    //                return "OOR";
                    //            else
                    //                return params.SuctionModulationValveOpening.toString();
                    //        }
                    //        else
                    //            return '-NA-';
                    //    }
                    //}
                    return '-NA-';
                }
                else {
                    if (params.SuctionModulationValveOpening != null && params.SuctionModulationValveOpening != ''&& params.SuctionModulationValveOpening != '-NA-') {
                        if (params.SuctionModulationValveOpening.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                            return "OOR";
                        else
                            return params.SuctionModulationValveOpening.toString();
                    }
                    else
                        return '-NA-';
                }
            }
            return '-NA-';
        }
        return '-NA-';
    },
    reeferPowerSourceConverter: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";

        if (params.value != null) {
            var imageElement = document.createElement("img");
            if (params.value.toString().toUpperCase().trim() == "TRUE") {
                imageElement.src = Yes;
            }
            else
                imageElement.src = No;

            element.appendChild(imageElement);
        }

        return element;
    },
    switchPowerSourceConverter: (params) => {
        if (params.value != null) {
            var element = document.createElement("span");
            element.className = "reefer-alert";
            var imageElement = document.createElement("img");
            if (params.value.toString().toUpperCase().trim() == "TRUE")
                imageElement.src = Yes;
            else
                imageElement.src = No;

            element.appendChild(imageElement);
            return element;
        }
        return "-NA-";
    },
    enginePowerSourceConverter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.HasOilPressureSwitch != null && params.data.GensetRunning != null) {
                if (params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {
                    var element = document.createElement("span");
                    element.className = "reefer-alert";
                    var imageElement = document.createElement("img");

                    if (params.data.OEMTypeCD != null && params.data.OEMTypeCD != '') {
                        if (params.data.OEMTypeCD.toUpperCase().trim() == 'C') {
                            return '-NA-';
                        }
                        else {
                            if (params.data.GensetRunning.toString().toUpperCase().trim() == "TRUE")
                                imageElement.src = Yes;
                            else if (params.data.GensetRunning.toString().toUpperCase().trim() == "FALSE")
                                imageElement.src = No;
                            else
                                return '-NA-';
                            element.appendChild(imageElement);
                            return element;
                        }
                    }
                }

                else
                    return '-NA-';
            }
            else
                return '-NA-';
        }
        else
            return "-NA-";
    },
    rcdPowerSourceConverter: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";

        if (params.value != null) {
            var imageElement = document.createElement("img");
            if (params.value.toString().trim() == "1" || params.value.toString().trim() == "2") {
                imageElement.src = Yes;
            }
            else
                imageElement.src = No;

            element.appendChild(imageElement);
        }

        return element;
    },
    YesNoFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param.toString().toUpperCase().trim() == "0" || param.toString().toUpperCase().trim() == "FALSE") {
                return "No";
            }
            else if (param.toString().toUpperCase().trim() == "1" || param.toString().toUpperCase().trim() == "TRUE") {
                return "Yes";
            }            
        }
        return "*No Uses LOP";
    },
    YesNoConverter: (params) => {
        if (params.value != null && params.value != undefined && params.value.toString() != '') {
            if (params.value.toString().toUpperCase().trim() == "0" || params.value.toString().toUpperCase().trim() == "FALSE") {
                return "No";
            }
            else if (params.value.toString().toUpperCase().trim() == "1" || params.value.toString().toUpperCase().trim() == "TRUE") {
                return "Yes";
            }
            else {
                return "-NA-";
            }
        }
        return "-NA-";
    },
    ReeferYesNoConverter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.HasReefer != null && params.data.HasReefer != undefined) {
                if (params.data.HasReefer) {
                    if (params.value != null && params.value != undefined) {
                        if (params.value.toString().toUpperCase().trim() == "YES") {
                            return "Yes";
                        }
                        else 
                            return "No";
                    }
                    else
                        return "No";
                }
                else
                    return "-NA-";
            }
            else
                return "-NA-";
        }
        return "-NA-";
    },
    Auth0MigratedYesNoConverter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.Auth0_OrgId != null && params.data.Auth0_OrgId != undefined) {
                if (params.data.Auth0_OrgId) {
                    if (params.value != null && params.value != '' && params.value != undefined) {
                        return "Yes";
                    }
                    else
                        return "No";
                }
                else
                    return "No";
            }
            else
                return "No";
        }
        return "-NA-";
    },
    Auth0MigratedYesNoConverterForExcel: (params) => { 
        if (params != null && params != '' && params != undefined) {
            return "Yes";
        }
        else {
            return "No";
        }
      

    },
    ReeferDCXDownloadsSortingConverter: (colvalue, hasReefer) => {
            if (hasReefer != null && hasReefer != undefined) {
                if (hasReefer) {
                    if (colvalue != null && colvalue!= undefined) {
                        if (colvalue.toString().toUpperCase().trim() == "1" || colvalue.toString().toUpperCase().trim() == "TRUE") {
                            return "Yes";
                        }
                        else {
                            return "No";
                        }
                    }
                    else {
                        return "No";
                    }
                }
                else {
                    return "-NA-";
                }
            }
            else
                return "-NA-";
    },
    ReeferTripWISEReportSortingConverter: (colvalue, hasReefer) => {
        if (hasReefer != null && hasReefer != undefined) {
            if (hasReefer) {
                if (colvalue != null && colvalue != undefined) {
                    if (colvalue.toString().toUpperCase().trim() == "1" || colvalue.toString().toUpperCase().trim() == "TRUE") {
                        return "Yes";
                    }
                    else {
                        return "No";
                    }
                }
                else {
                    return "No";
                }
            }
            else {
                return "-NA-";
            }
        }
        else
            return "-NA-";
    },
    YesNoValueSorting: (param) => {
        if (param != null && param != undefined && param.toString() != '') {
            if (param.toString().toUpperCase().trim() == "0" || param.toString().toUpperCase().trim() == "FALSE" || param.toString().toUpperCase().trim() == "I") {
                return "No";
            }
            else if (param.toString().toUpperCase().trim() == "1" || param.toString().toUpperCase().trim() == "TRUE" || param.toString().toUpperCase().trim() == "A") {
                return "Yes";
            }
            else {
                return "-NA-";
            }
        }
        return "-NA-";
    },    

    

    IsActiveFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.IsActive != null && params.data.IsActive != undefined) {
            if (params.data.IsActive.toString().toUpperCase().trim() == "0" || params.data.IsActive.toString().toUpperCase().trim() == "FALSE" || params.data.IsActive.toString().toUpperCase().trim() == "I") {
                return "No";
            }
            else if (params.data.IsActive.toString().toUpperCase().trim() == "1" || params.data.IsActive.toString().toUpperCase().trim() == "TRUE" || params.data.IsActive.toString().toUpperCase().trim() == "A") {
                return "Yes";
            }
            else {
                return "-NA-";
            }
        }
        return "-NA-";
    },

    StatusCdFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.StateCd != null && params.data.StateCd != undefined) {
            if (params.data.StateCd.toString().toUpperCase().trim() == "I") {
                return "No";
            }
            else if (params.data.StateCd.toString().toUpperCase().trim() == "A") {
                return "Yes";
            }
            else {
                return "-NA-";
            }
        }
        return "-NA-";
    },

    IsDeployedFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.IsDeployed != null && params.data.IsDeployed != undefined) {
            if (params.data.IsDeployed.toString().toUpperCase().trim() == "0" || params.data.IsDeployed.toString().toUpperCase().trim() == "FALSE") {
                return "No";
            }
            else if (params.data.IsDeployed.toString().toUpperCase().trim() == "1" || params.data.IsDeployed.toString().toUpperCase().trim() == "TRUE") {
                return "Yes";
            }
            else {
                return "-NA-";
            }
        }
        return "-NA-";
    },

    FileStatusFormattingForFilter: (params) => {
        if (params.data != null && params.data != undefined && params.data != '' && params.data.FilerepositoryActionCD != null && params.data.FilerepositoryActionCD != undefined && params.data.FilerepositoryActionCD != '') {
            var action = params.data.FilerepositoryActionCD.toUpperCase().trim();
            if (action == "P")
                return "Pending";
            else if (action == "C")
                return "Completed";
            else if (action == "E")
                return "Error";
            else if (action == "I")
                return "Processing";
        }

        return "-NA-";
    },
    FileStatusGrouping: (params) => {
        if (params != null && params != undefined && params != '') {
            var action = params.toUpperCase().trim();
            if (action == "P")
                return "Pending";
            else if (action == "C")
                return "Completed";
            else if (action == "E")
                return "Error";
            else if (action == "I")
                return "Processing";
        }
    },
    YesNoConverterforExcel: (params) => {

        if (params != null && params != undefined && params.toString() != '') {
            if (params.toString().toUpperCase().trim() == "0" || params.toString().toUpperCase().trim() == "FALSE" || params.toString().toUpperCase().trim() == "NO" || params.toString().toUpperCase().trim() == "I") {
                return "No";
            }
            else if (params.toString().toUpperCase().trim() == "1" || params.toString().toUpperCase().trim() == "TRUE" || params.toString().toUpperCase().trim() == "YES" || params.toString().toUpperCase().trim() == "A") {
                return "Yes";
            }
            else if (params.toString().toUpperCase().trim() == "ACTIVE") {
                return "Active";
            }
            else if (params.toString().toUpperCase().trim() == "INACTIVE") {
                return "InActive";
            }
            else {
                return "-NA-";
            }
        }
        return "-NA-";
    },
    TimeZoneColumnFormatterForExcel: (params) => {
        var timeZoneCd = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneCd.trim();
        if (params != null && params != "") {
            if (timeZoneCd != null && timeZoneCd != "")
                return params + " (" + timeZoneCd + ")";
            else
                return params;
        }
    },
    GuestReeferModeFormatterForExcel: (params) => {
        if (params != null) {
            if (params.toString().toUpperCase().trim() == "TRUE")
                return "Guest";
            else
                return "Standard";
        }
        else
            return 'Standard';
    },
    //secondsToTimeConverterForExcel: (params) => {
    //    if (params != null && params != undefined && params != '-NA-') {
    //        var val = parseInt(params);
    //        if (val != 0) {
    //            var hours = val / 60;
    //            var minutes = val % 60;
    //            return parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":00";

    //        }
    //        else
    //            return val;
    //    }
    //    else
    //        return "-NA-";
    //},

    secondsToTimeConverterForExcel: (params) => {
        if (params != null && params != undefined && params != '-NA-') {
            var val = parseInt(params);
            if (val != 0) {
                var hours = val / 60;
                var minutes = val % 60;
                return parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":00";

            }
            else
                return val;
        }
        else
            return "-NA-";
    },

    DoorFormatterForExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.HasDoorSensor != null && params.HasDoorSensor.toString().toUpperCase().trim() == "TRUE") {
                if (params.Door1Open != null) {
                    if (params.Door1Open.toString().toUpperCase().trim() == "TRUE" || params.Door1Open.toString().toUpperCase().trim()=== "1")
                        return "Open";
                    else
                        return "Closed";
                }
                else
                    return "Unknown";
            }
            else
                return "No Sensor";
        }
        else
            return '-NA-';
    },

    AlarmListFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value != '') {
            if (params.value.toString().endsWith(",")) {
                params.value = params.value.slice(0, -1);
            }
            return '<span title="' + params.value + '">' + params.value + '</span>';
        }

        else return "-NA-";
    },
    AlarmListFormatterforExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.toString().endsWith(",")) {
                params = params.slice(0, -1);
            }
            return params;
        }

        else return "-NA-";
    },
   
    AlertDescriptionFormatter: (params, alertsList) => {
        var element = document.createElement("span");
        if (params.data.Alerts != null && params.data.Alerts != undefined && params.data.Alerts != '') {
            var lstAlerts = params.data.Alerts.split(',');
            $.each(lstAlerts, function (index, item) {
                if (item != "" && item != null) {
                    if (parseInt(index.toString()) > 0) {
                        var spanElement = document.createElement("span");
                        spanElement.innerText = ", ";
                        element.appendChild(spanElement);
                    }

                    if (alertsList != null && alertsList != undefined && alertsList.length > 0) {
                        var alertDescription = alertsList.filter(e =>
                            e.AlertCD === item.toString().trim());
                        var anchorElement = document.createElement("a");
                        anchorElement.title = alertDescription.length > 0 ? alertDescription[0].AlertDsc.toString() : "";
                        anchorElement.text = item.toString().trim();
                        element.appendChild(anchorElement);
                    }
                }
            });

            return element;
        }

        else return "-NA-";
    },
    CommandValidatorFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value != '') {

            if (params.toString().endsWith(",")) {
                params = params.remove(params.lastIndexOf(","));
            }

            return params;
        }

        else return "";
    },
    RefCommandStatus: (params) => {
        var status = "";
        if (params.value != null && params.value != undefined && params.value != '') {
            switch (params.value.toString()) {
                case "P":
                case "4":
                    status = "Pending";
                    break;
                case "C":
                    status = "Success";
                    break;
                default:
                    break;
            }
        }
        return status;
    },
    TimeZoneHeaderFormatter: (params) => {
        var timeZoneCd = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneCd.trim();
        if (params.colDef.headerName != null && params.colDef.headerName != "") {
            if (timeZoneCd != null && timeZoneCd != "")
                return params.colDef.headerName + " (" + timeZoneCd + ")";
            else
                return params.colDef.headerName;
        }
    },
    SpeedHeaderFormatter: (params) => {
        var speedUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).SpeedUnitCd.trim();
        if (params.colDef.headerName != null && params.colDef.headerName != "") {
            if (speedUnitCd != null && speedUnitCd != "")
                return params.colDef.headerName + " (" + speedUnitCd.toLowerCase() + ")";
            else
                return params.colDef.headerName;
        }
    },
    TimeZoneFormatter: (headerName) => {
        var timeZoneCd = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneCd.trim();
        if (headerName != null && headerName != "") {
            if (timeZoneCd != null && timeZoneCd != "")
                return headerName + " (" + timeZoneCd + ")";
            else
                return headerName;
        }
    },
    TempHeaderFormatter: (params) => {
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        if (params.colDef.headerName != null && params.colDef.headerName != "") {
            if (tempUnitCd.toUpperCase() == "F")
                return params.colDef.headerName + " (°F)";
            else
                return params.colDef.headerName + " (°C)";
        }
    },
    TemperatureHeaderFormatter: (headerName) => {
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        if (headerName != null && headerName != "") {
            if (tempUnitCd.toUpperCase() == "F")
                return headerName + "(°F)";
            else
                return headerName + "(°C)";
        }
    },
   
    TempHeaderFormatterChildForms: (params) => {
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        //var tmp = ["Booking Temp "]
        if (params != null && params != "") {
            if (tempUnitCd.toUpperCase() == "F")
                return params + "(°F)";
            else
                return params + "(°C)";
        }
    },
    TemperatureFormatter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params.value != null) {
            if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                return "OOR";
            else {
                var tempVal = parseFloat(params.value);
                if ((params.data.DeviceType != null && params.data.DeviceType != undefined && params.data.DeviceType.toString().toUpperCase().trim() == "ST9100") && params.colDef.field == "DeviceTemp") {
                    // if (tempVal == 0)
                    return '-NA-';
                }
                if (tempUnitCd.toUpperCase() == "F") {
                    tempVal = ((tempVal * 9) / 5) + 32;

                    var param = parseFloat(tempVal.toString());
                    return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                        param.toFixed(parseInt(tempRoundingValue)) : param.toFixed(1);
                   //WI 26666 return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
                else
                  //WI 26666  return parseFloat(params.value.toFixed(parseInt(tempRoundingValue)));
                    return tempRoundingValue > 0 ? params.value.toFixed(parseInt(tempRoundingValue)).toString() === "-0.0" ? parseFloat("0.0").toFixed(1) :
                        params.value.toFixed(parseInt(tempRoundingValue)) : params.value.toFixed(1);
            }
        }
        else
            return '-NA-';
    },
    
    TemperatureSorting: (param) => {
        if (param != null && param != undefined && param != "null") {
            return param;
        }
        else
            return '-NA-';
    }, 
    
    DeviceTempFormatterForFilter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params.value != null) {
            if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                return "OOR";
            else {
                var tempVal = parseFloat(params.value);
                if ((params.data.DeviceType != null && params.data.DeviceType != undefined && params.data.DeviceType.toString().toUpperCase().trim() == "ST9100") && params.colDef.field == "DeviceTemp") {
                   // if (tempVal == 0)
                        return '-NA-';
                }
                if (tempUnitCd.toUpperCase() == "F") {
                    tempVal = ((tempVal * 9) / 5) + 32;

                    var param = parseFloat(tempVal.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
                else
                    return parseFloat(params.value.toFixed(parseInt(tempRoundingValue)));
            }
        }
        else
            return '-NA-';
    },
    
    FloatFormatterForGraph: (params) => {
        if (params != null) {
            if (params.toString().trim() == "")
                return "OOR";
            else
                return parseFloat(params);
        }
        else
            return '-NA-';
    },
    TemperatureFormatterForGraph: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params != null) {
            if (params.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                return "OOR";
            else {
                var tempVal = parseFloat(params);

                if (tempUnitCd.toUpperCase() == "F") {
                    tempVal = ((tempVal * 9) / 5) + 32;

                    var param = parseFloat(tempVal.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
                else
                    return parseFloat(params.toFixed(parseInt(tempRoundingValue)));
            }
        }
        else
            return '-NA-';
    },
    
    TripWiseExpirationSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.TripWiseExpiration != null && params.data.TripWiseExpiration != "0") {
                    if (params.data.TripWiseExpiration.toString().trim() == "-999")
                        return "OOR";
                    else
                        return params.data.TripWiseExpiration;
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
        
    },
    DimiRemainTermSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined && params.data.DimiTermQualifier != null && params.data.DimiTermQualifier != undefined) {
                if (params.data.DimiTermQualifier.toString().toUpperCase().trim() == "OFF") {
                    return "Off";
                }
                else if (params.data.DimiRemainTerm != null && params.data.DimiRemainTerm != undefined) {
                    if (params.data.DimiRemainTerm.toString().trim() == "-999")
                        return "OOR";
                    //else if (params.data.DimiRemainTerm == 0)
                        //return 1;
                    else
                        return Math.ceil(params.data.DimiRemainTerm/24);
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
        
    },
    DimiTermSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined && params.data.DimiTermQualifier != null && params.data.DimiTermQualifier != undefined) {
                if (params.data.DimiTermQualifier.toString().toUpperCase().trim() == "OFF") {
                    return "Off";
                }
                else if (params.data.DimiTerm != null && params.data.DimiTerm != undefined) {
                    if (params.data.DimiTerm.toString().trim() == "-999")
                        return "OOR";
                    
                    else
                        return params.data.DimiTerm;
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    //Start RCNG-1818
    CTDurationSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd.toUpperCase().trim() == "D") {
                    if (params.data.ACTMode != null && params.data.ACTMode.toString().toUpperCase().trim() == "TRUE") {
                        if (params.data.CTDuration != null && params.data.CTDuration != 0) {
                            if (params.data.CTDuration.toString().trim() == "-999")
                                return "OOR";
                            else
                                return params.data.CTDuration;
                        }
                        else
                            return "-NA-";
                    }
                    else
                        return "-NA-";
                }
                else {
                    if (params.data.CTDuration != null && params.data.CTDuration != 0) {
                        if (params.data.CTDuration.toString().trim() == "-999")
                            return "OOR";
                        else
                            return params.data.CTDuration;
                    }
                    else
                        return "-NA-";
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    CTRemainingTimeSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.ReeferOEMTypeCd != null && params.data.ReeferOEMTypeCd.toUpperCase().trim() == "D") {
                    if (params.data.ACTMode != null && params.data.ACTMode.toString().toUpperCase().trim() == "TRUE") {
                        if (params.data.CTRemainingTime != null && params.data.CTRemainingTime != 0) {
                            if (params.data.CTRemainingTime.toString().trim() == "-999")
                                return "OOR";
                            else
                                return params.data.CTRemainingTime;
                        }
                        else
                            return "-NA-";
                    }
                    else
                        return "-NA-";
                }
                else {
                    if (params.data.CTRemainingTime != null && params.data.CTRemainingTime != 0) {
                        if (params.data.CTRemainingTime.toString().trim() == "-999")
                            return "OOR";
                        else
                            return params.data.CTRemainingTime;
                    }
                    else
                        return "-NA-";
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    
    AirPumpRunHoursSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.AirPumpRunHours != null) {
                    if (params.data.AirPumpRunHours.toString().trim() == "-999")
                        return "OOR";
                    else
                        return params.data.AirPumpRunHours;
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    CARunHoursSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.CARunHours != null) {
                    if (params.data.CARunHours.toString().trim() == "-999")
                        return "OOR";
                    else
                        return params.data.CARunHours;
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    PowerMeterSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.PowerMeter != null) {
                    if (params.data.PowerMeter.toString().trim() == "-999")
                        return "OOR";
                    else
                        return params.data.PowerMeter;
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    CASWVerSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.CASoftwareRevision != null && params.data.CASoftwareRevision != 0) {
                    if (params.data.CASoftwareRevision.toString().trim() == "-999")
                        return "OOR";
                    else
                        return params.data.CASoftwareRevision;
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    CompressorRunHoursSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != null && params.data != undefined) {
                if (params.data.CompressorRunHours != null) {
                    if (params.data.CompressorRunHours.toString().trim() == "-999")
                        return "OOR";
                    else
                        return params.data.CompressorRunHours;
                }
                else
                    return "-NA-";
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    CTRemainingTimeGrouping: (params) => {  //Modified for the FIX of RCNG-5006
        if (params != null && params != undefined) {
            if (params.node != null && params.node != undefined) {
                if (params.node.key != null) {
                    if (params.node.key.toString().trim() == "-999")
                        return "OOR";
                    else
                        return params.node.key;
                }
                else
                    return '* No CT rem(hr)';
            }
            else
                return '* No CT rem(hr)';
        }
        else
            return '* No CT rem(hr)';

    },

    CTDurationGrouping: (params) => {  //Modified for the FIX of RCNG-5006
        if (params != null && params != undefined) {
            if (params.node != null && params.node != undefined) {
                if (params.node.key != null) {
                    if (params.node.key.toString().trim() == "-999")
                        return "OOR";
                    else
                        return params.node.key;
                }
                else
                    return '*No CT dur (d)';
            }
            else
                return '*No CT dur (d)';
        }
        else
            return '*No CT dur (d)';
    },
    CTDurationorRemainingTimeFormatterforExcel: (params) => {
        if (params != null && params != 0 && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '-NA-';
    },
    AirPumpRunHoursFormatterforExcel: (params) => {
        if (params != null && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '-NA-';
    },
    CompressorRunHoursFormatterforExcel: (params) => {
        if (params != null && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '-NA-';
    },
    CARunHoursFormatterforExcel: (params) => {
        if (params != null && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '-NA-';
    },
    
    PowerMeterFormatterforExcel: (params) => {
        if (params != null && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '-NA-';
    },
    CASWVerFormatterforExcel: (params) => {
        if (params != null && params != 0 && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '-NA-';
    },
    //end RCNG-1818
    TripWiseExpirationFormatterforExcel: (params) => {
        if (params != null && params != "0" && params != undefined) {
            if (params.toString().trim() == "-999")
                return "OOR";
            else
                return params;
        }
        else
            return '-NA-';
    },
      
    SpeedConverterforExcel: (params) => {
        
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var speedUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).SpeedUnitCd.trim();
        if (params != null && params != undefined && params != '-NA-') {
            if (speedUnitCd.toLowerCase() == "kmh") {
                var param = parseFloat(params);
                return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
            }
            else {
                var tempVal = parseFloat(params);
                var param1 = (tempVal / 1.609344);
                return parseFloat(param1.toFixed(parseInt(tempRoundingValue)));
            }

        }
        else
            return '-NA-';
       
    },
    
    TemperatureFormatterForSorting: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        var BookedTemperature = null;
        var TempUnit = null;
        if (params.data.TemperatureUnit != null && params.data.TemperatureUnit != undefined) {
            var strlstValues = params.value.split('@');
            BookedTemperature = strlstValues[0];
            TempUnit = strlstValues[1];
            if (TempUnit.toUpperCase() == "N")
                return "Non-Running";
            else if (TempUnit.toUpperCase() != tempUnitCd.toUpperCase()) {
                if ("F" == tempUnitCd.toUpperCase()) {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = ((tempValue * 9) / 5) + 32;
                    var param = parseFloat(tempValue.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
                else {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = (tempValue - 32) * 5 / 9;
                    var param = parseFloat(tempValue.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
            }
            else
                return parseFloat(parseFloat(BookedTemperature.toString()).toFixed(parseInt(tempRoundingValue)));
        }
        else
            return "-NA-";
    },
    TemperatureFormatterForBookingforExcel: function (params) {
        var tempRoundingValue = "1";
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        var BookedTemperature = null;
        var TempUnit = null;
        if (params != null && params != "" && params != "-NA-") {
            var strlstValues = params.split('@');
            BookedTemperature = strlstValues[0];
            TempUnit = strlstValues[1];
            if (TempUnit.toUpperCase() == "N")
                return "Non-Running";
            else if (TempUnit.toUpperCase() != tempUnitCd.toUpperCase()) {
                if ("F" == tempUnitCd.toUpperCase()) {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = ((tempValue * 9) / 5) + 32;
                    var param = parseFloat(tempValue.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
                else {
                    var tempValue = parseFloat(BookedTemperature.toString());
                    tempValue = (tempValue - 32) * 5 / 9;
                    var param = parseFloat(tempValue.toString());
                    return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                }
            }
            else
                return BookedTemperature.toString();
        }
        else
            return '-NA-';
    },

    TemperatureFormatterForDeviceTemp(params: any) {
            var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;//"1";
            var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

            if (params != null && params != undefined) {
                if (params.node.data.DeviceTemp != null && params.node.data.DeviceTemp != undefined && params.node.data.DeviceTemp != '-NA-') {
                    if (params.node.data.DeviceTemp.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                        return "OOR";
                    else {
                        var tempVal = parseFloat(params.node.data.DeviceTemp);
                        if ((params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().toUpperCase().trim() == "ST9100")) {
                            //if (tempVal == 0)
                                return '-NA-';
                        }
                        if (tempUnitCd.toUpperCase() == "F") {
                            tempVal = ((tempVal * 9) / 5) + 32;

                            var param = parseFloat(tempVal.toString());
                            return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                        }
                        else
                            return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue)));
                    }
                }
                else
                    return '-NA-';
            }
            else
                return '-NA-';
    },
    TemperatureFormatterforExcel: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params != null && params != "-NA-") {
            if (params == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                return "OOR";
            else {
                var tempVal = parseFloat(params);
                if (tempUnitCd.toUpperCase() == "F") {
                    tempVal = ((tempVal * 9) / 5) + 32;
                    
                    var param = parseFloat(tempVal.toString());
                    //return param.toFixed(parseInt(tempRoundingValue));
                    return tempRoundingValue > 0 ? param.toFixed(parseInt(tempRoundingValue)).toString() :
                        param.toFixed(1).toString();
                }
                else {
                    //26447-start
                    var tempVal = parseFloat(params);
                    var param = parseFloat(tempVal.toString());
                    //26447 -end
                    //return tempVal.toFixed(parseInt(tempRoundingValue));
                    return tempRoundingValue > 0 ? tempVal.toFixed(parseInt(tempRoundingValue)).toString() :
                        param.toFixed(1).toString();
                }
                
            }
        }
        else
            return '-NA-';
    },
    GravityVectorValueFormatter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).GravityVectorPrecision;

        if (params != null && params != undefined) {
            if (params.value != null && params.value != undefined && params.value != '-NA-') {
                var tempVal = parseFloat(params.value);
                if (tempVal == 0)
                    return 0;
                else
                return tempRoundingValue > 0 ? tempVal.toFixed(parseInt(tempRoundingValue)).toString() === "-0.00" ? parseFloat("0.00").toFixed(2) :
                    tempVal.toFixed(parseInt(tempRoundingValue)) : tempVal.toFixed(2);

            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    GravityVectorValueFormatterforGroup: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).GravityVectorPrecision;

        if (params != null && params != undefined) {
            if (params != null && params != undefined && params != '-NA-') {
                var tempVal = parseFloat(params);
                if (tempVal == 0)
                    return 0;
                else
                return tempRoundingValue > 0 ? tempVal.toFixed(parseInt(tempRoundingValue)).toString() === "-0.00" ? parseFloat("0.00").toFixed(2) :
                    tempVal.toFixed(parseInt(tempRoundingValue)) : tempVal.toFixed(2);

            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
   
    LuxValueFormatter: (params) => {
        var tempRoundingValue = "2";
        if (params != null && params != undefined) {
            if (params.value != null && params.value != undefined && params.value != '-NA-') {
                var tempVal = parseFloat(params.value);
                if (tempVal == 0)
                    return 0;
                else
                    return tempRoundingValue > 0 ? tempVal.toFixed(parseFloat(tempRoundingValue)).toString() === "-0.00" ? parseFloat("0.00").toFixed(2) :
                        tempVal.toFixed(parseFloat(tempRoundingValue)) : tempVal.toFixed(2);

            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    LuxValueFormatterforGroup: (params) => {
        var tempRoundingValue = "2";
        if (params != null && params != undefined) {
            if (params != null && params != undefined && params != '-NA-') {
                var tempVal = parseFloat(params);
                if (tempVal == 0)
                    return 0;
                else
                    return tempRoundingValue > 0 ? tempVal.toFixed(parseFloat(tempRoundingValue)).toString() === "-0.00" ? parseFloat("0.00").toFixed(2) :
                        tempVal.toFixed(parseFloat(tempRoundingValue)) : tempVal.toFixed(2);

            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },
    TemperatureFormatterExcelForDeviceTemp: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params != null && params != undefined) {
            if (params.value != null && params.value != undefined && params.value != '-NA-') {
                if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                    return "OOR";
                else {
                    var tempVal = parseFloat(params.value);
                    if ((params.node.data.DeviceType != null && params.node.data.DeviceType != undefined && params.node.data.DeviceType.toString().toUpperCase().trim() == "ST9100") && params.column.colDef.field == "DeviceTemp") {
                       // if (tempVal == 0)
                            return '-NA-';
                    }
                    if (tempUnitCd.toUpperCase() == "F") {
                        tempVal = ((tempVal * 9) / 5) + 32;

                        var param = parseFloat(tempVal.toString());
                        return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                    }
                    else
                        return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue)));
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';
    },
    DevcieTempGrouping: (params, DeviceType) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params != null && params != undefined) {
                if (params.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                    return "OOR";
                else {
                    var tempVal = parseFloat(params);
                    if ((DeviceType != null && DeviceType != undefined && DeviceType.toString().toUpperCase().trim() == "ST9100")) {
                        return '-NA-';
                    }
                    if (tempUnitCd.toUpperCase() == "F") {
                        tempVal = ((tempVal * 9) / 5) + 32;

                        var param = parseFloat(tempVal.toString());
                        return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                    }
                    else
                        return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue)));
                }
            
        }
        else
            return '-NA-';
    },
    InsideTempGrouping: (params, DeviceType) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();

        if (params != null && params != undefined) {
                if (params.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                    return "OOR";
                else {
                    var tempVal = parseFloat(params);
                    if ((DeviceType != null && DeviceType != undefined && DeviceType.toString().toUpperCase().trim() == "ST9100")) {
                        return '-NA-';
                    }
                    if (tempUnitCd.toUpperCase() == "F") {
                        tempVal = ((tempVal * 9) / 5) + 32;

                        var param = parseFloat(tempVal.toString());
                        return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                    }
                    else
                        return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue)));
                }
            
        }
        else
            return '-NA-';
    },

    GetOEMTypeDescription: (params) => {
        if (params != null && params != '-NA-') {
            switch (params.toUpperCase().trim()) {
                case "C":
                    return "CAR";
                case "D":
                    return "DKN";
                case "S":
                    return "SC";
                case "T":
                    return "TK";
                case "G":
                    return "GMK";
                case "TA":
                    return "TLR";
                case "U":
                    return "UNK";
                case "CARRIER":
                    return "CAR";
                case "DAIKIN":
                    return "DKN";
                case "STARCOOL":
                    return "SC";
                case "THERMOKING":
                    return "TK";
                case "GENMARK":
                    return "GMK";
                case "TAYLOR":
                    return "TLR";
                case "UNKNOWN":
                    return "UNK";
                case "OEM_KLINGE":
                case "KLINGE":
                    return "KLINGE";
                default:
                    return params.toUpperCase().trim(); 
            }
        }
        return "-NA-";
    },

    //CargoCareFormatter: (params) => {
    //    var element = document.createElement("span");
    //    element.className = "reefer-alert";
    //    if (params != null && params != undefined && params != '') {

    //        var cellColor = "";
    //        var isCargoCare = false;

    //        if (params.data != null && params.data != undefined && params.data != '') {
    //            isCargoCare = params.data.IsCargoCare;

    //            if (params.data.CCAlarms != "" && params.data.CCAlarms != null && params.data.CCSeverityLevel != "" && params.data.CCSeverityLevel != null) {
    //                if (params.data.CCSeverityLevel.toString() == "1") {
    //                    cellColor = "Tomato";
    //                }
    //                else if (params.data.CCSeverityLevel.toString() == "2") {
    //                    cellColor = "Orange";
    //                }
    //                else if (params.data.CCSeverityLevel.toString() == "3") {
    //                    cellColor = "Yellow";
    //                }
    //            }
    //            else {
    //                cellColor = "";
    //            }

    //            var imageElement = document.createElement("img");

    //            if (cellColor == "" && !isCargoCare) {
    //                return "";
    //            }
    //            else if (isCargoCare && cellColor == "") {
    //                imageElement.src = "../Images/cc.png";
    //            }
    //            else if (!isCargoCare && cellColor == "Tomato") {
    //                imageElement.src = "../Images/t.png";
    //            }
    //            else if (isCargoCare && cellColor == "Tomato") {
    //                imageElement.src = "../Images/tcc.png";
    //            }
    //            else if (!isCargoCare && cellColor == "Orange") {
    //                imageElement.src = "../Images/o.png";
    //            }
    //            else if (isCargoCare && cellColor == "Orange") {
    //                imageElement.src = "../Images/occ.png";
    //            }
    //            else if (!isCargoCare && cellColor == "Yellow") {
    //                imageElement.src = "../Images/y.png";
    //            }
    //            else if (isCargoCare && cellColor == "Yellow") {
    //                imageElement.src = "../Images/ycc.png";
    //            }
    //            element.appendChild(imageElement);
    //        }
    //    }
    //    return element;
    //},
   
  
   
    CargoCareFormatterGrouping: (param) => {
       
        if (param != null && param != undefined) {
            if (param == 1) {
                return '<span class="reefer-alert"><img src=' + HighCC + ' title="Severe"></img></span>' + " " + "<span class='aggrid-CellSignal'>Severe</span>";
            }
            else if (param == 2) {               
                return '<span class="reefer-alert"><img src=' + MediumCC + ' title="Minor"></img></span>' + " " + "<span class='aggrid-CellSignal'>Minor</span>";
            }
            else if (param == 3) {               
                return '<span class="reefer-alert"><img src=' + LowCC + ' title="Informational"></img></span>' + " " + "<span class='aggrid-CellSignal'>Informational</span>";
            }
            else if (param == 4) {
                return '<span class="reefer-alert"><img src=' + NormalCC + ' title="Assigned"></img></span>' + " " + "<span class='aggrid-CellSignal'>Assigned</span>"; //RCNG-241 Renamed Normal to Assigned
            }
            else if (param == 5) {
                return "*No CC";
            }           
        }
        return "*No CC";
    },
    CargoCareFormatterGroupingForExcel: (param) => {

        if (param != null && param != undefined) {
            if (param == 1) {
                return 'Severe';
            }
            else if (param == 2) {
                return 'Minor';
            }
            else if (param == 3) {
                return 'Informational';
            }
            else if (param == 4) {
                return 'Assigned'; //RCNG-241 Renamed Normal to Assigned
            }
            else if (param == 5) {
                return "*No CC";
            }
        }
        return "*No CC";
    },
    CargoCareFormatterforExcel: (params) => {
        var valueString = "";
        if (params != null && params != undefined && params != '') {
            if (params.isCargocare && params.CCSeverityLevel.toString() == "1") {
                valueString = "CC:Yes, Level:Severe";
            }
            else if (params.CCSeverityLevel.toString() == "1") {

                valueString = "CC:No, Level:Severe";
            }
            else if (params.isCargocare && params.CCSeverityLevel.toString() == "2") {
                valueString = "CC:Yes, Level:Minor";
            }
            else if (params.CCSeverityLevel.toString() == "2") {
                valueString = "CC:No, Level:Minor";
            }
            else if (params.isCargocare && params.CCSeverityLevel.toString() == "3") {
                valueString = "CC:Yes, Level:Informational";
            }
            else if (params.CCSeverityLevel.toString() == "3") {
                valueString = "CC:No, Level:Informational";
            }
            else if (params.isCargocare) {
                valueString = "CC:Yes, -NA-"; //RCNG-241 Renamed Normal to Assigned
            }
            else {
                //valueString = "CC:No, Level:No";
                valueString = "CC:No, -NA-";
            }
        }

        return valueString;
    },
    textTooltipFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value != '') {
            return '<span title ="' + params.value + '">' + params.value + '</span>';
        }
        else
            return '';
    },
    secondsToTimeConverter: (params) => {
        if (params.value != null && params.value!='-NA-') {
            var val = parseInt(params.value);
            if (val != 0) {
                var hours = val / 60;
                var minutes = val % 60;
                return parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":00";

            }
            else
                return val;
        }
        else
            return "-NA-";
    },
    reeferSecondsToTimeConverterFilter: (params) => {
        var returnValue = "-NA-";
        if (params != undefined && params != null) {

            if (params.data != undefined && params.data != null) {

                if (params.data.GPSLastLock != null) {
                    var val = parseInt(params.data.GPSLastLock);
                    if (val != 0) {
                        if (params.data.DeviceType != null && params.data.DeviceType != undefined && params.data.DeviceType.toString().toUpperCase().trim() == "ST9100") {
                            var minutesVal = val / 60;
                            var hours = minutesVal / 60;
                            var minutes = minutesVal % 60;
                            var seconds = val % 60;
                            returnValue = parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":" + parseInt(seconds.toString());
                        }
                        else {
                            var hours = val / 60;
                            var minutes = val % 60;
                            returnValue = parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":00";
                        }
                    }
                    else
                        returnValue = val.toString();
                }
                else
                    returnValue = "-NA-";

            }
        }
        return returnValue;
    },

    secondsToTimeConverterFilter: (params) => {

        var returnValue = "-NA-";
        if (params != undefined && params != null) {

            if (params.data != undefined && params.data != null) {

                if (params.data.GPSLastLock != null) {
                    var val = parseInt(params.data.GPSLastLock);
                    if (val != 0) {
                        var hours = val / 60;
                        var minutes = val % 60;
                        returnValue = parseInt(hours.toString()) + ":" + parseInt(minutes.toString()) + ":00";

                    }
                    else
                        returnValue = val.toString();
                }
                else
                    returnValue = "-NA-";

            }
        }
        return returnValue;
    },

    GPSCoordsFormatter: (params) => {
        if (params.value != null && params.value != '-1000') {
            if (params.data != null && params.data != undefined && params.data != '') {
                if (params.data.DeviceType != null && params.data.DeviceType != undefined && (params.data.DeviceType.toString().toUpperCase().trim() == "GT1200" || params.data.DeviceType.toString().toUpperCase().trim() == "GT1020")) {
                    if (params.value != null && params.value != '-1000')
                        return params.value;
                    else
                        return '-NA-';
                }
                else if (params.data.GPSLatitude != 0 && params.data.GPSLongitude != 0 && (params.data.GPSLockState == null || params.data.GPSLockState == '' || params.data.GPSLockState.toUpperCase() != "LOCKED")) {
                    if (params.value != null && params.value != '-1000') {
                        params.value = '<i>' + params.value + '</i>';
                        params.value = '<p style="color:#736F6E" >' + params.value + '</p>';
                        return params.value;
                    }
                    else
                        return '-NA-';
                }
                else if (params.data.GPSCoords != null && params.data.GPSCoords != undefined && params.data.GPSCoords.toString().trim() == "") {
                    return '-NA-';
                }
                else
                    return params.value;
            }
        }
        else
            return '-NA-';
    },
    DeploymentCommandValidatorFormatter: (params) => {
        var element = document.createElement("span");

        if (params != null) {
            var imageElement = document.createElement("img");

            if (params.value == "E") {
                imageElement.src = ImgPending1;
            }
            else if (params.value == "W") {
                imageElement.src = ImgWarning1;
            }
            else {
                imageElement.src = ImgSuccess1;
            }
            element.appendChild(imageElement);
            return element;
        }
        else
            return element;
    },

    GetFileRepositoryActionDesc: (params) => {

        var valueString = "";
        if (params != null && params != undefined && params != '') {
            var action = params.toUpperCase().trim();
            if (action == "P")
                valueString = "Pending";
            else if (action == "C")
                valueString = "Completed";
            else if (action == "E")
                valueString = "Error";
            else if (action == "I")
                valueString = "Processing";
        }
        return valueString;
    },

   
    
    Current3PhaseFormatterforExcel: (params) => {
        var currentValue1 = "";
        var currentValue2 = "";
        var currentValue3 = "";
        if (params != null && params != "-NA-") {
            var phases = params.split(",");
            if (phases[0].toString().trim() == "-999")
                currentValue1 = "OOR";
            else {
                var param = parseFloat(phases[0].toString());
                currentValue1 = param.toFixed(0).toString().trim() == "NaN" ? "" : param.toFixed(1).toString().trim();//WI-26512-in else toFixed number was wrong
                //currentValue1 = phases[0].toString().trim();
            }
                
            if (phases[1].toString().trim() == "-999")
                currentValue2 = "OOR";
            else {
                var param = parseFloat(phases[1].toString());
                currentValue2 = param.toFixed(1).toString().trim() == "NaN" ? "" : param.toFixed(1).toString().trim();
                //currentValue2 = phases[1].toString().trim();
            }
                
            if (phases[2].toString().trim() == "-999")
                currentValue3 = "OOR";
            else {
                var param = parseFloat(phases[2].toString());
                currentValue3 = param.toFixed(2).toString().trim() == "NaN" ? "" : param.toFixed(1).toString().trim();//WI-26512-in else toFixed number was wrong
                //currentValue3 = phases[2].toString().trim();
            }
                

            return currentValue1 + ", " + currentValue2 + ", " + currentValue3;
        }
        else
            return "-NA-";
    },
    DateTimeFormatter(params: any) {
        if (params != null && params != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy');
        }
        else
            return '-NA-';
    },
    UTCtoPreferenceTimeFormatter(params: any) {
        if (params != null && params != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM:ss');
        }
        else
            return '-NA-';
    },
    //RCNG-1398
    UTCtoPreferenceTimeFormatterHM(params: any) {
        if (params != null && params != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.toString());
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM');
        }
        else
            return '-NA-';
    },
    PreferenceTimeToUTCFormatterHM(params: any) {
        if (params != null && params != undefined) {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(params.toString());
            var prefDateTime = new Date(eventdttm.getTime() - (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy HH:MM');
        }
        else
            return '-NA-';
    },
    toolTipFormatter: (params) => {
        if (params.value != null && params.value != undefined && params.value != '' && params.value != '-NA-') {
            return params.value.trim();
        }
        else
            return '';
    },
    
    
    tripWiseFormatter: (params) => {
        if (params.value != undefined) {
            switch (params.value) {
                case 0:
                    return params.value = '<span title="Off" class="fas fa-square GridIcons greytext"></span>';
                case 1:
                    return params.value = '<span title="Expired" class="fas fa-times GridIcons orangetext "></span>';
                case 2:
                    return params.value = '<span title="Check" class="fas fa-exclamation GridIcons color-red"></span>';
                case 3:
                    return params.value = '<span title="Passed" class="fas fa-check GridIcons green-text-color"></span>';
                case 4:
                    return params.value = '<span title="Running" class="fas fa-history GridIcons black-text-color"></span>';
                case 5:
                    return params.value = '<span title="Unknown" class="fas fa-question GridIconsQuestion black-text-color"></span>';
                case null:
                    return params.value = '<span title="-NA-" class="fas fa-horizontal-rule GridIcons black-text-color"></span>';
            }
        }
        return params.value = '<span title="-NA-" class="fas fa-horizontal-rule GridIcons black-text-color"></span>';
    },
    TripWiseSorting: (params) => {

            var TripWiseStatusDescription = '-NA-';

    if (params != null && params != undefined) {

        if (params.data != null && params.data != undefined && params.data.ReeferOemTypeCd != null && params.data.ReeferOemTypeCd.toUpperCase().trim() != "D") {

            if (params.data.TWState != undefined) {

                return params.data.TWState;

            }

            else

                return TripWiseStatusDescription;//-999;

        }

		else{

		if (params != null && params != undefined && params.data != null && params.data != null && params.data != undefined){

        if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "OFF") {

            TripWiseStatusDescription = 'Off';

        }

        else if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "ON") {
 
            if (params.data.DimiResultActuator == "Passed" && params.data.DimiResultAlarm == "Passed" &&

                params.data.DimiResultOOR == "Passed" && params.data.DimiResultTerm == "Passed"
&& params.data.DimiResultValidity == "Passed") {

                TripWiseStatusDescription = "Passed";

            }

            else if ((params.data.DimiResultValidity == "Failed") && (

                (params.data.DimiResultActuator == "Passed" || params.data.DimiResultActuator == "Unknown") &&

                (params.data.DimiResultAlarm == "Passed" || params.data.DimiResultAlarm == "Unknown") &&

                (params.data.DimiResultOOR == "Passed" || params.data.DimiResultOOR == "Unknown") &&

                (params.data.DimiResultTerm == "Passed" || params.data.DimiResultTerm == "Unknown"))) {

                TripWiseStatusDescription = "Expired";

            }

            else if ((params.data.DimiResultActuator == "Unknown" || params.data.DimiResultAlarm == "Unknown"

                || params.data.DimiResultOOR == "Unknown" || params.data.DimiResultTerm == "Unknown"

                || params.data.DimiResultValidity == "Unknown") &&

                (params.data.DimiResultActuator != "Failed" && params.data.DimiResultAlarm != "Failed" &&

                params.data.DimiResultOOR != "Failed" && params.data.DimiResultTerm != "Failed" &&

                params.data.DimiResultValidity != "Failed")) {

                TripWiseStatusDescription = "Unknown";

            }

            else if (params.data.DimiResultActuator == "Failed" || params.data.DimiResultAlarm == "Failed"

                || params.data.DimiResultOOR == "Failed" || params.data.DimiResultTerm == "Failed") {

                TripWiseStatusDescription = "Check";

            }

        }

	}

	return TripWiseStatusDescription;

        }

    }

},    

TripWiseGrouping: (param) => {

    if (param != null && param != undefined && param != "null") {

        switch (param) {

            case '0':

                return '<span title="Off" class="fas fa-square GridIcons greytext"></span>' + " " + "<span class='ptTWpadding'>Off</span>";

            case '1':

                return '<span title="Expired" class="fas fa-times GridIcons orangetext "></span>' + " " + "<span class='ptTWpadding'>Expired</span>";

            case '2':

                return '<span title="Check" class="fas fa-exclamation GridIcons color-red"></span>' + " " + "<span class='ptTWpadding'>Check</span>";

            case '3':

                return '<span title="Passed" class="fas fa-check GridIcons green-text-color"></span>' + " " + "<span class='ptTWpadding'>Passed</span>";

            case '4':

                return '<span title="Running" class="fas fa-history GridIcons black-text-color"></span>' + " " + "<span class='ptTWpadding'>Running</span>";

            case '5':

                return '<span title="Unknown" class="fas fa-question GridIconsQuestion black-text-color"></span>' + " " + "<span class='ptTWpadding'>Unknown</span>";

        }

    }

},

TwStateForFilter: (params) => {

    if (params.data != null && params.data != undefined) {

        if (params.data.ReeferOemTypeCd != null && params.data.ReeferOemTypeCd != undefined && params.data.ReeferOemTypeCd.toString().toUpperCase().trim() != 'D') {

        if (params.data.TWState != undefined) {

            switch (params.data.TWState) {

                case 0:

                    return 'Off';

                case 1:

                    return 'Expired';

                case 2:

                    return 'Check';

                case 3:

                    return 'Passed';

                case 4:

                    return 'Running';

                case 5:

                    return 'Unknown';

            }

        }

        return '-NA-';

    }

        else {

            if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "OFF") {

                return  'Off';

            }

            if (params.data.DimiMode != null && params.data.DimiMode.toUpperCase().trim() == "ON") {

                if (params.data.DimiResultActuator == "Passed" && params.data.DimiResultAlarm == "Passed" &&

                    params.data.DimiResultOOR == "Passed" && params.data.DimiResultTerm == "Passed"
&& params.data.DimiResultValidity == "Passed") {

                    return "Passed";

                }

                else if ((params.data.DimiResultValidity == "Failed") && (

                    (params.data.DimiResultActuator == "Passed" || params.data.DimiResultActuator == "Unknown") &&

                    (params.data.DimiResultAlarm == "Passed" || params.data.DimiResultAlarm == "Unknown") &&

                    (params.data.DimiResultOOR == "Passed" || params.data.DimiResultOOR == "Unknown") &&

                    (params.data.DimiResultTerm == "Passed" || params.data.DimiResultTerm == "Unknown"))) {

                    return  "Expired";

                }

                else if ((params.data.DimiResultActuator == "Unknown" || params.data.DimiResultAlarm == "Unknown"

                    || params.data.DimiResultOOR == "Unknown" || params.data.DimiResultTerm == "Unknown"

                    || params.data.DimiResultValidity == "Unknown") &&

                    (params.data.DimiResultActuator != "Failed" && params.data.DimiResultAlarm != "Failed" &&

                    params.data.DimiResultOOR != "Failed" && params.data.DimiResultTerm != "Failed" &&

                    params.data.DimiResultValidity != "Failed")) {

                    return  "Unknown";

                }

                else if (params.data.DimiResultActuator == "Failed" || params.data.DimiResultAlarm == "Failed"

                    || params.data.DimiResultOOR == "Failed" || params.data.DimiResultTerm == "Failed") {

                    return "Check";

                }

            }

        }

    }

},

    TripWiseGroupingForExcel: (fieldValue, ReeferOemTypeCd, DimiResultActuator, DimiResultAlarm, DimiResultOOR, DimiResultTerm, DimiMode, DimiResultValidity) => {

    var TripWiseStatusDescription = '*No OEM PTI';
        if (fieldValue != null && fieldValue != undefined && fieldValue != "null") {
            switch (fieldValue.toString()) {

                case 'Off': case '0':

                    return 'Off';

                case 'Expired': case '1':

                    return 'Expired';

                case 'Check': case '2':

                    return 'Check';

                case 'Passed': case '3':

                    return 'Passed';

                case 'Running': case '4':

                    return 'Running';

                case 'Unknown': case '5':

                    return 'Unknown';

                case null:

                    return TripWiseStatusDescription;
            }
        }
        else
            return TripWiseStatusDescription;

},
 
tripWiseFormatterForExcel: (params) => {

    var TripWiseStatusDescription = '-NA-';

    if (params.node.data.ReeferOemTypeCd != null && params.node.data.ReeferOemTypeCd.toUpperCase().trim() != "D") {

        switch (params.value.toString()) {

            case '0':

                return 'Off';

            case '1':

                return 'Expired';

            case '2':

                return 'Check';

            case '3':

                return 'Passed';

            case '4':

                return 'Running';

            case '5':

                return 'Unknown';

        }

        return TripWiseStatusDescription;

    }

    else {
 
        if (params.node.data.DimiMode != null && params.node.data.DimiMode.toUpperCase().trim() == "OFF") {

            TripWiseStatusDescription = 'Off';

        }

        else if (params.node.data.DimiMode != null && params.node.data.DimiMode.toUpperCase().trim() == "ON") {
 
            if (params.node.data.DimiResultActuator == "Passed" && params.node.data.DimiResultAlarm == "Passed" &&

                params.node.data.DimiResultOOR == "Passed" && params.node.data.DimiResultTerm == "Passed"
                && params.node.data.DimiResultValidity == "Passed") {

                TripWiseStatusDescription = "Passed";

            }

            else if ((params.node.data.DimiResultValidity == "Failed") && (

                (params.node.data.DimiResultActuator == "Passed" || params.node.data.DimiResultActuator == "Unknown") &&

                (params.node.data.DimiResultAlarm == "Passed" || params.node.data.DimiResultAlarm == "Unknown") &&

                (params.node.data.DimiResultOOR == "Passed" || params.node.data.DimiResultOOR == "Unknown") &&

                (params.node.data.DimiResultTerm == "Passed" || params.node.data.DimiResultTerm == "Unknown"))) {

                TripWiseStatusDescription = "Expired";

            }

            else if ((params.node.data.DimiResultActuator == "Unknown" || params.node.data.DimiResultAlarm == "Unknown"

                || params.node.data.DimiResultOOR == "Unknown" || params.node.data.DimiResultTerm == "Unknown"

                || params.node.data.DimiResultValidity == "Unknown") &&

                (params.node.data.DimiResultActuator != "Failed" && params.node.data.DimiResultAlarm != "Failed" &&

                params.node.data.DimiResultOOR != "Failed" && params.node.data.DimiResultTerm != "Failed" &&

                params.node.data.DimiResultValidity != "Failed")) {

                TripWiseStatusDescription = "Unknown";

            }

            else if (params.node.data.DimiResultActuator == "Failed" || params.node.data.DimiResultAlarm == "Failed"

                || params.node.data.DimiResultOOR == "Failed" || params.node.data.DimiResultTerm == "Failed") {

                TripWiseStatusDescription = "Check";

            }

        }

    }

    return TripWiseStatusDescription;

},
 
    tripWiseFormatterForExcel: (params) => {
        var TripWiseStatusDescription = '-NA-';
        if (params.node.data.ReeferOemTypeCd != null && params.node.data.ReeferOemTypeCd.toUpperCase().trim() != "D") {
            switch (params.value.toString()) {
                case '0':
                    return 'Off';
                case '1':
                    return 'Expired';
                case '2':
                    return 'Check';
                case '3':
                    return 'Passed';
                case '4':
                    return 'Running';
                case '5':
                    return 'Unknown';
            }
            return TripWiseStatusDescription;
        }
        else {

            if (params.node.data.DimiMode != null && params.node.data.DimiMode.toUpperCase().trim() == "OFF") {
                TripWiseStatusDescription = 'Off';
            }
            else if (params.node.data.DimiMode != null && params.node.data.DimiMode.toUpperCase().trim() == "ON") {

                if (params.node.data.DimiResultActuator == "Passed" && params.node.data.DimiResultAlarm == "Passed" &&
                    params.node.data.DimiResultOOR == "Passed" && params.node.data.DimiResultTerm == "Passed"
                    && params.node.data.DimiResultValidity == "Passed") {
                    TripWiseStatusDescription = "Passed";
                }
                else if ((params.node.data.DimiResultValidity == "Failed") && (
                    (params.node.data.DimiResultActuator == "Passed" || params.node.data.DimiResultActuator == "Unknown") &&
                    (params.node.data.DimiResultAlarm == "Passed" || params.node.data.DimiResultAlarm == "Unknown") &&
                    (params.node.data.DimiResultOOR == "Passed" || params.node.data.DimiResultOOR == "Unknown") &&
                    (params.node.data.DimiResultTerm == "Passed" || params.node.data.DimiResultTerm == "Unknown"))) {
                    TripWiseStatusDescription = "Expired";
                }
                else if ((params.node.data.DimiResultActuator == "Unknown" || params.node.data.DimiResultAlarm == "Unknown"
                    || params.node.data.DimiResultOOR == "Unknown" || params.node.data.DimiResultTerm == "Unknown"
                    || params.node.data.DimiResultValidity == "Unknown") &&
                    (params.node.data.DimiResultActuator != "Failed" && params.node.data.DimiResultAlarm != "Failed" &&
                    params.node.data.DimiResultOOR != "Failed" && params.node.data.DimiResultTerm != "Failed" &&
                    params.node.data.DimiResultValidity != "Failed")) {
                    TripWiseStatusDescription = "Unknown";
                }
                else if (params.node.data.DimiResultActuator == "Failed" || params.node.data.DimiResultAlarm == "Failed"
                    || params.node.data.DimiResultOOR == "Failed" || params.node.data.DimiResultTerm == "Failed") {
                    TripWiseStatusDescription = "Check";
                }
            }
        }
        return TripWiseStatusDescription;
    },
   
    HumiditySettingFormatterforExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.Humidity != null && params.Humidity != '' && params.Humidity != '-NA-') {
                if (params.Humidity.toString().trim() == "0" || params.HumiditySetpointStatus == "O")
                    return "Off";
                else if (params.Humidity.toString().trim() == "-999" || params.Humidity.toString() == "OOR") // WI 26545
                    return "OOR";
                else
                    return parseFloat(params.Humidity).toFixed(1).toString();
            }
            return '-NA-';
        }
        return '-NA-';
    },
    FillLevelGalTraceFormatterforExcel: (params) => {
        if (params.HasFuelSensor != null && params.HasFuelSensor != undefined
            && params.HasFuelSensor === false) {
            return "No Sensor";
        }
        else {
            if (params != null && params != undefined && params != '') {
                var tempRoundingValue = "2";
                if (params.FuelLevelQualifier != null && ((params.FuelLevelQualifier == 'A') || (params.FuelLevelQualifier == 'P'))) {
                    return (params.FuelLevel != null) ? parseFloat(params.FuelLevel.toFixed(parseInt(tempRoundingValue))) : "-NA-";
                }
                else {
                    return params.FuelLevelQualifierDesc;
                }
            }
            return '-NA-';
        }
    },
    BattVoltageFormatterforExcel: (params) => {
        /*if (params != null && params != undefined) {
            var tempRoundingValue = "1";
            return (params != null) ? parseFloat(params.toFixed(parseInt(tempRoundingValue))) : "-NA-";
        }
        else
            return '-NA-';
        */
        if (params != null && params != undefined && params!=-999) {
            //var tempRoundingValue = "1";
            //return (params != null) ? parseFloat(params.toFixed(parseInt(tempRoundingValue))) :'-NA-';
            return parseFloat(params).toFixed(1).toString();
        }
        else
            return '-NA-';
    },
    FillLevelTraceFormatterforExcel: (params) => {
        if (params.HasFuelSensor != null && params.HasFuelSensor != undefined
            && params.HasFuelSensor === false) {
            return "No Sensor";
        }
        else {
            if (params != null && params != undefined && params != '') {
                if (params.HasFuelSensor != null && params.HasFuelSensor.toString().toUpperCase().trim() == "TRUE") {
                    if (params.FuelLevelQualifier != null && ((params.FuelLevelQualifier == 'A') || (params.FuelLevelQualifier == 'P'))) {
                        if (params.FractionDisplay != null) {
                            return  '\t' + params.FractionDisplay;
                        }
                        else {
                            if (params.FuelLevelPct != null) {
                                var tempRoundingValue = "2";
                                return parseFloat(params.FuelLevelPct.toFixed(parseInt(tempRoundingValue))) + " %";
                            }
                            else {
                                return "Fuel Reading Unavailable";
                            }
                        }
                    }
                    else {
                        if (params.FuelLevelQualifier == "S")
                            return "Sensor Error";
                        else
                            return params.FuelLevelQualifierDesc;
                    }
                }
                else
                    return '-NA-';
            }
            else
                return '-NA-';
        }
    },
    FuelSensorTraceFormatterforExcel: (params) => {
        if (params.HasFuelSensor != null && params.HasFuelSensor != undefined
            && params.HasFuelSensor === false) {
            return "No Sensor";
        }
        else {
            if (params != null && params != undefined && params != '') {
                if (params.FuelLevelQualifier == "" || params.FuelLevelQualifier == null) {
                    return "-NA-";
                }
                else {

                    if (params.FuelLevelQualifier == "C" || params.FuelLevelQualifier == "N" || params.FuelLevelQualifier == "S" || params.FuelLevelQualifier == "U") {
                        return params.FuelLevelQualifierDesc;
                    }
                    else {
                        return "Present";
                    }

                }
            }
            return '-NA-';
        }
    },
    GeofenceCoordinatesFormatter: (params) => {
        var coordinates = '';
        var lstCoordinates = params.value;
        $.each(lstCoordinates, function (index, value) {
            coordinates += value.Latitude + ', ' + value.Longitude + '; ';
        });

        return coordinates;
    },    
    GeofenceCoordinatesFormatterforExcel: (params) => {
        var coordinates = '';
        var lstCoordinates = params;
        $.each(lstCoordinates, function (index, value) {
            coordinates += value.Latitude + ', ' + value.Longitude + '; ';
        });

        return coordinates;
    },
    
    ControlledAtmosphereModeforExcel: (params) => {
        if (params != null && params != undefined && params != '') {
            if (params.ControlledAtmosphereMode != null && params.ControlledAtmosphereMode != '-NA-' && params.ControlledAtmosphereMode != undefined && params.ControlledAtmosphereMode != '') {
                if (params.ReeferOEMTypeCd != null && params.ReeferOEMTypeCd != '') {
                    if (params.ReeferOEMTypeCd.trim() == 'S') {

                        if (params.ControlledAtmosphereMode.toString().toUpperCase().trim() == "ON")
                            return "CA On";
                        else if (params.ControlledAtmosphereMode.toString().toUpperCase().trim() == "OFF")
                            return "Off";
                        else if (params.ControlledAtmosphereMode.toString().toUpperCase().trim() == "AV")
                            return "AV On";
                        else if (params.ControlledAtmosphereMode.toString().toUpperCase().trim() == "AVPLUS")
                            return "AV+ On";
                        else
                            return params.ControlledAtmosphereMode.toString();
                    }
                    else if (params.ControlledAtmosphereMode.toString().toUpperCase().trim() == "UNITOFF")
                        return "Unit Off";
                    else
                        return params.ControlledAtmosphereMode.toString();
                }
                else
                    return '-NA-';
            }
            else
                return '-NA-';
        }
        return '-NA-';
    },
    YearFromdateTypeFormatterForExcel: (params) => {
        if (params != null && params != undefined && params.toString() != '') {
            var eventdttm = new Date(params.toString().trim());
            return eventdttm.getFullYear();
        }
        else
            return '-NA-';
    },
    YearFromdateTypeFormatterForExcelNew: (params) => {
        if (params != null && params != undefined && params.toString() != '') {
            return params;
        }
        else
            return '-NA-';
    },
    YearFromdateTypeFormatter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.ManufacturedDate != null && params.data.ManufacturedDate != undefined) {
                var eventdttm = new Date(params.data.ManufacturedDate.toString());
                return eventdttm.getFullYear();
            }
        }

        return '-NA-';
    },
    YearFromdateTypeFormatterForFilter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.ManufacturedDate != null && params.data.ManufacturedDate != undefined) {
                var eventdttm = new Date(params.data.ManufacturedDate.toString());
                return eventdttm.getFullYear();
            }
        }

        return '-NA-';
    },
    ManufactureYearSorting: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.ManufacturedDate != null && params.data.ManufacturedDate != undefined) {
                var eventdttm = new Date(params.data.ManufacturedDate.toString());
                return eventdttm.getFullYear();
            }
        }

        return 0;
    },
    
    CopyCommandFormatters(params) {
        if (params != null && params != undefined && !params.node.group && params.column != null && params.column != undefined && params.column.colId != null && params.column.colId != undefined) {
            var returnValue = " ";
            switch (params.column.colId) {

                case 'RCDID': case 'RCDId': case 'TowerBaseStationID': case 'ICCID': case 'MSISDN': case 'SIM_IMSI': case 'RcdID': case 'Value1':
                case 'Value3': case 'Value4':
                    {
                        if (params.value == undefined || params.value == "-NA-")
                            returnValue = "-NA-";
                        else
                            returnValue = params.value;
                    }
                    break;
                case 'CO2Setpoint': case 'CO2Reading': case 'O2Setpoint': case 'O2Reading': case 'EvaporatorTemp':
                case 'CompositeSuctionPressure': case 'CompressorSuctionTemp': case 'DischargePressure': case 'CompressorDischargeTemp':
                case 'CondenserTemperature': case 'CondenserFanOutPut': case 'LowSpeedEvaporatorFanOutPut': case 'HighSpeedEvaporatorFanOutPut':
                case 'HeaterOnTime': case 'HotGasValveOpening': case 'EconomizerValveOpening': case 'CompressorFrequency': case 'VentPositionSensorCMH':
                case 'TotalCurrentDraw': case 'LineVoltage1': case 'LineVoltage2': case 'LineVoltage3': case 'VFD': case 'LineFrequency': 
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.sensorDataFormatterforExcel(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break;
                case 'TemperatureUnit': case 'SetPoint': case 'SupplyTemp1': case 'SupplyTemp2': case 'ReturnTemp1': case 'ReturnTemp2':
                case 'AmbientTemp': case 'EvaporatorTemp': case 'CompressorSuctionTemp': case 'CompressorDischargeTemp':
                case 'CondenserTemperature': case 'USDA1Temp': case 'USDA2Temp': case 'USDA3Temp': case 'Cargo4Temp':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.TemperatureFormatterforExcel(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'DeviceTemp':
                    {
                        if (params != undefined && params != null)
                            returnValue = this.TemperatureFormatterForDeviceTemp(params);//RCNG-1099
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM':
                case 'CreatedDTTM': case 'CreateDTTM': case 'StatusDate': case 'SubmittedOn': case 'EndDate': case 'scheduledCreatedDTTM':
                case 'StartDate': case 'LastPreTripDTTM': case 'PTRDateTime': case 'TTL': case 'GPSDTTM': case 'DeviceDataTime': case 'ExpirationTime':
                case 'EarliestDepartureDtm': case 'ArrivalDtm': case 'TWTime': case "DLEventDTTM":
                    {
                        returnValue = this.dateTypeFormatterforCopy(params.value);
                    }
                    break
                case 'Name': case 'Description': case 'RCDBootloaderVersion': case 'PTResult': case 'VesselCd': case 'DeviceType':
                case 'GeofenceTag': case 'VesselName': case 'Origin': case 'Handler': case 'TripStatusCdAndDFlag':
                case 'UserName': case 'TagName': case 'Created': case 'DeploymentName': case 'CreatedBy': case 'ModifiedBy': case 'SubmittedBy':
                case 'FullName': case 'Zip': case 'CCSeverityLevelGenset': case 'OEMModel':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.stringTypeFormatterChildFormsForCopy(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break;

                case 'CommentExists': case 'CommentExistsGenset': case 'CommentExistsDC': case 'CommentExistsChassis':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.CommentExistsforExcel(params.value);
                    }
                    break;
                case 'IsInsideGeofence': case 'IsActive': case 'HasOilPressureSwitch': case 'DCXDownloads':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.YesNoConverterforExcel(params.value);
                    }
                    break
                case 'ReeferOEMTypeCd': case 'ÓEMTypeCD':
                    {
                        returnValue = this.GetOEMTypeDescription(params.value);
                    }
                    break;
                case 'DryGPSHDOP': case 'DryGPSSatelliteCount': case 'ChassisGPSHDOP': case 'ChassisGPSSatelliteCount':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.GPSfloatTypeFormatterForExcel(params.value);
                    }
                    break;
                case 'ExtBattVoltage': case 'BattVoltage': case 'DeviceBattery':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.BattVoltageFormatterforExcel(params.value);
                    }
                    break;
                case 'DeviceConfig': case 'GuestReeferMode':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.GuestReeferModeFormatterForExcel(params.value);
                    }
                    break;
                case 'DrySpeed': case 'ChassisSpeed': case 'Speed':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.SpeedConverterforExcel(params.value);
                    }
                    break;
                case 'RCDPOWERSOURCECD': if (params.value != undefined && params.value != null) returnValue = this.rcdPowerSourceFormatterforExcel(params.value);
                    break;
                case 'RunState': if (params.value != undefined && params.value != null) returnValue = this.RunStateFormatterGroupingForExcel(params.value);
                    break;
                case 'R_HighestSeverityLevel': {
                    if (params.value != undefined && params.value != null)
                        returnValue = this.statusIndicatorforALMforExcel(params.value);
                }
                    break;
                case 'MASeverityLevel':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = this.statusIndicatorforALMforExcel(params.node.data.MASeverityLevel);
                    }
                    break;
                case 'AlertSeverityID': if (params.value != undefined && params.value != null) returnValue = this.statusIndicatorforALRforExcel(params.value); break;
                case 'IsOnVessel': if (params.value != undefined && params.value != null) returnValue = this.isOnVesselFormatterChildForms(params.value); break;
                case 'GPSLastLock': if (params.value != undefined && params.value != null) returnValue = this.secondsToTimeConverterForExcel(params.node.data.GPSLastLock); break;
                case 'AlarmsList': if (params.value != undefined && params.value != null) returnValue = this.AlarmListFormatterforExcel(params.value); break;
                case 'TemperatureUnit': if (params.value != undefined && params.value != null) returnValue = this.TemperatureFormatterForBookingforExcel(params.value); break;
                case 'ThreePhaseCurrent': if (params.value != undefined && params.value != null) returnValue = this.Current3PhaseFormatterforExcel(params.value); break;
                case 'FilerepositoryActionCD': if (params.value != undefined && params.value != null) returnValue = this.GetFileRepositoryActionDesc(params.value); break;
                case 'GeofenceCategoryCd': if (params.value != undefined && params.value != null) returnValue = this.fenceTypeFormatterForExcel(params.value); break;
                case 'IgnitionOn': if (params.value != undefined && params.value != null) returnValue = this.gensetSwitchFormatterForExcel(params.value); break;
                case 'BatteryStatus': if (params.value != undefined && params.value != null) returnValue = this.dryPwrStateFormatterForExcel(params.node.data.BatteryStatus); break;
                case 'ChassisBatteryStatus': if (params.value != undefined && params.value != null) returnValue = this.ChassisBatteryStatusFormatterForExcel(params.node.data.ChassisBatteryStatus); break;
                case 'BreakSignal': if (params.value != undefined && params.value != null) returnValue = this.BrakeSignalFormatterForExcel(params.value); break;
                case 'TripWiseExpiration': if (params.value != undefined && params.value != null) returnValue = this.TripWiseExpirationFormatterforExcel(params.value); break; //RCNG-169
                case 'CustomerName': if (params.value != undefined && params.value != null) returnValue = this.stringTypeFormatterFor3PExcel(params.value); break;
                case 'TWState': if (params.value != undefined && params.value != null) returnValue = this.tripWiseFormatterForExcel(params); break;
                case 'PWR': if (params.value != undefined && params.value != null) returnValue = this.pwrStateFormatterChassisforExcel(params.value); break;
                case 'Loaded': if (params.value != undefined && params.value != null) returnValue = this.LoadedFormatterForExcel(params.value); break;
                case "RSSI": if (params.value != undefined && params.value != null) returnValue = this.RSSIFormatterGroupingForExcel(params.value); break;
                case "GPSCoords": if (params.value != undefined && params.value != null) returnValue = this.GPSCoordsFormatterForGrid(params.value); break;  
                case 'FractionDisplay': {

                    if (params.value != undefined && params.value != null) {

                        var FuelLevelQualifier;
                        if (params.node.data != undefined
                            && params.node.data != null) {
                            FuelLevelQualifier = params.node.data.FuelLevelQualifier;
                        }
                        else {
                            FuelLevelQualifier = "";
                        }

                        var HasFuelSensor;
                        if (params.node.data != undefined
                            && params.node.data != null) {
                            HasFuelSensor = params.node.data.HasFuelSensor;
                        }
                        else {
                            HasFuelSensor = "";
                        }

                    }


                    var isFuelinfo = {
                        FuelLevelQualifier: FuelLevelQualifier,
                        FractionDisplay: params.value,
                        HasFuelSensor: HasFuelSensor
                    };
                    if (FuelLevelQualifier != undefined && FuelLevelQualifier != null && HasFuelSensor != undefined && HasFuelSensor != null)
                        returnValue = this.FillLevelTraceFormatterforExcel(isFuelinfo);
                }
                case 'HasFuelSensor': {
                    if (params.node.data != undefined
                        && params.node.data != null) {
                        var FuelLevelQualifier;
                        if (params.node.data != undefined
                            && params.node.data != null) {
                            FuelLevelQualifier = params.node.data.FuelLevelQualifier;
                        }
                        else {
                            FuelLevelQualifier = "";
                        }

                        var FuelLevelQualifierDesc;
                        if (params.node.data != undefined
                            && params.node.data != null) {
                            FuelLevelQualifierDesc = params.node.data.FuelLevelQualifierDesc;
                        }
                        else {
                            FuelLevelQualifierDesc = "";
                        }

                        var isFuelinfo2 = {
                            HasFuelSensor: params.value,
                            FuelLevelQualifier: FuelLevelQualifier,
                            FuelLevelQualifierDesc: FuelLevelQualifierDesc
                        };

                        if (FuelLevelQualifier != undefined && FuelLevelQualifier != null)
                            returnValue = this.FuelSensorTraceFormatterforExcel(isFuelinfo2);
                    }
                    break;
                }
                case 'ManufacturedDate':
                    {
                        if (params.value != undefined && params.value != null) returnValue = this.YearFromdateTypeFormatterForExcelNew(params.value);
                    }
                    break;
                case 'AssetType': returnValue = this.AssetTypeFormatterForExcel(params.value); break;
                case 'PreTrip': {
                    if (params.value != undefined && params.value != null) {
                        if (this.state.formName == "PreTrip")
                            returnValue = this.PTIStateforExcel(params.value);
                        else
                            returnValue = this.stringTypeFormatterChildFormsForCopy(params.value);
                    }
                }
                    break;
                case 'CCSeverityLevel':
                    {
                        if (params.value != undefined && params.value != null) {

                            var IsCargoCare;
                            //if (params.node.rowIndex != undefined && params.node.rowIndex != null) {
                            //    if (params.node.data != undefined
                            //        && params.node.data != null)
                            //        IsCargoCare = params.node.data.IsCargoCare;
                            //}
                            if (params.node != undefined && params.node != null && params.node.data != undefined && params.node.data != null)
                                IsCargoCare = params.node.data.IsCargoCare;
                            else {
                                IsCargoCare = false;
                            }
                            if (IsCargoCare != undefined && IsCargoCare != null)
                                returnValue = this.CargoCareFormatterforExcel({ isCargocare: IsCargoCare, CCSeverityLevel: params.value });
                        }
                    }
                    break;
                case 'Door1Open':
                    {
                        if (params.value != undefined && params.value != null) {
                            returnValue = this.DoorFormatterExcel(params.value);
                        }
                    }
                    break;
                case 'Humidity':
                    {
                        if (params.value != undefined && params.value != null) {
                            var HumiditySetpointStatus;
                            if (params.node.rowIndex != undefined && params.node.rowIndex != null
                                && params.node.data != undefined
                                && params.node.data != null) {
                                HumiditySetpointStatus = params.node.data.HumiditySetpointStatus;
                            }
                            else {
                                HumiditySetpointStatus = "";
                            }

                            if (HumiditySetpointStatus != undefined && HumiditySetpointStatus != null)
                                returnValue = this.HumiditySettingFormatterforExcel({ Humidity: params.value, HumiditySetpointStatus: HumiditySetpointStatus });
                        }
                    }
                    break;
                case 'ControlledAtmosphereMode': {
                    if (params.value != undefined && params.value != null) {
                        var ReeferOEMTypeCd;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            ReeferOEMTypeCd = params.node.data.ReeferOEMTypeCd;
                        }
                        else {
                            ReeferOEMTypeCd = "";
                        }

                        if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null)
                            returnValue = this.ControlledAtmosphereModeforExcel({ ReeferOEMTypeCd: ReeferOEMTypeCd, ControlledAtmosphereMode: params.value });
                    }
                }
                    break;
                case 'SuctionModulationValveOpening': {
                    if (params.value != undefined && params.value != null) {
                        var ReeferOEMTypeCd;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            ReeferOEMTypeCd = params.node.data.ReeferOEMTypeCd;
                        }
                        else {
                            ReeferOEMTypeCd = "";
                        }

                        var SuctionModulationValveOpeningQualifier;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            SuctionModulationValveOpeningQualifier = params.node.data.SuctionModulationValveOpeningQualifier;
                        }
                        else {
                            SuctionModulationValveOpeningQualifier = "";
                        }

                        var SuctionModulationValveOpeningData = {
                            ReeferOEMTypeCd: ReeferOEMTypeCd,
                            SuctionModulationValveOpeningQualifier: SuctionModulationValveOpeningQualifier,
                            SuctionModulationValveOpening: params.value
                        };

                        if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null && SuctionModulationValveOpeningQualifier != undefined && SuctionModulationValveOpeningQualifier != null)
                            returnValue = this.sensorDataOpenSucFormatterForExcel(SuctionModulationValveOpeningData);
                    }
                }
                    break;
                case 'CondenserPressure': {
                    if (params.value != undefined && params.value != null) {
                        var ReeferOEMTypeCd;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            ReeferOEMTypeCd = params.node.data.ReeferOEMTypeCd;
                        }
                        else {
                            ReeferOEMTypeCd = "";
                        }

                        if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null)
                            returnValue = this.sensorDataPCondFormatterExcel({ ReeferOEMTypeCd: ReeferOEMTypeCd, CondenserPressure: params.value });
                    }
                }
                    break;
                case 'EvaporatorExpansionValveOpening': {
                    if (params.value != undefined && params.value != null) {
                        var ReeferOEMTypeCd;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            ReeferOEMTypeCd = params.node.data.ReeferOEMTypeCd;
                        }
                        else {
                            ReeferOEMTypeCd = "";
                        }
                        var EEVData = {
                            ReeferOEMTypeCd: ReeferOEMTypeCd,
                            EvaporatorExpansionValveOpening: params.value
                        };
                        if (ReeferOEMTypeCd != undefined && ReeferOEMTypeCd != null)
                            returnValue = this.sensorDataOpenExpFormatterExcel(EEVData);
                    }
                }
                    break;
                case 'GensetRunning': {
                    if (params.value != undefined && params.value != null) {
                        var HasOilPressureSwitch;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            HasOilPressureSwitch = params.node.data.HasOilPressureSwitch;
                        }
                        else {
                            HasOilPressureSwitch = false;
                        }

                        if (HasOilPressureSwitch != undefined && HasOilPressureSwitch != null)
                            returnValue = this.gensetRunningFormatterforExcel({ GensetRunning: params.value, HasOilPressureSwitch: HasOilPressureSwitch });
                    }
                }
                    break;
                case 'FuelLevel':{
                    if (params.value != undefined && params.value != null) {
                        var FuelLevelQualifier;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            FuelLevelQualifier = params.node.data.FuelLevelQualifier;
                        }
                        else {
                            FuelLevelQualifier = "";
                        }
                        var FuelLevelQualifierDesc;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            FuelLevelQualifierDesc = params.node.data.FuelLevelQualifierDesc;
                        }
                        else {
                            FuelLevelQualifierDesc = "";
                        }
                       
                        var HasFuelSensor;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            HasFuelSensor = params.node.data.HasFuelSensor;
                        }
                        else {
                            HasFuelSensor = false;
                        }

                        var isFuelinfo3 = {
                            FuelLevel: params.value,
                            FuelLevelQualifier: FuelLevelQualifier,
                            FuelLevelQualifierDesc: FuelLevelQualifierDesc,
                            HasFuelSensor: HasFuelSensor
                        };
                        if (FuelLevelQualifier != undefined && FuelLevelQualifier != null &&
                            FuelLevelQualifierDesc != undefined && FuelLevelQualifierDesc != null &&
                            HasFuelSensor != undefined && HasFuelSensor != null)
                            returnValue = this.FillLevelGalTraceFormatterforExcel(isFuelinfo3);
                    }
                }
                    break;
                case 'FractionDisplay': {
                    if (params.value != undefined && params.value != null) {
                        var FuelLevelQualifier;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            FuelLevelQualifier = params.node.data.FuelLevelQualifier;
                        }
                        else {
                            FuelLevelQualifier = "";
                        }
                        var FuelLevelQualifierDesc;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            FuelLevelQualifierDesc = params.node.data.FuelLevelQualifierDesc;
                        }
                        else {
                            FuelLevelQualifierDesc = "";
                        }
                        var FractionDisplay;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            FractionDisplay = params.node.data.FractionDisplay;
                        }
                        else {
                            FractionDisplay = false;
                        }
                        var HasFuelSensor;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            HasFuelSensor = params.node.data.HasFuelSensor;
                        }
                        else {
                            HasFuelSensor = false;
                        }

                        var isFuelinfo4 = {
                            FuelLevel: params.value,
                            FuelLevelQualifier: FuelLevelQualifier,
                            FuelLevelQualifierDesc: FuelLevelQualifierDesc,
                            FractionDisplay: FractionDisplay,
                            HasFuelSensor: HasFuelSensor
                        };
                        if (FuelLevelQualifier != undefined && FuelLevelQualifier != null &&
                            FuelLevelQualifierDesc != undefined && FuelLevelQualifierDesc != null &&
                            FractionDisplay != undefined && FractionDisplay != null &&
                            HasFuelSensor != undefined && HasFuelSensor != null)
                            returnValue = this.FillLevelGalTraceFormatterforExcel(isFuelinfo4);
                    }
                }
                    break;
                case 'DevicePowerSourceCd': {
                    if (params.value != undefined && params.value != null) {
                        var DeviceConfig;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            DeviceConfig = params.node.data.DeviceConfig;
                        }
                        else {
                            DeviceConfig = false;
                        }

                        var DeviceType;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            DeviceType = params.node.data.DeviceType;
                        }
                        else {
                            DeviceType = "";
                        }

                        var ispwrStateFormatter = {
                            DeviceType: DeviceConfig,
                            DevicePowerSourceCd: params.node.data.DevicePowerSourceCd,
                            DeviceTypeCd: DeviceType
                        };
                        returnValue = this.pwrStateFormatterforExcel(ispwrStateFormatter);
                    }
                }
                    break;
                case 'Door1OpenChassis': {
                    if (params.value != undefined && params.value != null) {
                        var HasDoorSensor;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && params.node.data != undefined
                            && params.node.data != null) {
                            HasDoorSensor = params.node.data.HasDoorSensor;
                        }
                        else {
                            HasDoorSensor = false;
                        }

                        var door1ChassisStateFormatter = {
                            HasDoorSensor: HasDoorSensor,
                            Door1OpenChassis: params.value
                        };

                        if (HasDoorSensor != undefined && HasDoorSensor != null)
                            returnValue = this.DoorFormatterChassisforExcel(door1ChassisStateFormatter);
                    }
                }
                    break;
                case 'HumiditySetpoint':
                    {
                        returnValue = this.HumiditySetpointForExcel(params.value);
                    }
                    break;
                default: {
                    if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
                        returnValue = params.value;
                    }
                    else if (params.column.colId === "0") {
                        return "";
                    }
                    else
                        returnValue = "-NA-";
                }
            }

            return returnValue;
        }

    },

    pwrStateFormatter: (params) => {
        var element = document.createElement("span");
        var imageElement = document.createElement("img");
        if (params.data != null && params.data != undefined) {
            if (params.data.DeviceType != null && params.data.DeviceType != undefined && params.data.DeviceType.toString().toUpperCase().trim() == "GT1200") {
                if (params.data.AssetType != null && params.data.AssetType != undefined && params.data.AssetType.toString().toUpperCase().trim() == "C") {
                    if (params.data.ChassisPWR != null && params.data.ChassisPWR != undefined && params.data.ChassisPWR.toString().toUpperCase().trim() == "A") {
                        element.className = "PlugSolid";
                        element.title = "Powered"
                        imageElement.src = PlugSolid;
                        element.appendChild(imageElement);
                        return element;
                    }
                    else {
                        if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                            if (params.data.DevicePowerSourceCd == "C") {
                                element.className = "pwr_grid_icon";
                                element.title = "Critical"
                                imageElement.src = batterycritical;
                            }
                            else if (params.data.DevicePowerSourceCd == "L") {
                                element.className = "pwr_grid_icon";
                                element.title = "Low"
                                imageElement.src = batterylow;
                            }
                            else if (params.data.DevicePowerSourceCd == "N") {
                                element.className = "pwr_grid_icon";
                                element.title = "Normal"
                                imageElement.src = batterynormal;
                            }
                            element.appendChild(imageElement);
                            return element;
                        }
                    }
                }
                else {
                    if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                        if (params.data.DevicePowerSourceCd == "C") {
                            element.className = "pwr_grid_icon";
                            element.title = "Critical"
                            imageElement.src = batterycritical;
                        }
                        else if (params.data.DevicePowerSourceCd == "L") {
                            element.className = "pwr_grid_icon";
                            element.title = "Low"
                            imageElement.src = batterylow;
                        }
                        else if (params.data.DevicePowerSourceCd == "N") {
                            element.className = "pwr_grid_icon";
                            element.title = "Normal"
                            imageElement.src = batterynormal;
                        }
                        element.appendChild(imageElement);
                        return element;
                    }
                }
            }
            else if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                if (params.data.DevicePowerSourceCd == "B") {
                    element.className = "BatteryIndicator";
                    element.title = "On Battery"
                    imageElement.src = BatteryIndicator;
                }
                else if (params.data.DeviceConfig.toString().toUpperCase().trim() == "TRUE" && params.data.DevicePowerSourceCd == "A") {
                    element.className = "DualColorBattery";
                    element.title = "Charging"
                    imageElement.src = DualColorBattery;
                }
                else {
                    element.className = "PlugSolid";
                    element.title = "Powered"
                    imageElement.src = PlugSolid;
                }

                element.appendChild(imageElement);
                return element;
            }

        }

        return '-NA-';
    },

    PwrSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.DeviceType != null && params.data.DeviceType != undefined && params.data.DeviceType.toString().toUpperCase().trim() == "GT1200") {
                if (params.data.AssetType != null && params.data.AssetType != undefined && params.data.AssetType.toString().toUpperCase().trim() == "C") {
                    if (params.data.ChassisPWR != null && params.data.ChassisPWR != undefined && params.data.ChassisPWR.toString().toUpperCase().trim() == "A") {
                        return "1";
                    }
                    else {
                        if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                            if (params.data.DevicePowerSourceCd == "C")
                                return "4";
                            else if (params.data.DevicePowerSourceCd == "L")
                                return "5";
                            else if (params.data.DevicePowerSourceCd == "N")
                                return "6";
                        }
                    }
                }
                else {
                    if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                        if (params.data.DevicePowerSourceCd == "C")
                            return "4";
                        else if (params.data.DevicePowerSourceCd == "L")
                            return "5";
                        else if (params.data.DevicePowerSourceCd == "N")
                            return "6";
                    }
                }
            }
            else if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                if (params.data.DevicePowerSourceCd == "B")
                    return "2";
                else if (params.data.DeviceConfig.toString().toUpperCase().trim() == "TRUE" && params.data.DevicePowerSourceCd == "A")
                    return "3";
                else
                    return "1";
            }
            return "7";
        }
    },

    pwrStateFormatterForFilter: (params) => {
        var title = "";
        if (params.data != null && params.data != undefined) {
            if (params.data.DeviceType != null && params.data.DeviceType != undefined && params.data.DeviceType.toString().toUpperCase().trim() == "GT1200") {
                if (params.data.AssetType != null && params.data.AssetType != undefined && params.data.AssetType.toString().toUpperCase().trim() == "C") {
                    if (params.data.ChassisPWR != null && params.data.ChassisPWR != undefined && params.data.ChassisPWR.toString().toUpperCase().trim() == "A") {
                        title = "Powered";
                    }
                    else {
                        if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                            if (params.data.DevicePowerSourceCd == "C")
                                title = "Critical";
                            else if (params.data.DevicePowerSourceCd == "L")
                                title = "Low";
                            else if (params.data.DevicePowerSourceCd == "N")
                                title = "Normal";
                        }
                    }

                }
                else {
                    if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                        if (params.data.DevicePowerSourceCd == "C")
                            title = "Critical";
                        else if (params.data.DevicePowerSourceCd == "L")
                            title = "Low";
                        else if (params.data.DevicePowerSourceCd == "N")
                            title = "Normal";
                    }
                }
            }
            else if (params.data.DevicePowerSourceCd != null && params.data.DevicePowerSourceCd != undefined) {
                if (params.data.DevicePowerSourceCd == "B") {
                    title = "On Battery";
                }
                else if (params.data.DeviceConfig.toString().toUpperCase().trim() == "TRUE" && params.data.DevicePowerSourceCd == "A") {
                    title = "Charging";
                }
                else {
                    title = "Powered";
                }
            }
            return title;
        }
    },

    runStateFormatter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.RunState != null && params.data.RunState != undefined) {
                if ((params.data.RunState.toString().toUpperCase().trim()) == 'I')
                    return params.value = '<span title="Running" class="fas fa-power-off GridIcons greenText"></span>';

                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'S')
                    return params.value = '<span title="Standby" class="fas fa-power-off GridIcons greytext"></span>';

                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'X')
                    return params.value = '<span title="Faulty" class="fas fa-power-off GridIcons orangetext"></span>';


                else if ((params.data.RunState.toString().toUpperCase().trim()) == 'O')
                    return params.value = '<span title="Offline" class="fas fa-horizontal-rule"></span>';

                else
                    return '-NA-';

            }

            return '-NA-';
        }
    },

    commandStatusSorting: (params) => {
        if (params.data != null && params.data != undefined && params.data != '') {
            if (params.data.Status != null && params.data.Status != "" && params.data.Status != undefined) {
                var commandStatus = params.data.Status.toUpperCase().trim();                
                 if (commandStatus == 'COMMANDACCEPTEDBYBUSYRCD')
                    return "1";
                else if (commandStatus == 'COMMANDACCEPTEDBYRCD')
                    return "10";
                else if (commandStatus == 'AWAITINGPREREQUISITES')
                    return "11";
                else if (commandStatus == 'CANCELLED')
                    return "12";
                else if (commandStatus == 'SYNCCANCELLED')
                    return "13";
                else if (commandStatus == 'CANCELLATIONREQUEST')
                    return "14";
                else if (commandStatus == 'DISCARDED')
                    return "15";  
                else if (commandStatus == 'ERROR')
                    return "16";
                else if (commandStatus == 'SYNCERROR')
                    return "17";                
                else if (commandStatus == 'ISSUED')
                    return "18";
                else if (commandStatus == 'PENDING')
                    return "19";
                else if (commandStatus == 'AWAITINGSYNC')
                    return "2";
                else if (commandStatus == 'RETRY')
                     return "20";
                 else if (commandStatus == 'REJECTED')
                     return "21";
                 else if (commandStatus == 'SUCCESS')
                     return "3";
                 else if (commandStatus == 'UNDELIVERABLE')
                     return "4";
                 else if (commandStatus == 'UNKNOWN')
                     return "5";   
                else if (commandStatus == 'VALIDATIONPENDING')
                     return "6";    
                 else if (commandStatus == 'SENTTOVC')
                     return "7";  
                 else if (commandStatus == 'EXPIRED')
                     return "8";
                else
                    return "9";
            }
        }
    },

    TripstatusIndicator: (params) => {
        var element = document.createElement("span");
        element.className = "reefer-alert";
        var deviationFlg = '';
        if (params.value != null && params.value != undefined && params.value != '' && params.value != '-NA-') {
            var imageElement = document.createElement("img");
            var valueString = params.value.toString();
            var arrList = valueString.split(':');
            if (arrList.length == 2) {
                var cLogStatusvalue = arrList[0];
                deviationFlg = arrList[1];
                switch (cLogStatusvalue.toUpperCase().trim()) {
                    case 'A':
                        imageElement.src = TripInprogress;
                        break;
                    case 'C':
                        if (deviationFlg == "True")
                            imageElement.src = TripCompletedDeviation; /* WI19591 checking Trip is deviated */
                        else
                            imageElement.src = TripCompleted;
                        break;
                    case 'D':
                        imageElement.src = TripProblemetic;
                        break;
                    case 'P':
                        imageElement.src = TripPending;
                        break;
                    case 'R':
                        imageElement.src = TripDeleted;
                        break;
                    case 'X':
                        if (deviationFlg == "True")
                            imageElement.src = TripCancelDeviation; /* WI19591 checking Trip is deviated */
                        else
                            imageElement.src = TripCancel;
                        break;
                    default:
                        break;

                }
            }

            element.appendChild(imageElement);
            return element;
        }
        return '-NA-';
    },

    TripSorting: (params) => {
        if (params != null && params != undefined) {
            if (params.data != undefined && params.data != null) {
                if (params.data.TripStatusCdAndDFlag != null && params.data.TripStatusCdAndDFlag != undefined) {
                    return params.data.TripStatusCdAndDFlag;
                }
            }
        }

        return '-NA-';
    },

    gensetSwitchFormatterImg: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.IgnitionOn != null && params.data.IgnitionOn != undefined) {
                if (params.data.IgnitionOn.toString().toUpperCase().trim() == "TRUE")
                    return '<div class="power-onbg"><span class="fa fa-power-off power-icon"></span></div>';
                else if (params.data.IgnitionOn.toString().toUpperCase().trim() == "FALSE")
                    return '<div class="power-offbg"><span class="fa fa-power-off power-icon"></span></div>';
                else
                    return '';
            }
            //return params.value;
        }

        return '';
    },

    gensetRunningFormatter: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.HasOilPressureSwitch != null && params.data.GensetRunning != null) {
                if (params.data.HasOilPressureSwitch.toString().toUpperCase().trim() == "TRUE") {

                    var element = document.createElement("span");
                    element.className = "reefer-alert";
                    var imageElement = document.createElement("img");

                    if (params.data.OEMTypeCD != null && params.data.OEMTypeCD.toString().toUpperCase().trim() == "C") {
                        return '';
                    }
                    else {
                        if (params.data.GensetRunning.toString().toUpperCase().trim() == "0" || params.data.GensetRunning.toString().toUpperCase().trim() == "FALSE")
                            imageElement.src = NotRunning; //No
                        else if (params.data.GensetRunning.toString().toUpperCase().trim() == "1" || params.data.GensetRunning.toString().toUpperCase().trim() == "TRUE")
                            imageElement.src = Running; //Yes
                        else
                            return '';
                        element.appendChild(imageElement);
                        return element;
                    }
                }
                else
                    return '';
            }
            else
                return '';
        }
        else
            return '';
    },
    TempSensorHeaderFormatter: (params) => {
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        if (params.colDef.headerName != null && params.colDef.headerName != "") {
            if (tempUnitCd.toUpperCase() == "F")
                return params.colDef.headerName + " (°F)";
            else
                return params.colDef.headerName + " (°C)";
        }
    },
    TemperatureValueFormatter: (params) => {
       
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        //var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        if (params != null && params != undefined) {
            if (params.value != null && params.value != undefined && params.value != '-NA-') {
                if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                    return "OOR";
                else {
                    
                    var tempVal = parseFloat(params.value);

                    if (tempUnitCd.toUpperCase() == "F") {
                        tempVal = ((tempVal * 9) / 5) + 32;

                        var param = parseFloat(tempVal.toString());
                        return parseFloat(param.toFixed(parseInt(tempRoundingValue)));
                    }
                    else
                        return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue)));
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },

    TemperatureSensorValueFormatter: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        //var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        if (params != null && params != undefined) {
            if (params.value != null && params.value != undefined && params.value != '-NA-') {
                if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                {
                    if (params.colDef.headerClass != null && params.colDef.headerClass != undefined)
                        return params.colDef.headerClass;
                    else
                        return "OOR";
                }
                else {
                    var tempVal = parseFloat(params.value);

                    if (tempUnitCd.toUpperCase() == "F") {
                        tempVal = ((tempVal * 9) / 5) + 32;

                        var param = parseFloat(tempVal.toString());
                        return parseFloat(param.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString();//26528
                    }
                    else
                        return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString();//26528
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },

    TemperatureSensorFormatterForExcel: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        //var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        if (params != null && params != undefined) {
            if (params.value != null && params.value != undefined && params.value != '-NA-') {
                if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                {
                    if (params.column.colDef.headerClass != null && params.column.colDef.headerClass != undefined)
                        return params.column.colDef.headerClass;
                    else
                        return "OOR";
                }
                else {
                    var tempVal = parseFloat(params.value);

                    if (tempUnitCd.toUpperCase() == "F") {
                        tempVal = ((tempVal * 9) / 5) + 32;

                        var param = parseFloat(tempVal.toString());
                        return parseFloat(param.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString();//26528
                    }
                    else
                        return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString();//26528
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },

    TemperatureSensorGroupingForExcel: (params) => {
        var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
        //var dd = JSON.parse(sessionStorage.getItem('UserInfo'));
        var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
        if (params != null && params != undefined) {
            if (params.value != null && params.value != undefined && params.value != '-NA-') {
                if (params.value.toString().trim() == "-999") //SensorOORIdentifier to be defined from RefApplicationParams
                {
                    if (params.column.colDef.headerClass != null && params.column.colDef.headerClass != undefined)
                        return params.column.colDef.headerClass;
                    else
                        return "OOR";
                }
                else {
                    var tempVal = parseFloat(params.value);

                    if (tempUnitCd.toUpperCase() == "F") {
                        tempVal = ((tempVal * 9) / 5) + 32;

                        var param = parseFloat(tempVal.toString());
                        return parseFloat(param.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString();//26528
                    }
                    else
                        return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString();//26528
                }
            }
            else
                return '-NA-';
        }
        else
            return '-NA-';

    },   
    //WI26638 GT 1030 for Chassis, Dry and Genset asset types
    SensorGrouping: (fieldName, value, sensorData, params) => {
        if (sensorData != undefined && sensorData != null && sensorData.length > 0 && fieldName != null && fieldName != undefined && value != null && value != undefined && params != null && params != undefined) {
            var tempRoundingValue = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureRoundPrecision;
            var tempUnitCd = JSON.parse(sessionStorage.getItem('UserInfo')).TemperatureUnitCd.trim();
            var name = fieldName.split("_");
            var field = name[0];
            var deviceType = name[1];

            var sensorcolumn = sensorData.filter(x => x.FieldName == field && x.DeviceTypeCd.trim() == deviceType.trim());
            if (sensorcolumn[0] != undefined && sensorcolumn[0] != null) {
                if (sensorcolumn[0].SensorTypeCd.trim() == "T") {
                    if (value.toString().trim() == "-999") {
                        if (params.headerClass != undefined && params.headerClass != null)
                            return params.headerClass;
                        else
                            return "OOR";
                    }
                    else {
                        var tempVal = parseFloat(value);

                        if (tempUnitCd.toUpperCase() == "F") {
                            tempVal = ((tempVal * 9) / 5) + 32;

                            var param = parseFloat(tempVal.toString());
                            return parseFloat(param.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString();//26528
                        }
                        else
                            return parseFloat(tempVal.toFixed(parseInt(tempRoundingValue))).toFixed(1).toString();//26528
                    }
                }
                else {
                    if (value.toString().trim() == "-999") {
                        if (params.headerClass != undefined && params.headerClass != null)//RCNG-232
                            return params.headerClass;//RCNG-232
                        else
                            return "OOR";
                    }
                    else {                        
                        if (!isNaN(value)) {//RCNG-230
                            var tempRoundingValueDigital = "1";
                            return (value != null) ? parseFloat(parseInt(value).toFixed(parseInt(tempRoundingValueDigital))).toFixed(1).toString() : "-NA-";
                        }
                        else
                            return (value != null) ? value : "-NA-";//RCNG-230
                    }
                }
            }
            else
                return "-NA-";
        }
        else
            return "-NA-";
    },

    HumiditySetpointGrouping: (params, humiditySetpointStatus) => {
        if(humiditySetpointStatus != null && humiditySetpointStatus != '') {
            if(humiditySetpointStatus.toUpperCase().trim() == "OFF" || humiditySetpointStatus == "O")//RCNG-4689
                return "Off";
        } 
        if (params != null && params != undefined && params != '-NA-') {
            if (params.toString().trim() == "0")
                return "Off";
            //else if (params.toString().trim() == "-999")
            //    return "OOR";
            else if (params > 0 && params <= 100)
                return parseFloat(params).toFixed(1).toString();
            else
                return "OOR";
        }
        else
            return '-NA-';
    },  
    HumiditySetpointForExcel: (params, humiditySetpointStatus) => {
        if(humiditySetpointStatus != null && humiditySetpointStatus != '') {
            if(humiditySetpointStatus.toUpperCase().trim() == "OFF" || humiditySetpointStatus == "O")//RCNG-4689
                return "Off";
        }
        if (params != null && params != undefined && params !='-NA-') {
            if (params.toString().trim() == "0")
                return "Off";
            //else if (params.toString().trim() == "-999")
            //    return "OOR";
            else if (params > 0 && params <= 100)
                return parseFloat(params).toFixed(1).toString();
            else
                return "OOR";
        }
        else
            return '-NA-';
    },  
    TripWiseStatusGrouping: (param) => {
        if (param != null && param != undefined && param != "null") {
            switch (param) {
                case 'Off':
                    return '<span title="Off" class="fas fa-square GridIcons greytext"></span>' + " " + "<span class='ptTWpadding'>Off</span>";
                case 'Expired':
                    return '<span title="Expired" class="fas fa-times GridIcons orangetext "></span>' + " " + "<span class='ptTWpadding'>Expired</span>";
                case 'Check':
                    return '<span title="Check" class="fas fa-exclamation GridIcons color-red"></span>' + " " + "<span class='ptTWpadding'>Check</span>";
                case 'Passed':
                    return '<span title="Passed" class="fas fa-check GridIcons green-text-color"></span>' + " " + "<span class='ptTWpadding'>Passed</span>";
                case 'Running':
                    return '<span title="Running" class="fas fa-history GridIcons black-text-color"></span>' + " " + "<span class='ptTWpadding'>Running</span>";
                case 'Unknown':
                    return '<span title="Unknown" class="fas fa-question GridIconsQuestion black-text-color"></span>' + " " + "<span class='ptTWpadding'>Unknown</span>";
            }
        }
    },
    debounce: (func, wait) => {
        let timeout;
        return function () {
            const context = this;
            const args = arguments;
            var later = function () {
                timeout = null;
                func.apply(context, args);
            };

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);

            if (!timeout) {
                func.apply(context, args);
            }
        };
    },
    EverFreshFormatterGrouping: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return "On";
            else if (param == 2)
                return "Off";
            else if (param == 3)
                return "*No EverFRESH"
        }
    },
    EverFreshFormatterExcel: (param) => {
        if (param != null && param != undefined) {
            if (param == 1)
                return "On";
            else if (param == 2)
                return "Off";
            else 
                return "-NA-"
        }
    },
    //RCNG-2227,2228
    DoorBattPctFormatterforExcel: (params) => {        
        if (params != null && params != undefined && params >= 0 && params != "-NA-") {
            var battPct = parseFloat(params).toFixed(1).toString();
            return battPct;
        }
        else
            return '-NA-';
    },

    ReeferBattPctFormatterforExcel: (params, deviceType) => {
        if (deviceType != null && deviceType != undefined) {
            if (deviceType.trim() == 'CT3600' && params != null && params != undefined && params >= 0 && params != "-NA-") {
                var battPct = parseFloat(params).toFixed(1).toString();
                return battPct;
            }
            else
                return '-NA-';
        }
        return '-NA-';
    },
    DoorBattPctHeaderFormatter: (params) =>
    {
        //var a = params;
        
        if (params != null && params != "") 
                return params + " (%)";
            else
                return params;
    },
    GPSAcctypeSorting: (params) =>
    {
        //debugger;
        if (params != null && params != undefined && params != '-NA-') {
            if (params.toString().trim() == "-999") {
                return "OOR";
            }
            else {
                return (params != null) ? params.toString() : "-NA-";
            }
        }
        else
            return '-NA-';
    },
    //RCNG-4478
    doorBattPctSorting: (params) => {        
        if (params.data != null && params.data != undefined) {
            if(params.data.AssetType !=null && params.data.AssetType !=undefined && params.data.AssetType !="") {
                if(params.data.AssetType.toUpperCase().trim() == "D") {
                    if (params.data.DoorSensorBatteryVoltage != null && params.data.DoorSensorBatteryVoltage != undefined) {
                        var battPct = (Math.round(params.data.DoorSensorBatteryVoltage / 10.0)) * 10;
                        return battPct.toString();
                    }
                    return "-1";
                }
                else { 
                     if (params != null && params != undefined) {
                    if (params.data != null && params.data != undefined) {
                        var tempRoundingValue = "1";
                        //return (params.data.DoorSensorBatteryVoltage != null) ? parseFloat(params.data.DoorSensorBatteryVoltage.toFixed(parseInt(tempRoundingValue))) : -999;
                        if (params.data.DoorSensorBatteryVoltage != null) {
                            var val = parseFloat(params.data.DoorSensorBatteryVoltage.toFixed(parseInt(tempRoundingValue)));
                            return val.toFixed(parseInt(tempRoundingValue));
                        }
                        return - 999;
                    }
                    else
                        return -999;
                }
                else
                    return -999;
                }
            }
            else
            {
                if (params != null && params != undefined) {
                    if (params.data != null && params.data != undefined) {
                        var tempRoundingValue = "1";
                        //return (params.data.DoorSensorBatteryVoltage != null) ? parseFloat(params.data.DoorSensorBatteryVoltage.toFixed(parseInt(tempRoundingValue))) : -999;
                        if (params.data.DoorSensorBatteryVoltage != null) {
                            var val = parseFloat(params.data.DoorSensorBatteryVoltage.toFixed(parseInt(tempRoundingValue)));
                            return val.toFixed(parseInt(tempRoundingValue));
                        }
                        return - 999;
                    }
                    else
                        return -999;
                }
                else
                    return -999;
            }
        }
        else
            return "-1";
    },
    doorBattPctFormatterFilter: (params) => {        
        var title = "";
        if (params.data != null && params.data != undefined) {
            if(params.data.AssetType !=null && params.data.AssetType !=undefined && params.data.AssetType !="") {
                if(params.data.AssetType.toUpperCase().trim() == "D") {
                    if (params.data.DoorSensorBatteryVoltage != null && params.data.DoorSensorBatteryVoltage != undefined) {
                        var battPct = (Math.round(params.data.DoorSensorBatteryVoltage / 10.0)) * 10;
                        title = battPct.toString();
                    }
                    else
                        title = "-NA-";
                }
                else {
                if (params.data != null && params.data != undefined && params.data != '' && params.data.DoorSensorBatteryVoltage != null && params.data.DoorSensorBatteryVoltage != undefined) {
                    var tempRoundingValue = "1";
                    if (params.data.DoorSensorBatteryVoltage != null) {
                        var val = parseFloat(params.data.DoorSensorBatteryVoltage.toFixed(parseInt(tempRoundingValue)));
                        return val.toFixed(parseInt(tempRoundingValue));
                    }
                    return '-NA-';
                }
                else
                    return '-NA-';
             }
            }
            else {
                if (params.data != null && params.data != undefined && params.data != '' && params.data.DoorSensorBatteryVoltage != null && params.data.DoorSensorBatteryVoltage != undefined) {
                    var tempRoundingValue = "1";
                    if (params.data.DoorSensorBatteryVoltage != null) {
                        var val = parseFloat(params.data.DoorSensorBatteryVoltage.toFixed(parseInt(tempRoundingValue)));
                        return val.toFixed(parseInt(tempRoundingValue));
                    }
                    return '-NA-';
                }
                else
                    return '-NA-';
             }                
        }
        else
            title = "-NA-";

        return title;
    },
    reeferBatteryPctSorting: (params) => {
        if (params.data != null && params.data != undefined) {
            if (params.data.DeviceType != null && params.data.DeviceType != "" && params.data.DeviceType != undefined) {
                if (params.data.DeviceType.trim() == "CT3600" && params.data.ReeferBatteryPct != null && params.data.ReeferBatteryPct != undefined && params.data.ReeferBatteryPct >= 0) {
                    var battPct = (Math.round(params.data.ReeferBatteryPct / 10.0)) * 10;
                    return battPct.toString();
                }
            }
            return "-1";
        }
        return "-1";
    },
    reeferBatteryPctFormatterFilter: (params) => {
        var title = "";
        if (params.data != null && params.data != undefined) {
            if (params.data.DeviceType != null && params.data.DeviceType != "" && params.data.DeviceType != undefined) {
                if (params.data.DeviceType.trim() == "CT3600" && params.data.ReeferBatteryPct != null && params.data.ReeferBatteryPct != undefined) {
                    var battPct = (Math.round(params.data.ReeferBatteryPct / 10.0)) * 10;
                    title = battPct.toString();
                }
                else
                    title = "-NA-";
            }
            else
                title = "-NA-";
        }
        else
            title = "-NA-";

        return title;
    }
}


export default formatters;

